unit View.Main;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.Forms, WEBLib.Controls, WEBLib.ExtCtrls, Vcl.StdCtrls, WEBLib.StdCtrls,
  App.Types,
  ConnectionModule, WEBLib.Lists,
  View.Crud.Container,
  XData.Web.Client, Data.DB, XData.Web.JsonDataset, XData.Web.Dataset, Js,
  WEBLib.DB, WEBLib.DBCtrls, System.Generics.Collections, WEBLib.WebCtrls,
  View.Lancamentos.List, View.Lancamentos.Edit, View.Tipos.List,
  View.Tipos.Edit, View.Banco_Carteiras.List, View.Banco_Carteiras.Edit,
  View.Boletos.Edit, View.Boletos.List, View.Facil_Planos.List,
  View.Facil_Planos.Edit, View.Facil_Planos_Aliados.List,
  View.Facil_Planos_Aliados.Edit, UHelperServer, View.Erros_Catalogados.List,
  View.Erros_Catalogados.Edit, View.Operadoras_Cartao.List,
  View.Operadoras_Cartao.Edit, View.Scripts.List, View.Scripts.Edit,
  View.Scripts_Aliados.List, View.Scripts_Aliados.Edit, View.Versoes.Edit,
  View.Versoes.List, View.Provedores.List, View.Provedores.Edit,
  View.Logs_Sistema.List, View.Logs_Sistema.Edit, View.Cfop_Configuracoes.List,
  View.Cfop_Configuracoes.Edit, View.Ncm.Edit, View.Ncm.List,
  View.Rt_Ibs_Cbs_Cst.Edit, View.Rt_Ibs_Cbs_Cst.List, View.Rt_Is_Cst.Edit,
  View.Rt_Is_Cst.List, View.Api_Veiculos.List, View.Promocoes.Edit,
  View.Promocoes.List, View.Produtos_Associacao.List, UDadosUsuarioVO,
  UWeb.Enum, UUtils, View.Fs_Prod_Categorias.List,
  View.Fs_Prod_Categorias.Edit, View.Fs_Prod_SubCategorias.List,
  View.Fs_Prod_SubCategorias.Edit, View.Fs_Prod_Departamentos.List,
  View.Fs_Prod_Departamentos.Edit, View.Fs_Prod_SubDepartamentos.List,
  View.Fs_Prod_SubDepartamentos.Edit, View.Fs_Prod_Fabricantes.List,
  View.Fs_Prod_Fabricantes.Edit, View.Fs_Prod_Marcas.List,
  View.Fs_Prod_Marcas.Edit, View.Fs_Prod_Produtos.List,
  View.Fs_Prod_Produtos.Edit, View.Fs_Prod_Caracteristicas.List,
  View.Fs_Prod_Caracteristicas.Edit, View.Servicos_Nacional.List,
  View.Servicos_Nacional.Edit, View.Nbs.List, View.Nbs.Edit,
  View.Rt_Credito_Presumido.Edit, View.Rt_Credito_Presumido.List,
  View.Api_Cpfs.List, View.Modulos_Acesso.List, View.Servicos.List,
  View.Servicos.Edit, View.Vendas_Servicos.List, View.Vendas_Servicos.Edit,
  View.Nfse.Edit, View.Nfse.List, View.Data_Base_Logs.List,
  View.Data_Base_Logs.Edit, View.Sincronizacao_Servidor_Retaguarda.List,
  View.Sincronizacao_Servidor_Retaguarda.Edit;

type
  TFViewMain = class(TForm)
    WebPanel1: TPanel;
    WebLinkLabel6: TLinkLabel;
    lbUsername: TLabel;
    lblLogo: TLinkLabel;
    lblEmpresalogin: TLinkLabel;
    cdsDataBase: TXDataWebDataSet;
    cdsDataBaseid: TIntegerField;
    cdsDataBasenome_fantasia: TStringField;
    dwcGetUsuario: TXDataWebClient;
    cdsUsuarios: TXDataWebDataSet;
    cdsUsuariosid: TIntegerField;
    cdsUsuariosdata_base_id: TIntegerField;
    div_bancos_usuario: THTMLDiv;
    cbbDataBase: TComboBox;
    div_empresa_login: THTMLDiv;
    dwcGetDadosEmpresaLogado: TXDataWebClient;
    cdsUsuariosaliado_id: TIntegerField;
    div_aliado_login: THTMLDiv;
    aliado_logado: TLabel;
    aliado_conectado_topo: THTMLDiv;
    nome_aliado_conectado_topo: TLabel;
    btnDesconectar: TButton;
    cdsUsuariosperfil: TIntegerField;
    cdsUsuariosnome: TStringField;
    menu_nfse: THTMLDiv;
    cdsLogsSistema: TXDataWebDataSet;
    cdsLogsSistemaaliado_id: TIntegerField;
    cdsLogsSistematabela: TStringField;
    cdsLogsSistemaoperacao: TStringField;
    cdsLogsSistemalog: TStringField;
    lbMeuperfil: TLabel;
    cdsDataBaseassociar_produtos: TBooleanField;
    cdsUsuariosperfil_acesso: TStringField;
    home: THTMLDiv;
    lbViewHome: TLinkLabel;
    aliado: THTMLDiv;
    lbViewAliado: TLinkLabel;
    logs_sistema: THTMLDiv;
    lbViewLogs_Sistema: TLinkLabel;
    provedores: THTMLDiv;
    consulta_nfse: THTMLDiv;
    lbViewProvedores: TLinkLabel;
    lbViewConsultaNfse: TLinkLabel;
    menu_scripts: THTMLDiv;
    scripts: THTMLDiv;
    scripts_aliados: THTMLDiv;
    lbViewScripts: TLinkLabel;
    lbViewScripts_Aliados: TLinkLabel;
    versoes: THTMLDiv;
    lbViewVersoes: TLinkLabel;
    menu_apis_externas: THTMLDiv;
    api_veiculos: THTMLDiv;
    lbViewApi_Veiculos: TLinkLabel;
    menu_fs_produtos: THTMLDiv;
    fs_prod_produtos: THTMLDiv;
    fs_prod_marcas: THTMLDiv;
    fs_prod_fabricantes: THTMLDiv;
    lbViewFs_Prod_Produtos: TLinkLabel;
    lbViewFs_Prod_Marcas: TLinkLabel;
    lbViewFs_Prod_Fabricantes: TLinkLabel;
    fs_prod_categorias: THTMLDiv;
    fs_prod_subcategorias: THTMLDiv;
    fs_prod_departamentos: THTMLDiv;
    lbViewFs_Prod_Categorias: TLinkLabel;
    lbViewFs_Prod_SubCategorias: TLinkLabel;
    lbViewFs_Prod_Departamentos: TLinkLabel;
    fs_prod_subdepartamentos: THTMLDiv;
    fs_prod_caracteristicas: THTMLDiv;
    lbViewFs_Prod_SubDepartamentos: TLinkLabel;
    lbViewFs_Prod_Caracteristicas: TLinkLabel;
    menu_facil_planos: THTMLDiv;
    facil_planos: THTMLDiv;
    facil_planos_aliados: THTMLDiv;
    lbViewFacil_Planos: TLinkLabel;
    lbViewPlanos_Aliados: TLinkLabel;
    boletos: THTMLDiv;
    lancamentos: THTMLDiv;
    lbViewBoletos: TLinkLabel;
    lbViewLancamentos: TLinkLabel;
    menu_recebimentos: THTMLDiv;
    areceber: THTMLDiv;
    recebimentos: THTMLDiv;
    lbViewAreceber: TLinkLabel;
    lbViewRecebimentos: TLinkLabel;
    menu_pagamentos: THTMLDiv;
    apagar: THTMLDiv;
    pagamentos: THTMLDiv;
    lbViewApagar: TLinkLabel;
    lbViewPagamentos: TLinkLabel;
    menu_localidades: THTMLDiv;
    cidade: THTMLDiv;
    ufs: THTMLDiv;
    lbViewCidade: TLinkLabel;
    lbViewUF: TLinkLabel;
    menu_sincronizacao: THTMLDiv;
    sincronizacao_service: THTMLDiv;
    erros_catalogados: THTMLDiv;
    lbViewSincronizacao_Service: TLinkLabel;
    lbViewErros_Catalogados: TLinkLabel;
    menu_tributacoes: THTMLDiv;
    ncm: THTMLDiv;
    cfop: THTMLDiv;
    menu_reforma_tributaria: THTMLDiv;
    rt_ibs_cbs_cst: THTMLDiv;
    lbViewRt_Ibs_Cbs_Cst: TLinkLabel;
    rt_is_cst: THTMLDiv;
    lbViewRt_Is_Cst: TLinkLabel;
    lbViewNcm: TLinkLabel;
    lbViewCfop: TLinkLabel;
    cfop_configuracoes: THTMLDiv;
    cst: THTMLDiv;
    lbViewCfop_Configuracoes: TLinkLabel;
    lbViewCst: TLinkLabel;
    cst_pis: THTMLDiv;
    cst_cofins: THTMLDiv;
    lbViewCst_Pis: TLinkLabel;
    lbViewCst_Cofins: TLinkLabel;
    cst_ipi: THTMLDiv;
    codigo_bc_piscofins: THTMLDiv;
    lbViewCst_Ipi: TLinkLabel;
    lbViewCodigo_bc_Piscofins: TLinkLabel;
    origem_csosn: THTMLDiv;
    codigo_credito_piscofins: THTMLDiv;
    lbViewOrigem_Csosn: TLinkLabel;
    lbViewCodigo_Credito_Piscofins: TLinkLabel;
    desoneracao_icms: THTMLDiv;
    csosn: THTMLDiv;
    lbViewDesoneracao_Icms: TLinkLabel;
    lbViewCsosn: TLinkLabel;
    menu_cadastros: THTMLDiv;
    promocoes: THTMLDiv;
    funcionarios: THTMLDiv;
    clientes: THTMLDiv;
    modalidades: THTMLDiv;
    lbViewPromocoes: TLinkLabel;
    lbViewClientes: TLinkLabel;
    lbViewFuncionarios: TLinkLabel;
    lbViewModalidades: TLinkLabel;
    aliquotas: THTMLDiv;
    parceiros: THTMLDiv;
    contas: THTMLDiv;
    bancos: THTMLDiv;
    banco_carteiras: THTMLDiv;
    lbViewAliquotas: TLinkLabel;
    lbViewParceiros: TLinkLabel;
    lbViewContas: TLinkLabel;
    lbViewBancos: TLinkLabel;
    lbViewBanco_Carteiras: TLinkLabel;
    operadoras_cartao: THTMLDiv;
    contadores: THTMLDiv;
    fornecedores: THTMLDiv;
    tipos: THTMLDiv;
    modulos: THTMLDiv;
    lbViewOperadoras_Cartao: TLinkLabel;
    lbViewContadores: TLinkLabel;
    lbViewFornecedores: TLinkLabel;
    lbViewTipos: TLinkLabel;
    lbViewModulos: TLinkLabel;
    pdvs: THTMLDiv;
    segmentos: THTMLDiv;
    lbViewSegmento: TLinkLabel;
    lbViewPdvs: TLinkLabel;
    menu_plano_contas: THTMLDiv;
    plano_contas: THTMLDiv;
    lbViewPlano_Contas: TLinkLabel;
    plano_contas_contabil: THTMLDiv;
    lbViewPlano_Contas_Contabil: TLinkLabel;
    plano_contas2: THTMLDiv;
    lbViewPlano_Contas2: TLinkLabel;
    plano_contas1: THTMLDiv;
    lbViewPlano_Contas1: TLinkLabel;
    plano_contas3: THTMLDiv;
    lbViewPlano_Contas3: TLinkLabel;
    XDataWebClientPermissoes: TXDataWebClient;
    tmrIniciarSistema: TTimer;
    cdsPersonalizacaoTabelas: TXDataWebDataSet;
    cdsPersonalizacaoTabelasid: TIntegerField;
    cdsPersonalizacaoTabelasusuario_id: TIntegerField;
    cdsPersonalizacaoTabelastabela_frontend: TStringField;
    cdsPersonalizacaoTabelaspersonalizacao: TStringField;
    servicos_nacional: THTMLDiv;
    lbViewServicos_Nacional: TLinkLabel;
    nbs: THTMLDiv;
    lbViewNbs: TLinkLabel;
    rt_credito_presumido: THTMLDiv;
    lbViewRt_Credito_Presumido: TLinkLabel;
    api_cpfs: THTMLDiv;
    lbViewApi_Cpfs: TLinkLabel;
    menu_vendas: THTMLDiv;
    vendas: THTMLDiv;
    lbViewVendas: TLinkLabel;
    servicos: THTMLDiv;
    lbViewServicos: TLinkLabel;
    vendas_servicos: THTMLDiv;
    lbViewVendasServicos: TLinkLabel;
    menu_documentos_fiscais: THTMLDiv;
    nfe: THTMLDiv;
    lbViewNfe: TLinkLabel;
    nfse: THTMLDiv;
    lbViewNfse: TLinkLabel;
    painel_aliados: THTMLDiv;
    lbViewPainelAliados: TLinkLabel;
    relatorios: THTMLDiv;
    lbViewRelatorios: TLinkLabel;
    compras: THTMLDiv;
    lbViewCompras: TLinkLabel;
    cupons: THTMLDiv;
    lbViewCupons: TLinkLabel;
    sincronizacao_servidor_retaguarda: THTMLDiv;
    lbViewSincronizacao_Servidor_Retaguarda: TLinkLabel;
    usuarios: THTMLDiv;
    lbViewUsuarios: TLinkLabel;
    menu_produtos: THTMLDiv;
    produtos: THTMLDiv;
    lbViewProdutos: TLinkLabel;
    grupos: THTMLDiv;
    lbViewGrupos: TLinkLabel;
    unidades: THTMLDiv;
    lbViewUnidades: TLinkLabel;
    subgrupos: THTMLDiv;
    lbViewSubgrupos: TLinkLabel;
    menu_grades: THTMLDiv;
    grade_produtos: THTMLDiv;
    lbViewGrade_Produtos: TLinkLabel;
    grade_descricoes: THTMLDiv;
    lbViewGrade_Descricoes: TLinkLabel;
    grade_colunas: THTMLDiv;
    lbViewGrade_Colunas: TLinkLabel;
    grade_linhas: THTMLDiv;
    lbViewGrade_Linhas: TLinkLabel;
    procedure WebFormCreate(Sender: TObject);
    procedure lbViewStatus_TitulosClick(Sender: TObject);
    procedure WebLinkLabel6Click(Sender: TObject);
    procedure cdsDataBaseAfterOpen(DataSet: TDataSet);
    procedure WebFormClose(Sender: TObject; var Action: TCloseAction);
    procedure dwcGetUsuarioLoad(Response: TXDataClientResponse);
    procedure cdsUsuariosAfterOpen(DataSet: TDataSet);
    [Async]
    procedure cbbDataBaseChange(Sender: TObject); async;
    procedure dwcGetDadosEmpresaLogadoLoad(Response: TXDataClientResponse);
    [Async]
    procedure btnDesconectarClick(Sender: TObject); async;
    procedure cdsUsuariosAfterApplyUpdates(Sender: TDataSet;
      Info: TResolveResults);
    procedure WebFormShow(Sender: TObject);
    procedure lbMeuperfilClick(Sender: TObject);
    procedure homeClick(Sender: TObject);
    procedure aliadoClick(Sender: TObject);
    procedure logs_sistemaClick(Sender: TObject);
    procedure provedoresClick(Sender: TObject);
    procedure consulta_nfseClick(Sender: TObject);
    procedure scriptsClick(Sender: TObject);
    procedure scripts_aliadosClick(Sender: TObject);
    procedure versoesClick(Sender: TObject);
    procedure api_veiculosClick(Sender: TObject);
    procedure fs_prod_produtosClick(Sender: TObject);
    procedure fs_prod_marcasClick(Sender: TObject);
    procedure fs_prod_fabricantesClick(Sender: TObject);
    procedure fs_prod_categoriasClick(Sender: TObject);
    procedure fs_prod_subcategoriasClick(Sender: TObject);
    procedure fs_prod_departamentosClick(Sender: TObject);
    procedure fs_prod_subdepartamentosClick(Sender: TObject);
    procedure fs_prod_caracteristicasClick(Sender: TObject);
    procedure vendasClick(Sender: TObject);
    procedure nfeClick(Sender: TObject);
    procedure nfe_loteClick(Sender: TObject);
    procedure cuponsClick(Sender: TObject);
    procedure itens_cuponsClick(Sender: TObject);
    procedure nfceClick(Sender: TObject);
    procedure comprasClick(Sender: TObject);
    procedure itens_entradaClick(Sender: TObject);
    procedure facil_planosClick(Sender: TObject);
    procedure facil_planos_aliadosClick(Sender: TObject);
    procedure boletosClick(Sender: TObject);
    procedure lancamentosClick(Sender: TObject);
    procedure areceberClick(Sender: TObject);
    procedure recebimentosClick(Sender: TObject);
    procedure apagarClick(Sender: TObject);
    procedure pagamentosClick(Sender: TObject);
    procedure cidadeClick(Sender: TObject);
    procedure ufsClick(Sender: TObject);
    procedure sincronizacao_serviceClick(Sender: TObject);
    procedure erros_catalogadosClick(Sender: TObject);
    procedure rt_ibs_cbs_cstClick(Sender: TObject);
    procedure rt_is_cstClick(Sender: TObject);
    procedure ncmClick(Sender: TObject);
    procedure cfopClick(Sender: TObject);
    procedure cfop_configuracoesClick(Sender: TObject);
    procedure cstClick(Sender: TObject);
    procedure cst_pisClick(Sender: TObject);
    procedure cst_cofinsClick(Sender: TObject);
    procedure cst_ipiClick(Sender: TObject);
    procedure codigo_bc_piscofinsClick(Sender: TObject);
    procedure origem_csosnClick(Sender: TObject);
    procedure codigo_credito_piscofinsClick(Sender: TObject);
    procedure desoneracao_icmsClick(Sender: TObject);
    procedure csosnClick(Sender: TObject);
    procedure plano_contasClick(Sender: TObject);
    procedure plano_contas_contabilClick(Sender: TObject);
    procedure plano_contas1Click(Sender: TObject);
    procedure plano_contas2Click(Sender: TObject);
    procedure plano_contas3Click(Sender: TObject);
    procedure grade_produtosClick(Sender: TObject);
    procedure grade_descricoesClick(Sender: TObject);
    procedure grade_linhasClick(Sender: TObject);
    procedure grade_colunasClick(Sender: TObject);
    procedure produtos_associacaoClick(Sender: TObject);
    procedure produtosClick(Sender: TObject);
    procedure unidadesClick(Sender: TObject);
    procedure gruposClick(Sender: TObject);
    procedure subgruposClick(Sender: TObject);
    procedure promocoesClick(Sender: TObject);
    procedure clientesClick(Sender: TObject);
    procedure funcionariosClick(Sender: TObject);
    procedure modalidadesClick(Sender: TObject);
    procedure usuariosClick(Sender: TObject);
    procedure aliquotasClick(Sender: TObject);
    procedure parceirosClick(Sender: TObject);
    procedure contasClick(Sender: TObject);
    procedure bancosClick(Sender: TObject);
    procedure banco_carteirasClick(Sender: TObject);
    procedure operadoras_cartaoClick(Sender: TObject);
    procedure contadoresClick(Sender: TObject);
    procedure fornecedoresClick(Sender: TObject);
    procedure tiposClick(Sender: TObject);
    procedure modulosClick(Sender: TObject);
    procedure segmentosClick(Sender: TObject);
    procedure pdvsClick(Sender: TObject);
    procedure tmrIniciarSistemaTimer(Sender: TObject);
    procedure cdsPersonalizacaoTabelasAfterApplyUpdates(Sender: TDataSet;
      Info: TResolveResults);
    procedure cdsPersonalizacaoTabelasAfterOpen(DataSet: TDataSet);
    procedure servicos_nacionalClick(Sender: TObject);
    procedure nbsClick(Sender: TObject);
    procedure rt_credito_presumidoClick(Sender: TObject);
    procedure api_cpfsClick(Sender: TObject);
    procedure modulos_acessoClick(Sender: TObject);
    procedure servicosClick(Sender: TObject);
    procedure vendas_servicosClick(Sender: TObject);
    procedure nfseClick(Sender: TObject);
    procedure data_base_logsClick(Sender: TObject);
    procedure painel_aliadosClick(Sender: TObject);
    procedure relatoriosClick(Sender: TObject);
    procedure sincronizacao_servidor_retaguardaClick(Sender: TObject);
  private
    FChildForm: TForm;
    FLogoutProc: TLogoutProc;
    FIndice : Integer;
    FDicionarioBancos : TDictionary<Integer, Integer>;
    FRouteRestoring: Boolean;
    FPendingRoute: string;
    FPendingEditId: JSValue;
    FCurrentRouteQueryString: string;
    FRouteNavigationPending: Boolean;
    function RouteFromFormClass(AFormClass: TFormClass): string;
    function HashRoute: string;
    function HashEditId: JSValue;
    function HashRouteQueryString: string;
    function EncodeHashValue(AValue: string): string;
    function BuildRouteQueryString: string;
    procedure ApplyHashFilters;
    procedure NavigateCurrentHash;
    procedure SetRouteHash(ARoute: string; AEditId: JSValue = nil);
    procedure ShowForm(AFormClass: TFormClass);
    procedure ShowCrudContainer(ACrudFormClass: TFormClass; ATitle: string;
      AShowCrudListProc: TShowCrudListProc; AShowCrudEditProc: TShowCrudEditProc);
    procedure SelecionarNoCombo(pId : Integer);
    function GetKeyByValue(lIndice : Integer): Integer;
    procedure ConfigurarUsuarioComum;
    [async]
    procedure SetPermissoes; async;
  public
    class procedure Display(AElementId: string; LogoutProc: TLogoutProc);
    procedure HandleHashChanged;
    procedure GerarLog(pAliadoId : Integer; pTabela, pOperacao, pLog : string);
  protected procedure LoadDFMValues; override; end;

var
  FViewMain: TFViewMain;

implementation

uses
  Web,
  Auth.Service,
  View.Login,
  View.UserProfile,  
  View.Itens_Cupons.List,
  View.Itens_Cupons.Edit,
  View.Itens_Saida.List,
  View.Itens_Saida.Edit,
  View.Cst_Ipi.List,
  View.Cst_Ipi.Edit,
  View.Cfop.List,
  View.Cfop.Edit,
  View.Codigo_bc_Piscofins.List,
  View.Codigo_bc_Piscofins.Edit,
  View.Contadores.List,
  View.Contadores.Edit,
  View.Cst.List,
  View.Cst.Edit,
  View.Recebimentos.List,
  View.Recebimentos.Edit,
  View.Cst_Pis.List,
  View.Cst_Pis.Edit,
  View.Plano_Contas.List,
  View.Plano_Contas.Edit,
  View.Modalidades.List,
  View.Modalidades.Edit,
  View.Modulos_Data_Base.List,
  View.Modulos_Data_Base.Edit,
  View.Apagar.List,
  View.Apagar.Edit,
  View.Sincronizacao_Service.List,
  View.Sincronizacao_Service.Edit,
  View.Origem_Csosn.List,
  View.Origem_Csosn.Edit,
  View.Aliado.List,
  View.Aliado.Edit,
  View.Itens_Entrada.List,
  View.Itens_Entrada.Edit,
  View.UF.List,
  View.UF.Edit,
  View.Cidade.List,
  View.Cidade.Edit,
  View.Parceiros.List,
  View.Parceiros.Edit,
  View.Unidades.List,
  View.Unidades.Edit,
  View.Pagamentos.List,
  View.Pagamentos.Edit,
  View.Grupos.List,
  View.Grupos.Edit,
  View.Plano_Contas3.List,
  View.Plano_Contas3.Edit,
  View.Plano_Contas_Contabil.List,
  View.Plano_Contas_Contabil.Edit,
  View.Modulos.List,
  View.Modulos.Edit,
  View.Certificados.List,
  View.Certificados.Edit,
  View.Segmento.List,
  View.Segmento.Edit,
  View.Grade_Produtos.List,
  View.Grade_Produtos.Edit,
  View.Pdvs.List,
  View.Pdvs.Edit,
  View.Vendas.List,
  View.Vendas.Edit,
  View.Areceber.List,
  View.Areceber.Edit,
  View.Clientes.List,
  View.Clientes.Edit,
  View.Compras.List,
  View.Compras.Edit,
  View.Plano_Contas2.List,
  View.Plano_Contas2.Edit,
  View.data_base.List,
  View.data_base.Edit,
  View.Funcionarios.List,
  View.Funcionarios.Edit,
  View.Nfce.List,
  View.Nfce.Edit,
  View.Grade_Descricoes.List,
  View.Grade_Descricoes.Edit,
  View.Plano_Contas1.List,
  View.Plano_Contas1.Edit,
  View.Produtos.List,
  View.Produtos.Edit,
  View.Sincronizacao_Logs.List,
  View.Sincronizacao_Logs.Edit,
  View.Csosn.List,
  View.Csosn.Edit,
  View.Usuarios.List,
  View.Usuarios.Edit,
  View.Grade_Colunas.List,
  View.Grade_Colunas.Edit,
  View.Grade_Linhas.List,
  View.Grade_Linhas.Edit,
  View.Aliquotas.List,
  View.Aliquotas.Edit,
  View.Cst_Cofins.List,
  View.Cst_Cofins.Edit,
  View.Status_Titulos.List,
  View.Status_Titulos.Edit,
  View.Bancos.List,
  View.Bancos.Edit,
  View.Subgrupos.List,
  View.Subgrupos.Edit,
  View.Nfe.List,
  View.Nfe.Edit,
  View.Fornecedores.List,
  View.Fornecedores.Edit,
  View.Sincronizacao_Aliados.List,
  View.Sincronizacao_Aliados.Edit,
  View.Contas.List,
  View.Contas.Edit,
  View.Desoneracao_Icms.List,
  View.Desoneracao_Icms.Edit,
  View.Codigo_Credito_Piscofins.List,
  View.Codigo_Credito_Piscofins.Edit,
  View.Cupons.List,
  View.Cupons.Edit,
  View.Nfe_Lote.List,
  View.Nfe_Lote.Edit,
  View.Home;

{$R *.dfm}


procedure TFViewMain.ApplyHashFilters;
begin
  // Sincroniza os filtros antigos baseados em class var com a query string da rota.
  // Ex.: #/aliado?query=status%20eq%201 ou #/produtos?queryProdutos=produto_id%20eq%201.
  asm
    var h = window.location.hash || '';
    var q = h.indexOf('?');
    var params = q >= 0 ? new URLSearchParams(h.substring(q + 1)) : new URLSearchParams();
    pas.UHelperServer.THelperServer.FQuery = params.get('query') || params.get('filter') || '';
    pas.UHelperServer.THelperServer.FQueryProdutos = params.get('queryProdutos') || '';
    pas.UHelperServer.THelperServer.FFilterParametro = params.get('filterParametro') || '';
  end;
end;

function TFViewMain.BuildRouteQueryString: string;

  procedure AddParam(AName, AValue: string);
  begin
    if AValue = '' then
      Exit;

    if Result <> '' then
      Result := Result + '&';

    Result := Result + AName + '=' + EncodeHashValue(AValue);
  end;

begin
  Result := '';

  AddParam('query', THelperServer.FQuery);
  AddParam('queryProdutos', THelperServer.FQueryProdutos);
  AddParam('filterParametro', THelperServer.FFilterParametro);
end;

function TFViewMain.EncodeHashValue(AValue: string): string;
begin
  asm
    Result = encodeURIComponent(AValue || '');
  end;
end;

procedure TFViewMain.HandleHashChanged;
var
  lInternal: Boolean;
begin
  asm
    lInternal = !!window.__facilRouterInternalHash;
    window.__facilRouterInternalHash = false;
  end;

  if lInternal then
    Exit;

  // Os menus usam <a href="#">. Depois do OnClick abrir a tela correta,
  // o link pode disparar um hashchange para "#"; ignoramos esse ruído para
  // não voltar para a Home imediatamente.
  if (HashRoute = '') and Assigned(FChildForm) then
    Exit;

  NavigateCurrentHash;
end;

function TFViewMain.HashEditId: JSValue;
begin
  Result := nil;
  asm
    var h = window.location.hash || '';
    if (h.charAt(0) === '#') h = h.substring(1);
    if (h.charAt(0) === '/') h = h.substring(1);
    var q = h.indexOf('?');
    if (q >= 0) h = h.substring(0, q);
    var parts = h.split('/');
    if (parts.length >= 3 && (String(parts[1]).toLowerCase() === 'editar')) {
      var id = decodeURIComponent(parts[2]);
      Result = /^-?\d+$/.test(id) ? parseInt(id, 10) : id;
    }
  end;
end;

function TFViewMain.HashRoute: string;
begin
  asm
    var h = window.location.hash || '';
    if (h.charAt(0) === '#') h = h.substring(1);
    if (h.charAt(0) === '/') h = h.substring(1);
    var q = h.indexOf('?');
    if (q >= 0) h = h.substring(0, q);
    var route = h.split('/')[0] || '';
    Result = decodeURIComponent(route).toLowerCase().replace(/-/g, '_');
  end;
end;

function TFViewMain.HashRouteQueryString: string;
begin
  asm
    var h = window.location.hash || '';
    var q = h.indexOf('?');
    Result = q >= 0 ? h.substring(q + 1) : '';
  end;
end;

procedure TFViewMain.NavigateCurrentHash;
var
  lRoute: string;
  lComponent: TComponent;
  lHandled: Boolean;
begin
  lRoute := HashRoute;
  FCurrentRouteQueryString := HashRouteQueryString;

  if lRoute = '' then
    lRoute := 'home';

  ApplyHashFilters;
  FPendingRoute := lRoute;
  FPendingEditId := HashEditId;
  FRouteRestoring := True;
  try
    if lRoute = 'home' then
      ShowForm(TFViewHome)
    else
    begin
      lHandled := False;
      lComponent := FindComponent(lRoute);

      if Assigned(lComponent) and (lComponent is THTMLDiv) and
        Assigned(THTMLDiv(lComponent).OnClick) then
      begin
        THTMLDiv(lComponent).OnClick(nil);
        lHandled := True;
      end;

      if not lHandled then
      begin
        asm
          var el = document.getElementById(lRoute);
          lHandled = !!el;
          if (el) {
            el.click();
          }
        end;
      end;

      if not lHandled then
        ShowForm(TFViewHome);
    end;
  finally
    FRouteRestoring := False;
    FPendingRoute := '';
    FPendingEditId := nil;
  end;
end;

function TFViewMain.RouteFromFormClass(AFormClass: TFormClass): string;
var
  lName: string;
begin
  lName := AFormClass.ClassName;

  if Copy(lName, 1, 6) = 'TFView' then
    Delete(lName, 1, 6);

  if Copy(lName, Length(lName) - 3, 4) = 'List' then
    Delete(lName, Length(lName) - 3, 4)
  else if Copy(lName, Length(lName) - 3, 4) = 'Edit' then
    Delete(lName, Length(lName) - 3, 4);

  Result := LowerCase(lName);
end;

procedure TFViewMain.SetRouteHash(ARoute: string; AEditId: JSValue);
var
  lHash: string;
  lId: string;
  lQueryString: string;
begin
  if FRouteRestoring or (ARoute = '') then
    Exit;

  lQueryString := BuildRouteQueryString;
  lHash := '#/' + ARoute;

  if not IsNull(AEditId) then
  begin
    asm
      lId = encodeURIComponent(String(AEditId));
    end;
    lHash := lHash + '/editar/' + lId;
  end;

  if lQueryString <> '' then
    lHash := lHash + '?' + lQueryString;

  if window.location.hash <> lHash then
  begin
    asm
      window.__facilRouterInternalHash = true;
    end;
    window.location.hash := lHash;
  end;
end;

procedure TFViewMain.WebFormClose(Sender: TObject; var Action: TCloseAction);
begin
  if Assigned(FDicionarioBancos) then
    FreeAndNil(FDicionarioBancos);
end;

procedure TFViewMain.WebFormCreate(Sender: TObject);
begin
  TUtils.OcultarElemento('frmPrincipal');
  TUtils.ChamarDivLoading;
  cdsPersonalizacaoTabelas.AfterOpen := cdsPersonalizacaoTabelasAfterOpen;
  asm
    window.__facilRouterInternalHash = false;
    if (!window.__facilRouterHooked) {
      window.__facilRouterHooked = true;
      window.addEventListener('hashchange', function () {
        if (pas['View.Main'].FViewMain && pas['View.Main'].FViewMain.HandleHashChanged) {
          pas['View.Main'].FViewMain.HandleHashChanged();
        }
      });
      document.addEventListener('click', function (event) {
        var link = event.target && event.target.closest ? event.target.closest('a[href="#"]') : null;
        if (link && link.closest('#frmPrincipal')) {
          event.preventDefault();
        }
      }, true);
    }
  end;
  SetPermissoes;
end;

procedure TFViewMain.WebFormShow(Sender: TObject);
begin
  asm
    let style = document.createElement('style');
    style.innerHTML = '*{ user-select: auto !important; }';
    document.body.appendChild(style);
  end;
end;

procedure TFViewMain.WebLinkLabel6Click(Sender: TObject);
begin
  FLogoutProc;
end;

procedure TFViewMain.lancamentosClick(Sender: TObject);
  function CreateLancamentosListForm(const AElementId: string; AEditProc: TEditProc): TForm;
  begin
    Result := TFViewLancamentosList.CreateForm(AElementId, AEditProc);
  end;

  function CreateLancamentosEditForm(const AElementId: string; AListProc: TListProc;
    AId: JSValue): TForm;
  begin
    Result := TFViewLancamentosEdit.CreateForm(AElementId, AListProc, AId);
  end;

begin
  ShowCrudContainer(TFViewLancamentosList, 'Lancamentos', @CreateLancamentosListForm, @CreateLancamentosEditForm);
end;

procedure TFViewMain.lbMeuperfilClick(Sender: TObject);
begin
  ShowForm(TFViewUserProfile);
end;

procedure TFViewMain.logs_sistemaClick(Sender: TObject);
  function CreateLogs_SistemaListForm(const AElementId: string; AEditProc: TEditProc): TForm;
  begin
    Result := TFViewLogs_SistemaList.CreateForm(AElementId, AEditProc);
  end;

  function CreateLogs_SistemaEditForm(const AElementId: string; AListProc: TListProc;
    AId: JSValue): TForm;
  begin
    Result := TFViewLogs_SistemaEdit.CreateForm(AElementId, AListProc, AId);
  end;

begin
  ShowCrudContainer(TFViewLogs_SistemaList, 'Logs Sistema', @CreateLogs_SistemaListForm, @CreateLogs_SistemaEditForm);
end;

procedure TFViewMain.modalidadesClick(Sender: TObject);
  function CreateModalidadesListForm(const AElementId: string; AEditProc: TEditProc): TForm;
  begin
    Result := TFViewModalidadesList.CreateForm(AElementId, AEditProc);
  end;

  function CreateModalidadesEditForm(const AElementId: string; AListProc: TListProc;
    AId: JSValue): TForm;
  begin
    Result := TFViewModalidadesEdit.CreateForm(AElementId, AListProc, AId);
  end;

begin
  ShowCrudContainer(TFViewModalidadesList, 'Modalidades', @CreateModalidadesListForm, @CreateModalidadesEditForm);
end;

procedure TFViewMain.modulosClick(Sender: TObject);
  function CreateModulosListForm(const AElementId: string; AEditProc: TEditProc): TForm;
  begin
    Result := TFViewModulosList.CreateForm(AElementId, AEditProc);
  end;

  function CreateModulosEditForm(const AElementId: string; AListProc: TListProc;
    AId: JSValue): TForm;
  begin
    Result := TFViewModulosEdit.CreateForm(AElementId, AListProc, AId);
  end;

begin
  ShowCrudContainer(TFViewModulosList, 'Modulos', @CreateModulosListForm, @CreateModulosEditForm);
end;

procedure TFViewMain.modulos_acessoClick(Sender: TObject);
  function CreateModulos_AcessoListForm(const AElementId: string; AEditProc: TEditProc): TForm;
  begin
    Result := TFViewModulos_AcessoList.CreateForm(AElementId, AEditProc);
  end;

  function CreateModulos_AcessoEditForm(const AElementId: string; AListProc: TListProc;
    AId: JSValue): TForm;
  begin
    //
  end;

begin
  ShowCrudContainer(TFViewModulos_AcessoList, 'Módulos_Acesso', @CreateModulos_AcessoListForm, @CreateModulos_AcessoEditForm);
end;

procedure TFViewMain.nbsClick(Sender: TObject);
  function CreateNbsListForm(const AElementId: string; AEditProc: TEditProc): TForm;
  begin
    Result := TFViewNbsList.CreateForm(AElementId, AEditProc);
  end;

  function CreateNbsEditForm(const AElementId: string; AListProc: TListProc;
    AId: JSValue): TForm;
  begin
    Result := TFViewNbsEdit.CreateForm(AElementId, AListProc, AId);
  end;

begin
  ShowCrudContainer(TFViewNbsList, 'Nbs', @CreateNbsListForm, @CreateNbsEditForm);
end;

procedure TFViewMain.ncmClick(Sender: TObject);
  function CreateNcmListForm(const AElementId: string; AEditProc: TEditProc): TForm;
  begin
    Result := TFViewNcmList.CreateForm(AElementId, AEditProc);
  end;

  function CreateNcmEditForm(const AElementId: string; AListProc: TListProc;
    AId: JSValue): TForm;
  begin
    Result := TFViewNcmEdit.CreateForm(AElementId, AListProc, AId);
  end;

begin
  ShowCrudContainer(TFViewNcmList, 'Ncm', @CreateNcmListForm, @CreateNcmEditForm);
end;

procedure TFViewMain.nfceClick(Sender: TObject);

  function CreateNfceListForm(const AElementId: string; AEditProc: TEditProc): TForm;
  begin
    Result := TFViewNfceList.CreateForm(AElementId, AEditProc);
  end;

  function CreateNfceEditForm(const AElementId: string; AListProc: TListProc;
    AId: JSValue): TForm;
  begin
    Result := TFViewNfceEdit.CreateForm(AElementId, AListProc, AId);
  end;

begin
  ShowCrudContainer(TFViewNfceList, 'Nfce', @CreateNfceListForm, @CreateNfceEditForm);
end;

procedure TFViewMain.nfeClick(Sender: TObject);
  function CreateNfeListForm(const AElementId: string; AEditProc: TEditProc): TForm;
  begin
    Result := TFViewNfeList.CreateForm(AElementId, AEditProc);
  end;

  function CreateNfeEditForm(const AElementId: string; AListProc: TListProc;
    AId: JSValue): TForm;
  begin
    Result := TFViewNfeEdit.CreateForm(AElementId, AListProc, AId);
  end;

begin
  ShowCrudContainer(TFViewNfeList, 'Nfe', @CreateNfeListForm, @CreateNfeEditForm);
end;

procedure TFViewMain.nfe_loteClick(Sender: TObject);
  function CreateNfe_LoteListForm(const AElementId: string; AEditProc: TEditProc): TForm;
  begin
    Result := TFViewNfe_LoteList.CreateForm(AElementId, AEditProc);
  end;

  function CreateNfe_LoteEditForm(const AElementId: string; AListProc: TListProc;
    AId: JSValue): TForm;
  begin
    Result := TFViewNfe_LoteEdit.CreateForm(AElementId, AListProc, AId);
  end;

begin
  ShowCrudContainer(TFViewNfe_LoteList, 'Nfe_Lote', @CreateNfe_LoteListForm, @CreateNfe_LoteEditForm);
end;

procedure TFViewMain.nfseClick(Sender: TObject);
  function CreateNfseListForm(const AElementId: string; AEditProc: TEditProc): TForm;
  begin
    Result := TFViewNfseList.CreateForm(AElementId, AEditProc);
  end;

  function CreateNfseEditForm(const AElementId: string; AListProc: TListProc;
    AId: JSValue): TForm;
  begin
    Result := TFViewNfseEdit.CreateForm(AElementId, AListProc, AId);
  end;

begin
  ShowCrudContainer(TFViewNfseList, 'Nfse', @CreateNfseListForm, @CreateNfseEditForm);
end;

procedure TFViewMain.operadoras_cartaoClick(Sender: TObject);
  function CreateOperadoras_CartaoListForm(const AElementId: string; AEditProc: TEditProc): TForm;
  begin
    Result := TFViewOperadoras_CartaoList.CreateForm(AElementId, AEditProc);
  end;

  function CreateOperadoras_CartaoEditForm(const AElementId: string; AListProc: TListProc;
    AId: JSValue): TForm;
  begin
    Result := TFViewOperadoras_CartaoEdit.CreateForm(AElementId, AListProc, AId);
  end;

begin
  ShowCrudContainer(TFViewOperadoras_CartaoList, 'Operadoras_Cartao', @CreateOperadoras_CartaoListForm, @CreateOperadoras_CartaoEditForm);
end;

procedure TFViewMain.origem_csosnClick(Sender: TObject);
  function CreateOrigem_CsosnListForm(const AElementId: string; AEditProc: TEditProc): TForm;
  begin
    Result := TFViewOrigem_CsosnList.CreateForm(AElementId, AEditProc);
  end;

  function CreateOrigem_CsosnEditForm(const AElementId: string; AListProc: TListProc;
    AId: JSValue): TForm;
  begin
    Result := TFViewOrigem_CsosnEdit.CreateForm(AElementId, AListProc, AId);
  end;

begin
  ShowCrudContainer(TFViewOrigem_CsosnList, 'Origem_Csosn', @CreateOrigem_CsosnListForm, @CreateOrigem_CsosnEditForm);
end;

procedure TFViewMain.pagamentosClick(Sender: TObject);

  function CreatePagamentosListForm(const AElementId: string; AEditProc: TEditProc): TForm;
  begin
    Result := TFViewPagamentosList.CreateForm(AElementId, AEditProc);
  end;

  function CreatePagamentosEditForm(const AElementId: string; AListProc: TListProc;
    AId: JSValue): TForm;
  begin
    Result := TFViewPagamentosEdit.CreateForm(AElementId, AListProc, AId);
  end;

begin
  ShowCrudContainer(TFViewPagamentosList, 'Pagamentos', @CreatePagamentosListForm, @CreatePagamentosEditForm);
end;

procedure TFViewMain.painel_aliadosClick(Sender: TObject);
begin
  asm
    var lPath = window.location.pathname;
    var lBase = lPath.substring(0, lPath.indexOf('/', 1));

    window.open(window.location.origin + lBase + '/painel_aliados/index.html', '_blank');
  end;
end;

procedure TFViewMain.parceirosClick(Sender: TObject);
  function CreateParceirosListForm(const AElementId: string; AEditProc: TEditProc): TForm;
  begin
    Result := TFViewParceirosList.CreateForm(AElementId, AEditProc);
  end;

  function CreateParceirosEditForm(const AElementId: string; AListProc: TListProc;
    AId: JSValue): TForm;
  begin
    Result := TFViewParceirosEdit.CreateForm(AElementId, AListProc, AId);
  end;

begin
  ShowCrudContainer(TFViewParceirosList, 'Parceiros', @CreateParceirosListForm, @CreateParceirosEditForm);
end;

procedure TFViewMain.pdvsClick(Sender: TObject);
  function CreatePdvsListForm(const AElementId: string; AEditProc: TEditProc): TForm;
  begin
    Result := TFViewPdvsList.CreateForm(AElementId, AEditProc);
  end;

  function CreatePdvsEditForm(const AElementId: string; AListProc: TListProc;
    AId: JSValue): TForm;
  begin
    Result := TFViewPdvsEdit.CreateForm(AElementId, AListProc, AId);
  end;

begin
  ShowCrudContainer(TFViewPdvsList, 'Pdvs', @CreatePdvsListForm, @CreatePdvsEditForm);
end;

procedure TFViewMain.plano_contas1Click(Sender: TObject);

  function CreatePlano_Contas1ListForm(const AElementId: string; AEditProc: TEditProc): TForm;
  begin
    Result := TFViewPlano_Contas1List.CreateForm(AElementId, AEditProc);
  end;

  function CreatePlano_Contas1EditForm(const AElementId: string; AListProc: TListProc;
    AId: JSValue): TForm;
  begin
    Result := TFViewPlano_Contas1Edit.CreateForm(AElementId, AListProc, AId);
  end;

begin
  ShowCrudContainer(TFViewPlano_Contas1List, 'Plano_Contas1', @CreatePlano_Contas1ListForm, @CreatePlano_Contas1EditForm);
end;

procedure TFViewMain.plano_contas2Click(Sender: TObject);
  function CreatePlano_Contas2ListForm(const AElementId: string; AEditProc: TEditProc): TForm;
  begin
    Result := TFViewPlano_Contas2List.CreateForm(AElementId, AEditProc);
  end;

  function CreatePlano_Contas2EditForm(const AElementId: string; AListProc: TListProc;
    AId: JSValue): TForm;
  begin
    Result := TFViewPlano_Contas2Edit.CreateForm(AElementId, AListProc, AId);
  end;

begin
  ShowCrudContainer(TFViewPlano_Contas2List, 'Plano_Contas2', @CreatePlano_Contas2ListForm, @CreatePlano_Contas2EditForm);
end;

procedure TFViewMain.plano_contas3Click(Sender: TObject);
  function CreatePlano_Contas3ListForm(const AElementId: string; AEditProc: TEditProc): TForm;
  begin
    Result := TFViewPlano_Contas3List.CreateForm(AElementId, AEditProc);
  end;

  function CreatePlano_Contas3EditForm(const AElementId: string; AListProc: TListProc;
    AId: JSValue): TForm;
  begin
    Result := TFViewPlano_Contas3Edit.CreateForm(AElementId, AListProc, AId);
  end;

begin
  ShowCrudContainer(TFViewPlano_Contas3List, 'Plano_Contas3', @CreatePlano_Contas3ListForm, @CreatePlano_Contas3EditForm);
end;

procedure TFViewMain.plano_contasClick(Sender: TObject);
  function CreatePlano_ContasListForm(const AElementId: string; AEditProc: TEditProc): TForm;
  begin
    Result := TFViewPlano_ContasList.CreateForm(AElementId, AEditProc);
  end;

  function CreatePlano_ContasEditForm(const AElementId: string; AListProc: TListProc;
    AId: JSValue): TForm;
  begin
    Result := TFViewPlano_ContasEdit.CreateForm(AElementId, AListProc, AId);
  end;

begin
  ShowCrudContainer(TFViewPlano_ContasList, 'Plano_Contas', @CreatePlano_ContasListForm, @CreatePlano_ContasEditForm);
end;

procedure TFViewMain.plano_contas_contabilClick(Sender: TObject);
  function CreatePlano_Contas_ContabilListForm(const AElementId: string; AEditProc: TEditProc): TForm;
  begin
    Result := TFViewPlano_Contas_ContabilList.CreateForm(AElementId, AEditProc);
  end;

  function CreatePlano_Contas_ContabilEditForm(const AElementId: string; AListProc: TListProc;
    AId: JSValue): TForm;
  begin
    Result := TFViewPlano_Contas_ContabilEdit.CreateForm(AElementId, AListProc, AId);
  end;

begin
  ShowCrudContainer(TFViewPlano_Contas_ContabilList, 'Plano_Contas_Contabil', @CreatePlano_Contas_ContabilListForm, @CreatePlano_Contas_ContabilEditForm);
end;

procedure TFViewMain.produtosClick(Sender: TObject);
  function CreateProdutosListForm(const AElementId: string; AEditProc: TEditProc): TForm;
  begin
    Result := TFViewProdutosList.CreateForm(AElementId, AEditProc);
  end;

  function CreateProdutosEditForm(const AElementId: string; AListProc: TListProc;
    AId: JSValue): TForm;
  begin
    Result := TFViewProdutosEdit.CreateForm(AElementId, AListProc, AId);
  end;

begin
  if (Sender <> nil) and (not FRouteRestoring) then
    THelperServer.FQueryProdutos := '';

  ShowCrudContainer(TFViewProdutosList, 'Produtos', @CreateProdutosListForm, @CreateProdutosEditForm);
end;

procedure TFViewMain.produtos_associacaoClick(Sender: TObject);
  function CreateProdutos_AssociacaoListForm(const AElementId: string; AEditProc: TEditProc): TForm;
  begin
    Result := TFViewProdutos_AssociacaoList.CreateForm(AElementId, AEditProc);
  end;

  function CreateProdutos_AssociacaoEditForm(const AElementId: string; AListProc: TListProc;
    AId: JSValue): TForm;
  begin
    //
  end;

begin
  ShowCrudContainer(TFViewProdutos_AssociacaoList, 'Aprovação de produtos', @CreateProdutos_AssociacaoListForm, @CreateProdutos_AssociacaoEditForm);
end;

procedure TFViewMain.promocoesClick(Sender: TObject);
  function CreatePromocoesListForm(const AElementId: string; AEditProc: TEditProc): TForm;
  begin
    Result := TFViewPromocoesList.CreateForm(AElementId, AEditProc);
  end;

  function CreatePromocoesEditForm(const AElementId: string; AListProc: TListProc;
    AId: JSValue): TForm;
  begin
    Result := TFViewPromocoesEdit.CreateForm(AElementId, AListProc, AId);
  end;

begin
  ShowCrudContainer(TFViewPromocoesList, 'Promoções', @CreatePromocoesListForm, @CreatePromocoesEditForm);
end;

procedure TFViewMain.provedoresClick(Sender: TObject);
  function CreateProvedoresListForm(const AElementId: string; AEditProc: TEditProc): TForm;
  begin
    Result := TFViewProvedoresList.CreateForm(AElementId, AEditProc);
  end;

  function CreateProvedoresEditForm(const AElementId: string; AListProc: TListProc;
    AId: JSValue): TForm;
  begin
    Result := TFViewProvedoresEdit.CreateForm(AElementId, AListProc, AId);
  end;

begin
  ShowCrudContainer(TFViewProvedoresList, 'Provedores', @CreateProvedoresListForm, @CreateProvedoresEditForm);
end;

procedure TFViewMain.recebimentosClick(Sender: TObject);
  function CreateRecebimentosListForm(const AElementId: string; AEditProc: TEditProc): TForm;
  begin
    Result := TFViewRecebimentosList.CreateForm(AElementId, AEditProc);
  end;

  function CreateRecebimentosEditForm(const AElementId: string; AListProc: TListProc;
    AId: JSValue): TForm;
  begin
    Result := TFViewRecebimentosEdit.CreateForm(AElementId, AListProc, AId);
  end;

begin
  ShowCrudContainer(TFViewRecebimentosList, 'Recebimentos', @CreateRecebimentosListForm, @CreateRecebimentosEditForm);
end;

procedure TFViewMain.relatoriosClick(Sender: TObject);
begin
  asm
    var lPath = window.location.pathname;
    var lBase = lPath.substring(0, lPath.indexOf('/', 1));

    window.open(window.location.origin + lBase + '/relatorios/relatorios.html', '_blank');
  end;
end;

procedure TFViewMain.rt_credito_presumidoClick(Sender: TObject);

  function CreateRt_Credito_PresumidoListForm(const AElementId: string; AEditProc: TEditProc): TForm;
  begin
    Result := TFViewRt_Credito_PresumidoList.CreateForm(AElementId, AEditProc);
  end;

  function CreateRt_Credito_PresumidoEditForm(const AElementId: string; AListProc: TListProc;
    AId: JSValue): TForm;
  begin
    Result := TFViewRt_Credito_PresumidoEdit.CreateForm(AElementId, AListProc, AId);
  end;

begin
  ShowCrudContainer(TFViewRt_Credito_PresumidoList, 'Crédito Presumido', @CreateRt_Credito_PresumidoListForm, @CreateRt_Credito_PresumidoEditForm);
end;

procedure TFViewMain.rt_ibs_cbs_cstClick(Sender: TObject);

  function CreateRt_Ibs_Cbs_CstListForm(const AElementId: string; AEditProc: TEditProc): TForm;
  begin
    Result := TFViewRt_Ibs_Cbs_CstList.CreateForm(AElementId, AEditProc);
  end;

  function CreateRt_Ibs_Cbs_CstEditForm(const AElementId: string; AListProc: TListProc;
    AId: JSValue): TForm;
  begin
    Result := TFViewRt_Ibs_Cbs_CstEdit.CreateForm(AElementId, AListProc, AId);
  end;

begin
  ShowCrudContainer(TFViewRt_Ibs_Cbs_CstList, 'IBS_CBS_CST', @CreateRt_Ibs_Cbs_CstListForm, @CreateRt_Ibs_Cbs_CstEditForm);
end;

procedure TFViewMain.rt_is_cstClick(Sender: TObject);

  function CreateRt_Is_CstListForm(const AElementId: string; AEditProc: TEditProc): TForm;
  begin
    Result := TFViewRt_Is_CstList.CreateForm(AElementId, AEditProc);
  end;

  function CreateRt_Is_CstEditForm(const AElementId: string; AListProc: TListProc;
    AId: JSValue): TForm;
  begin
    Result := TFViewRt_Is_CstEdit.CreateForm(AElementId, AListProc, AId);
  end;

begin
  ShowCrudContainer(TFViewRt_Is_CstList, 'IS_CST', @CreateRt_Is_CstListForm, @CreateRt_Is_CstEditForm);
end;

procedure TFViewMain.scriptsClick(Sender: TObject);
  function CreateScriptsListForm(const AElementId: string; AEditProc: TEditProc): TForm;
  begin
    Result := TFViewScriptsList.CreateForm(AElementId, AEditProc);
  end;

  function CreateScriptsEditForm(const AElementId: string; AListProc: TListProc;
    AId: JSValue): TForm;
  begin
    Result := TFViewScriptsEdit.CreateForm(AElementId, AListProc, AId);
  end;

begin
  ShowCrudContainer(TFViewScriptsList, 'Scripts', @CreateScriptsListForm, @CreateScriptsEditForm);
end;

procedure TFViewMain.scripts_aliadosClick(Sender: TObject);
  function CreateScripts_AliadosListForm(const AElementId: string; AEditProc: TEditProc): TForm;
  begin
    Result := TFViewScripts_AliadosList.CreateForm(AElementId, AEditProc);
  end;

  function CreateScripts_AliadosEditForm(const AElementId: string; AListProc: TListProc;
    AId: JSValue): TForm;
  begin
    Result := TFViewScripts_AliadosEdit.CreateForm(AElementId, AListProc, AId);
  end;

begin
  ShowCrudContainer(TFViewScripts_AliadosList, 'Scripts Aliados', @CreateScripts_AliadosListForm, @CreateScripts_AliadosEditForm);
end;

procedure TFViewMain.segmentosClick(Sender: TObject);
  function CreateSegmentoListForm(const AElementId: string; AEditProc: TEditProc): TForm;
  begin
    Result := TFViewSegmentoList.CreateForm(AElementId, AEditProc);
  end;

  function CreateSegmentoEditForm(const AElementId: string; AListProc: TListProc;
    AId: JSValue): TForm;
  begin
    Result := TFViewSegmentoEdit.CreateForm(AElementId, AListProc, AId);
  end;

begin
  ShowCrudContainer(TFViewSegmentoList, 'Segmento', @CreateSegmentoListForm, @CreateSegmentoEditForm);
end;

procedure TFViewMain.lbViewStatus_TitulosClick(Sender: TObject);

  function CreateStatus_TitulosListForm(const AElementId: string; AEditProc: TEditProc): TForm;
  begin
    Result := TFViewStatus_TitulosList.CreateForm(AElementId, AEditProc);
  end;

  function CreateStatus_TitulosEditForm(const AElementId: string; AListProc: TListProc;
    AId: JSValue): TForm;
  begin
    Result := TFViewStatus_TitulosEdit.CreateForm(AElementId, AListProc, AId);
  end;

begin
  ShowCrudContainer(TFViewStatus_TitulosList, 'Status_Titulos', @CreateStatus_TitulosListForm, @CreateStatus_TitulosEditForm);
end;

procedure TFViewMain.aliadoClick(Sender: TObject);

  function CreateAliadoListForm(const AElementId: string; AEditProc: TEditProc): TForm;
  begin
    Result := TFViewAliadoList.CreateForm(AElementId, AEditProc);
  end;

  function CreateAliadoEditForm(const AElementId: string; AListProc: TListProc;
    AId: JSValue): TForm;
  begin
    Result := TFViewAliadoEdit.CreateForm(AElementId, AListProc, AId);
  end;

begin
  ShowCrudContainer(TFViewAliadoList, 'Aliado', @CreateAliadoListForm, @CreateAliadoEditForm);
end;

procedure TFViewMain.aliquotasClick(Sender: TObject);
  function CreateAliquotasListForm(const AElementId: string; AEditProc: TEditProc): TForm;
  begin
    Result := TFViewAliquotasList.CreateForm(AElementId, AEditProc);
  end;

  function CreateAliquotasEditForm(const AElementId: string; AListProc: TListProc;
    AId: JSValue): TForm;
  begin
    Result := TFViewAliquotasEdit.CreateForm(AElementId, AListProc, AId);
  end;

begin
  ShowCrudContainer(TFViewAliquotasList, 'Aliquotas', @CreateAliquotasListForm, @CreateAliquotasEditForm);
end;

procedure TFViewMain.apagarClick(Sender: TObject);
  function CreateApagarListForm(const AElementId: string; AEditProc: TEditProc): TForm;
  begin
    Result := TFViewApagarList.CreateForm(AElementId, AEditProc);
  end;

  function CreateApagarEditForm(const AElementId: string; AListProc: TListProc;
    AId: JSValue): TForm;
  begin
    Result := TFViewApagarEdit.CreateForm(AElementId, AListProc, AId);
  end;

begin
  ShowCrudContainer(TFViewApagarList, 'Apagar', @CreateApagarListForm, @CreateApagarEditForm);
end;

procedure TFViewMain.api_cpfsClick(Sender: TObject);
  function CreateApi_CpfsListForm(const AElementId: string; AEditProc: TEditProc): TForm;
  begin
    Result := TFViewApi_CpfsList.CreateForm(AElementId, AEditProc);
  end;

  function CreateApi_CpfsEditForm(const AElementId: string; AListProc: TListProc;
    AId: JSValue): TForm;
  begin
    //
  end;

begin
  ShowCrudContainer(TFViewApi_CpfsList, 'Api_CPFs', @CreateApi_CpfsListForm, @CreateApi_CpfsEditForm);
end;

procedure TFViewMain.api_veiculosClick(Sender: TObject);
  function CreateApi_VeiculosListForm(const AElementId: string; AEditProc: TEditProc): TForm;
  begin
    Result := TFViewApi_VeiculosList.CreateForm(AElementId, AEditProc);
  end;

  function CreateApi_VeiculosEditForm(const AElementId: string; AListProc: TListProc;
    AId: JSValue): TForm;
  begin
    //Result := TFViewApi_VeiculosEdit.CreateForm(AElementId, AListProc, AId);
  end;

begin
  ShowCrudContainer(TFViewApi_VeiculosList, 'Api_Veiculos', @CreateApi_VeiculosListForm, @CreateApi_VeiculosEditForm);
end;

procedure TFViewMain.areceberClick(Sender: TObject);
  function CreateAreceberListForm(const AElementId: string; AEditProc: TEditProc): TForm;
  begin
    Result := TFViewAreceberList.CreateForm(AElementId, AEditProc);
  end;

  function CreateAreceberEditForm(const AElementId: string; AListProc: TListProc;
    AId: JSValue): TForm;
  begin
    Result := TFViewAreceberEdit.CreateForm(AElementId, AListProc, AId);
  end;

begin
  ShowCrudContainer(TFViewAreceberList, 'Areceber', @CreateAreceberListForm, @CreateAreceberEditForm);
end;

procedure TFViewMain.bancosClick(Sender: TObject);
  function CreateBancosListForm(const AElementId: string; AEditProc: TEditProc): TForm;
  begin
    Result := TFViewBancosList.CreateForm(AElementId, AEditProc);
  end;

  function CreateBancosEditForm(const AElementId: string; AListProc: TListProc;
    AId: JSValue): TForm;
  begin
    Result := TFViewBancosEdit.CreateForm(AElementId, AListProc, AId);
  end;

begin
  ShowCrudContainer(TFViewBancosList, 'Bancos', @CreateBancosListForm, @CreateBancosEditForm);
end;

procedure TFViewMain.banco_carteirasClick(Sender: TObject);
  function CreateBanco_CarteirasListForm(const AElementId: string; AEditProc: TEditProc): TForm;
  begin
    Result := TFViewBanco_CarteirasList.CreateForm(AElementId, AEditProc);
  end;

  function CreateBanco_CarteirasEditForm(const AElementId: string; AListProc: TListProc;
    AId: JSValue): TForm;
  begin
    Result := TFViewBanco_CarteirasEdit.CreateForm(AElementId, AListProc, AId);
  end;

begin
  ShowCrudContainer(TFViewBanco_CarteirasList, 'Banco_Carteiras', @CreateBanco_CarteirasListForm, @CreateBanco_CarteirasEditForm);
end;

procedure TFViewMain.boletosClick(Sender: TObject);
  function CreateBoletosListForm(const AElementId: string; AEditProc: TEditProc): TForm;
  begin
    Result := TFViewBoletosList.CreateForm(AElementId, AEditProc);
  end;

  function CreateBoletosEditForm(const AElementId: string; AListProc: TListProc;
    AId: JSValue): TForm;
  begin
    Result := TFViewBoletosEdit.CreateForm(AElementId, AListProc, AId);
  end;

begin
  ShowCrudContainer(TFViewBoletosList, 'Boletos', @CreateBoletosListForm, @CreateBoletosEditForm);
end;

procedure TFViewMain.btnDesconectarClick(Sender: TObject);
begin
  if Await(TUtils.ChamarMensagemDialog(TTipoDialogo.CONFIRMACAO,
      'Tem certeza que deseja desconectar do aliado logado?')) then
  begin
    cdsUsuarios.Edit;
    cdsUsuarios.FieldByName('data_base_id').Value := null;
    cdsUsuarios.FieldByName('aliado_id').Value := null;

    cdsUsuarios.Post;
    cdsUsuarios.ApplyUpdates;
  end;
end;

procedure TFViewMain.cbbDataBaseChange(Sender: TObject);
var
  lIndiceAtual : Integer;
begin
  lIndiceAtual := cbbDataBase.ItemIndex;

  if lIndiceAtual <> FIndice then
  begin
    if Await(TUtils.ChamarMensagemDialog(TTipoDialogo.CONFIRMACAO,
      'Tem certeza que deseja alterar o banco em que esta logado?')) then
    begin
      cdsUsuarios.Edit;

      if lIndiceAtual = 0 then
        cdsUsuarios.FieldByName('data_base_id').Value := null
      else
        cdsUsuarios.FieldByName('data_base_id').AsInteger := GetKeyByValue(lIndiceAtual);

      cdsUsuarios.Post;
      cdsUsuarios.ApplyUpdates;
      lblEmpresalogin.Caption := cbbDataBase.Text;

      FIndice := lIndiceAtual;
    end
    else
      cbbDataBase.ItemIndex := FIndice;
  end;
end;

procedure TFViewMain.cdsDataBaseAfterOpen(DataSet: TDataSet);
var
  lDataBaseId,
  lTagImg : string;
begin
  cbbDataBase.Items.Clear;
  FDicionarioBancos.Clear;

  cdsDataBase.First;

  FDicionarioBancos.Add(0, cbbDataBase.Items.Add('Todos'));

  while not cdsDataBase.Eof do
  begin
    if cdsDataBase.FieldByName('associar_produtos').AsBoolean then
      lTagImg := 'IMG - '
    else
      lTagImg := EmptyStr;

    FDicionarioBancos.Add(cdsDataBase.FieldByName('id').AsInteger,
      cbbDataBase.Items.Add(lTagImg + cdsDataBase.FieldByName('nome_fantasia').AsString));

    cdsDataBase.Next;
  end;

  lDataBaseId := cdsUsuarios.FieldByName('data_base_id').AsString;

  if lDataBaseId.IsEmpty then
    SelecionarNoCombo(0)
  else
    SelecionarNoCombo(StrToInt(lDataBaseId));

  lblEmpresalogin.Caption := cbbDataBase.Text;
end;

procedure TFViewMain.cdsPersonalizacaoTabelasAfterOpen(DataSet: TDataSet);
begin
  if not FRouteNavigationPending then
    Exit;

  FRouteNavigationPending := False;

  asm
    setTimeout(function () {
      if (pas['View.Main'].FViewMain) {
        pas['View.Main'].FViewMain.NavigateCurrentHash();
      }
    }, 0);
  end;
end;
procedure TFViewMain.cdsPersonalizacaoTabelasAfterApplyUpdates(Sender: TDataSet;
  Info: TResolveResults);
var
  ResolveInfo: TResolveInfo;
  I : Integer;
  lDataObject: TJSObject;
begin
  for I := 0 to Length(Info.Records) - 1 do
  begin
    ResolveInfo := Info.Records[I];

     if ResolveInfo.Error <> '' then
    begin
      TUtils.ChamarMensagemDialog(TTipoDialogo.ERROR, ResolveInfo.Error);

      Exit;
    end;
  end;

  TUtils.CloseModal('modalPersonalizacaoTabela');
  TUtils.ChamarMensagemDialog(TTipoDialogo.SUCESSO, 'Operação realizada com sucesso!' +
    slineBreak + '<b>Recarregue a página.</b>');

  cdsPersonalizacaoTabelas.Close;
  cdsPersonalizacaoTabelas.Load;
end;

procedure TFViewMain.cdsUsuariosAfterApplyUpdates(Sender: TDataSet;
  Info: TResolveResults);
begin
  asm
    var lPath = window.location.pathname;
    var lBase = lPath.substring(0, lPath.indexOf('/', 1));

    window.location.href = window.location.origin + lBase + '/';
  end;
end;

procedure TFViewMain.cdsUsuariosAfterOpen(DataSet: TDataSet);
begin
  TUtils.FUsuario := TDadosUsuarioVO.Create;
  TUtils.FUsuario.Nome := cdsUsuarios.FieldByName('nome').AsString;
  TUtils.FUsuario.Id := cdsUsuarios.FieldByName('id').AsInteger;
  TUtils.FUsuario.Perfil := cdsUsuarios.FieldByName('perfil').AsInteger;
  TUtils.FUsuario.DataBase := cdsUsuarios.FieldByName('data_base_id').AsInteger;
  TUtils.FUsuario.Aliado := cdsUsuarios.FieldByName('aliado_id').AsInteger;
  TUtils.FUsuario.PerfilAcesso := cdsUsuarios.FieldByName('perfil_acesso').AsString;


  lbUsername.Caption := TUtils.FUsuario.Nome;

  if TUtils.FUsuario.Aliado > 0 then
  begin
    div_empresa_login.Visible := True;
    div_bancos_usuario.Visible := True;

    if not TUtils.PossuiPermissao('data_base', TTipoPermissao.VISUALIZAR) then
    begin
      TUtils.RemoverElementoPorId('cbbSelecionarDataBase');
      TUtils.RemoverElementoPorId('lblSelecionarDataBase');
      TUtils.RemoverElementoPorId('div_empresa_login');
    end
    else
      cdsDataBase.Load;

    if not(TUtils.IsPerfilAliado(TUtils.FUsuario)) then
    begin
      lbViewAliado.Caption := 'Aliados';
      dwcGetDadosEmpresaLogado.Get('aliado', TUtils.FUsuario.Aliado);
    end
    else
      lbViewAliado.Caption := 'Empresa';
  end;

  if not TUtils.VerificarAcessoServidor(TServidor.PAINEL_ALIADOS, TUtils.FUsuario.PerfilAcesso) then
    TUtils.RemoverElementoPorId(painel_aliados.ElementID);

  cdsPersonalizacaoTabelas.QueryString := '$filter=(usuario_id eq ' + TUtils.FUsuario.Id.ToString + ')';
  cdsPersonalizacaoTabelas.Load;
end;

procedure TFViewMain.cfopClick(Sender: TObject);
  function CreateCfopListForm(const AElementId: string; AEditProc: TEditProc): TForm;
  begin
    Result := TFViewCfopList.CreateForm(AElementId, AEditProc);
  end;

  function CreateCfopEditForm(const AElementId: string; AListProc: TListProc;
    AId: JSValue): TForm;
  begin
    Result := TFViewCfopEdit.CreateForm(AElementId, AListProc, AId);
  end;

begin
  ShowCrudContainer(TFViewCfopList, 'Cfop', @CreateCfopListForm, @CreateCfopEditForm);
end;

procedure TFViewMain.cfop_configuracoesClick(Sender: TObject);
  function CreateCfop_ConfiguracoesListForm(const AElementId: string; AEditProc: TEditProc): TForm;
  begin
    Result := TFViewCfop_ConfiguracoesList.CreateForm(AElementId, AEditProc);
  end;

  function CreateCfop_ConfiguracoesEditForm(const AElementId: string; AListProc: TListProc;
    AId: JSValue): TForm;
  begin
    Result := TFViewCfop_ConfiguracoesEdit.CreateForm(AElementId, AListProc, AId);
  end;

begin
  ShowCrudContainer(TFViewCfop_ConfiguracoesList, 'Cfop_Configuracoes', @CreateCfop_ConfiguracoesListForm, @CreateCfop_ConfiguracoesEditForm);
end;

procedure TFViewMain.cidadeClick(Sender: TObject);
  function CreateCidadeListForm(const AElementId: string; AEditProc: TEditProc): TForm;
  begin
    Result := TFViewCidadeList.CreateForm(AElementId, AEditProc);
  end;

  function CreateCidadeEditForm(const AElementId: string; AListProc: TListProc;
    AId: JSValue): TForm;
  begin
    Result := TFViewCidadeEdit.CreateForm(AElementId, AListProc, AId);
  end;

begin
  ShowCrudContainer(TFViewCidadeList, 'Cidade', @CreateCidadeListForm, @CreateCidadeEditForm);
end;

procedure TFViewMain.clientesClick(Sender: TObject);
  function CreateClientesListForm(const AElementId: string; AEditProc: TEditProc): TForm;
  begin
    Result := TFViewClientesList.CreateForm(AElementId, AEditProc);
  end;

  function CreateClientesEditForm(const AElementId: string; AListProc: TListProc;
    AId: JSValue): TForm;
  begin
    Result := TFViewClientesEdit.CreateForm(AElementId, AListProc, AId);
  end;

begin
  ShowCrudContainer(TFViewClientesList, 'Clientes', @CreateClientesListForm, @CreateClientesEditForm);
end;

procedure TFViewMain.codigo_bc_piscofinsClick(Sender: TObject);

  function CreateCodigo_bc_PiscofinsListForm(const AElementId: string; AEditProc: TEditProc): TForm;
  begin
    Result := TFViewCodigo_bc_PiscofinsList.CreateForm(AElementId, AEditProc);
  end;

  function CreateCodigo_bc_PiscofinsEditForm(const AElementId: string; AListProc: TListProc;
    AId: JSValue): TForm;
  begin
    Result := TFViewCodigo_bc_PiscofinsEdit.CreateForm(AElementId, AListProc, AId);
  end;

begin
  ShowCrudContainer(TFViewCodigo_bc_PiscofinsList, 'Codigo_bc_Piscofins', @CreateCodigo_bc_PiscofinsListForm, @CreateCodigo_bc_PiscofinsEditForm);
end;

procedure TFViewMain.codigo_credito_piscofinsClick(Sender: TObject);
  function CreateCodigo_Credito_PiscofinsListForm(const AElementId: string; AEditProc: TEditProc): TForm;
  begin
    Result := TFViewCodigo_Credito_PiscofinsList.CreateForm(AElementId, AEditProc);
  end;

  function CreateCodigo_Credito_PiscofinsEditForm(const AElementId: string; AListProc: TListProc;
    AId: JSValue): TForm;
  begin
    Result := TFViewCodigo_Credito_PiscofinsEdit.CreateForm(AElementId, AListProc, AId);
  end;

begin
  ShowCrudContainer(TFViewCodigo_Credito_PiscofinsList, 'Codigo_Credito_Piscofins', @CreateCodigo_Credito_PiscofinsListForm, @CreateCodigo_Credito_PiscofinsEditForm);
end;

procedure TFViewMain.comprasClick(Sender: TObject);
  function CreateComprasListForm(const AElementId: string; AEditProc: TEditProc): TForm;
  begin
    Result := TFViewComprasList.CreateForm(AElementId, AEditProc);
  end;

  function CreateComprasEditForm(const AElementId: string; AListProc: TListProc;
    AId: JSValue): TForm;
  begin
    Result := TFViewComprasEdit.CreateForm(AElementId, AListProc, AId);
  end;

begin
  ShowCrudContainer(TFViewComprasList, 'Compras', @CreateComprasListForm, @CreateComprasEditForm);
end;

procedure TFViewMain.ConfigurarUsuarioComum;
var
  lUsuarioId : Integer;
begin
  lUsuarioId := Js.toInteger(AuthService.TokenPayload.Properties['usuario_id']);
  div_aliado_login.Visible := False;
  aliado_conectado_topo.Visible := False;
  div_bancos_usuario.Visible := False;
  div_empresa_login.Visible := False;

  dwcGetUsuario.Get('Usuarios_Gerenciamento', lUsuarioId);
end;

procedure TFViewMain.consulta_nfseClick(Sender: TObject);
var
  lHashPos: Integer;
  lUrl: string;
begin
  lUrl := window.location.href;
  lHashPos := Pos('#', lUrl);

  if lHashPos > 0 then
    lUrl := Copy(lUrl, 1, lHashPos - 1);

  window.open(lUrl + '#consultar-cidades-nfse', '_blank');
end;

procedure TFViewMain.contadoresClick(Sender: TObject);
  function CreateContadoresListForm(const AElementId: string; AEditProc: TEditProc): TForm;
  begin
    Result := TFViewContadoresList.CreateForm(AElementId, AEditProc);
  end;

  function CreateContadoresEditForm(const AElementId: string; AListProc: TListProc;
    AId: JSValue): TForm;
  begin
    Result := TFViewContadoresEdit.CreateForm(AElementId, AListProc, AId);
  end;

begin
  ShowCrudContainer(TFViewContadoresList, 'Contadores', @CreateContadoresListForm, @CreateContadoresEditForm);
end;

procedure TFViewMain.contasClick(Sender: TObject);
  function CreateContasListForm(const AElementId: string; AEditProc: TEditProc): TForm;
  begin
    Result := TFViewContasList.CreateForm(AElementId, AEditProc);
  end;

  function CreateContasEditForm(const AElementId: string; AListProc: TListProc;
    AId: JSValue): TForm;
  begin
    Result := TFViewContasEdit.CreateForm(AElementId, AListProc, AId);
  end;

begin
  ShowCrudContainer(TFViewContasList, 'Contas', @CreateContasListForm, @CreateContasEditForm);
end;

procedure TFViewMain.csosnClick(Sender: TObject);
  function CreateCsosnListForm(const AElementId: string; AEditProc: TEditProc): TForm;
  begin
    Result := TFViewCsosnList.CreateForm(AElementId, AEditProc);
  end;

  function CreateCsosnEditForm(const AElementId: string; AListProc: TListProc;
    AId: JSValue): TForm;
  begin
    Result := TFViewCsosnEdit.CreateForm(AElementId, AListProc, AId);
  end;

begin
  ShowCrudContainer(TFViewCsosnList, 'Csosn', @CreateCsosnListForm, @CreateCsosnEditForm);
end;

procedure TFViewMain.cstClick(Sender: TObject);
  function CreateCstListForm(const AElementId: string; AEditProc: TEditProc): TForm;
  begin
    Result := TFViewCstList.CreateForm(AElementId, AEditProc);
  end;

  function CreateCstEditForm(const AElementId: string; AListProc: TListProc;
    AId: JSValue): TForm;
  begin
    Result := TFViewCstEdit.CreateForm(AElementId, AListProc, AId);
  end;

begin
  ShowCrudContainer(TFViewCstList, 'Cst', @CreateCstListForm, @CreateCstEditForm);
end;

procedure TFViewMain.cst_cofinsClick(Sender: TObject);
  function CreateCst_CofinsListForm(const AElementId: string; AEditProc: TEditProc): TForm;
  begin
    Result := TFViewCst_CofinsList.CreateForm(AElementId, AEditProc);
  end;

  function CreateCst_CofinsEditForm(const AElementId: string; AListProc: TListProc;
    AId: JSValue): TForm;
  begin
    Result := TFViewCst_CofinsEdit.CreateForm(AElementId, AListProc, AId);
  end;

begin
  ShowCrudContainer(TFViewCst_CofinsList, 'Cst_Cofins', @CreateCst_CofinsListForm, @CreateCst_CofinsEditForm);
end;

procedure TFViewMain.cst_ipiClick(Sender: TObject);
  function CreateCst_IpiListForm(const AElementId: string; AEditProc: TEditProc): TForm;
  begin
    Result := TFViewCst_IpiList.CreateForm(AElementId, AEditProc);
  end;

  function CreateCst_IpiEditForm(const AElementId: string; AListProc: TListProc;
    AId: JSValue): TForm;
  begin
    Result := TFViewCst_IpiEdit.CreateForm(AElementId, AListProc, AId);
  end;

begin
  ShowCrudContainer(TFViewCst_IpiList, 'Cst_Ipi', @CreateCst_IpiListForm, @CreateCst_IpiEditForm);
end;

procedure TFViewMain.cst_pisClick(Sender: TObject);
  function CreateCst_PisListForm(const AElementId: string; AEditProc: TEditProc): TForm;
  begin
    Result := TFViewCst_PisList.CreateForm(AElementId, AEditProc);
  end;

  function CreateCst_PisEditForm(const AElementId: string; AListProc: TListProc;
    AId: JSValue): TForm;
  begin
    Result := TFViewCst_PisEdit.CreateForm(AElementId, AListProc, AId);
  end;

begin
  ShowCrudContainer(TFViewCst_PisList, 'Cst_Pis', @CreateCst_PisListForm, @CreateCst_PisEditForm);
end;

procedure TFViewMain.cuponsClick(Sender: TObject);
  function CreateCuponsListForm(const AElementId: string; AEditProc: TEditProc): TForm;
  begin
    Result := TFViewCuponsList.CreateForm(AElementId, AEditProc);
  end;

  function CreateCuponsEditForm(const AElementId: string; AListProc: TListProc;
    AId: JSValue): TForm;
  begin
    Result := TFViewCuponsEdit.CreateForm(AElementId, AListProc, AId);
  end;

begin
  ShowCrudContainer(TFViewCuponsList, 'Cupons', @CreateCuponsListForm, @CreateCuponsEditForm);
end;

procedure TFViewMain.data_base_logsClick(Sender: TObject);
  function CreateData_Base_LogsListForm(const AElementId: string; AEditProc: TEditProc): TForm;
  begin
    Result := TFViewData_Base_LogsList.CreateForm(AElementId, AEditProc);
  end;

  function CreateData_Base_LogsEditForm(const AElementId: string; AListProc: TListProc;
    AId: JSValue): TForm;
  begin
    Result := TFViewData_Base_LogsEdit.CreateForm(AElementId, AListProc, AId);
  end;

begin
  ShowCrudContainer(TFViewData_Base_LogsList, 'Data_Base_Logs', @CreateData_Base_LogsListForm, @CreateData_Base_LogsEditForm);
end;

procedure TFViewMain.desoneracao_icmsClick(Sender: TObject);
  function CreateDesoneracao_IcmsListForm(const AElementId: string; AEditProc: TEditProc): TForm;
  begin
    Result := TFViewDesoneracao_IcmsList.CreateForm(AElementId, AEditProc);
  end;

  function CreateDesoneracao_IcmsEditForm(const AElementId: string; AListProc: TListProc;
    AId: JSValue): TForm;
  begin
    Result := TFViewDesoneracao_IcmsEdit.CreateForm(AElementId, AListProc, AId);
  end;

begin
  ShowCrudContainer(TFViewDesoneracao_IcmsList, 'Desoneracao_Icms', @CreateDesoneracao_IcmsListForm, @CreateDesoneracao_IcmsEditForm);
end;

class procedure TFViewMain.Display(AElementId: string; LogoutProc: TLogoutProc);

  procedure AfterCreate(AForm: TObject);
  begin
    //TFViewMain(AForm).FLogoutProc := LogoutProc;
  end;

begin
  if Assigned(FViewMain) then
    FViewMain.Free;
  FViewMain := TFViewMain.CreateNew(AElementId, @AfterCreate);
  FViewMain.FLogoutProc := LogoutProc;
end;

procedure TFViewMain.dwcGetDadosEmpresaLogadoLoad(
  Response: TXDataClientResponse);
var
  lJson : TJSObject;
begin
  lJson := TJSObject(TJSJSON.parse(Response.ResponseText));

  aliado_logado.Caption := string(lJson['Razao_Social']);
  nome_aliado_conectado_topo.Caption := aliado_logado.Caption;
  div_aliado_login.Visible := True;
  aliado_conectado_topo.Visible := True;
end;

procedure TFViewMain.dwcGetUsuarioLoad(Response: TXDataClientResponse);
begin
  cdsUsuarios.Close;
  cdsUsuarios.SetJsonData(Response.Result);
  FRouteNavigationPending := True;
  cdsUsuarios.Open;
end;

procedure TFViewMain.erros_catalogadosClick(Sender: TObject);
  function CreateErros_CatalogadosListForm(const AElementId: string; AEditProc: TEditProc): TForm;
  begin
    Result := TFViewErros_CatalogadosList.CreateForm(AElementId, AEditProc);
  end;

  function CreateErros_CatalogadosEditForm(const AElementId: string; AListProc: TListProc;
    AId: JSValue): TForm;
  begin
    Result := TFViewErros_CatalogadosEdit.CreateForm(AElementId, AListProc, AId);
  end;

begin
  ShowCrudContainer(TFViewErros_CatalogadosList, 'Erros_Catalogados', @CreateErros_CatalogadosListForm, @CreateErros_CatalogadosEditForm);
end;

procedure TFViewMain.facil_planosClick(Sender: TObject);
  function CreateFacil_PlanosListForm(const AElementId: string; AEditProc: TEditProc): TForm;
  begin
    Result := TFViewFacil_PlanosList.CreateForm(AElementId, AEditProc);
  end;

  function CreateFacil_PlanosEditForm(const AElementId: string; AListProc: TListProc;
    AId: JSValue): TForm;
  begin
    Result := TFViewFacil_PlanosEdit.CreateForm(AElementId, AListProc, AId);
  end;

begin
  ShowCrudContainer(TFViewFacil_PlanosList, 'Facil_Planos', @CreateFacil_PlanosListForm, @CreateFacil_PlanosEditForm);
end;

procedure TFViewMain.facil_planos_aliadosClick(Sender: TObject);
  function CreateFacil_Planos_AliadosListForm(const AElementId: string; AEditProc: TEditProc): TForm;
  begin
    Result := TFViewFacil_Planos_AliadosList.CreateForm(AElementId, AEditProc);
  end;

  function CreateFacil_Planos_AliadosEditForm(const AElementId: string; AListProc: TListProc;
    AId: JSValue): TForm;
  begin
    Result := TFViewFacil_Planos_AliadosEdit.CreateForm(AElementId, AListProc, AId);
  end;

begin
  ShowCrudContainer(TFViewFacil_Planos_AliadosList, 'Facil_Planos_Aliados', @CreateFacil_Planos_AliadosListForm, @CreateFacil_Planos_AliadosEditForm);
end;

procedure TFViewMain.fornecedoresClick(Sender: TObject);
  function CreateFornecedoresListForm(const AElementId: string; AEditProc: TEditProc): TForm;
  begin
    Result := TFViewFornecedoresList.CreateForm(AElementId, AEditProc);
  end;

  function CreateFornecedoresEditForm(const AElementId: string; AListProc: TListProc;
    AId: JSValue): TForm;
  begin
    Result := TFViewFornecedoresEdit.CreateForm(AElementId, AListProc, AId);
  end;

begin
  ShowCrudContainer(TFViewFornecedoresList, 'Fornecedores', @CreateFornecedoresListForm, @CreateFornecedoresEditForm);
end;

procedure TFViewMain.fs_prod_caracteristicasClick(Sender: TObject);
  function CreateFs_Prod_CaracteristicasListForm(const AElementId: string; AEditProc: TEditProc): TForm;
  begin
    Result := TFViewFs_Prod_CaracteristicasList.CreateForm(AElementId, AEditProc);
  end;

  function CreateFs_Prod_CaracteristicasEditForm(const AElementId: string; AListProc: TListProc;
    AId: JSValue): TForm;
  begin
    Result := TFViewFs_Prod_CaracteristicasEdit.CreateForm(AElementId, AListProc, AId);
  end;

begin
  ShowCrudContainer(TFViewFs_Prod_CaracteristicasList, 'Características', @CreateFs_Prod_CaracteristicasListForm, @CreateFs_Prod_CaracteristicasEditForm);
end;

procedure TFViewMain.fs_prod_categoriasClick(Sender: TObject);
  function CreateFs_Prod_CategoriasListForm(const AElementId: string; AEditProc: TEditProc): TForm;
  begin
    Result := TFViewFs_Prod_CategoriasList.CreateForm(AElementId, AEditProc);
  end;

  function CreateFs_Prod_CategoriasEditForm(const AElementId: string; AListProc: TListProc;
    AId: JSValue): TForm;
  begin
    Result := TFViewFs_Prod_CategoriasEdit.CreateForm(AElementId, AListProc, AId);
  end;

begin
  ShowCrudContainer(TFViewFs_Prod_CategoriasList, 'Categorias', @CreateFs_Prod_CategoriasListForm, @CreateFs_Prod_CategoriasEditForm);
end;

procedure TFViewMain.fs_prod_departamentosClick(Sender: TObject);
  function CreateFs_Prod_DepartamentosListForm(const AElementId: string; AEditProc: TEditProc): TForm;
  begin
    Result := TFViewFs_Prod_DepartamentosList.CreateForm(AElementId, AEditProc);
  end;

  function CreateFs_Prod_DepartamentosEditForm(const AElementId: string; AListProc: TListProc;
    AId: JSValue): TForm;
  begin
    Result := TFViewFs_Prod_DepartamentosEdit.CreateForm(AElementId, AListProc, AId);
  end;

begin
  ShowCrudContainer(TFViewFs_Prod_DepartamentosList, 'Departamentos', @CreateFs_Prod_DepartamentosListForm, @CreateFs_Prod_DepartamentosEditForm);
end;

procedure TFViewMain.fs_prod_fabricantesClick(Sender: TObject);
  function CreateFs_Prod_FabricantesListForm(const AElementId: string; AEditProc: TEditProc): TForm;
  begin
    Result := TFViewFs_Prod_FabricantesList.CreateForm(AElementId, AEditProc);
  end;

  function CreateFs_Prod_FabricantesEditForm(const AElementId: string; AListProc: TListProc;
    AId: JSValue): TForm;
  begin
    Result := TFViewFs_Prod_FabricantesEdit.CreateForm(AElementId, AListProc, AId);
  end;

begin
  ShowCrudContainer(TFViewFs_Prod_FabricantesList, 'Fabricantes', @CreateFs_Prod_FabricantesListForm, @CreateFs_Prod_FabricantesEditForm);
end;

procedure TFViewMain.fs_prod_marcasClick(Sender: TObject);
  function CreateFs_Prod_MarcasListForm(const AElementId: string; AEditProc: TEditProc): TForm;
  begin
    Result := TFViewFs_Prod_MarcasList.CreateForm(AElementId, AEditProc);
  end;

  function CreateFs_Prod_MarcasEditForm(const AElementId: string; AListProc: TListProc;
    AId: JSValue): TForm;
  begin
    Result := TFViewFs_Prod_MarcasEdit.CreateForm(AElementId, AListProc, AId);
  end;

begin
  ShowCrudContainer(TFViewFs_Prod_MarcasList, 'Marcas', @CreateFs_Prod_MarcasListForm, @CreateFs_Prod_MarcasEditForm);
end;

procedure TFViewMain.fs_prod_produtosClick(Sender: TObject);

  function CreateFs_Prod_ProdutosListForm(const AElementId: string; AEditProc: TEditProc): TForm;
  begin
    Result := TFViewFs_Prod_ProdutosList.CreateForm(AElementId, AEditProc);
  end;

  function CreateFs_Prod_ProdutosEditForm(const AElementId: string; AListProc: TListProc;
    AId: JSValue): TForm;
  begin
    Result := TFViewFs_Prod_ProdutosEdit.CreateForm(AElementId, AListProc, AId);
  end;

begin
  ShowCrudContainer(TFViewFs_Prod_ProdutosList, 'Produtos', @CreateFs_Prod_ProdutosListForm, @CreateFs_Prod_ProdutosEditForm);
end;

procedure TFViewMain.fs_prod_subcategoriasClick(Sender: TObject);
  function CreateFs_Prod_SubCategoriasListForm(const AElementId: string; AEditProc: TEditProc): TForm;
  begin
    Result := TFViewFs_Prod_SubCategoriasList.CreateForm(AElementId, AEditProc);
  end;

  function CreateFs_Prod_SubCategoriasEditForm(const AElementId: string; AListProc: TListProc;
    AId: JSValue): TForm;
  begin
    Result := TFViewFs_Prod_SubCategoriasEdit.CreateForm(AElementId, AListProc, AId);
  end;

begin
  ShowCrudContainer(TFViewFs_Prod_SubCategoriasList, 'SubCategorias', @CreateFs_Prod_SubCategoriasListForm, @CreateFs_Prod_SubCategoriasEditForm);
end;

procedure TFViewMain.fs_prod_subdepartamentosClick(Sender: TObject);
  function CreateFs_Prod_SubDepartamentosListForm(const AElementId: string; AEditProc: TEditProc): TForm;
  begin
    Result := TFViewFs_Prod_SubDepartamentosList.CreateForm(AElementId, AEditProc);
  end;

  function CreateFs_Prod_SubDepartamentosEditForm(const AElementId: string; AListProc: TListProc;
    AId: JSValue): TForm;
  begin
    Result := TFViewFs_Prod_SubDepartamentosEdit.CreateForm(AElementId, AListProc, AId);
  end;

begin
  ShowCrudContainer(TFViewFs_Prod_SubDepartamentosList, 'SubDepartamentos', @CreateFs_Prod_SubDepartamentosListForm, @CreateFs_Prod_SubDepartamentosEditForm);
end;

procedure TFViewMain.funcionariosClick(Sender: TObject);
  function CreateFuncionariosListForm(const AElementId: string; AEditProc: TEditProc): TForm;
  begin
    Result := TFViewFuncionariosList.CreateForm(AElementId, AEditProc);
  end;

  function CreateFuncionariosEditForm(const AElementId: string; AListProc: TListProc;
    AId: JSValue): TForm;
  begin
    Result := TFViewFuncionariosEdit.CreateForm(AElementId, AListProc, AId);
  end;

begin
  ShowCrudContainer(TFViewFuncionariosList, 'Funcionarios', @CreateFuncionariosListForm, @CreateFuncionariosEditForm);
end;

procedure TFViewMain.GerarLog(pAliadoId: Integer; pTabela, pOperacao, pLog: string);
begin
  cdsLogsSistema.Close;
  cdsLogsSistema.SetJsonData('{}');
  cdsLogsSistema.Open;
  cdsLogsSistema.Insert;

  cdsLogsSistema.Append;

  if pAliadoId > 0 then
    cdsLogsSistema.FieldByName('aliado_id').AsInteger := pAliadoId;

  cdsLogsSistema.FieldByName('tabela').AsString := pTabela;
  cdsLogsSistema.FieldByName('operacao').AsString := pOperacao;
  cdsLogsSistema.FieldByName('log').AsString := pLog;

  cdsLogsSistema.Post;
  cdsLogsSistema.ApplyUpdates;
end;

function TFViewMain.GetKeyByValue(lIndice: Integer): Integer;
var
  lPair: TPair<Integer, Integer>;
begin
  Result := 0;

  for lPair in FDicionarioBancos do
  begin
    if lPair.Value = lIndice then
    begin
      Result := lPair.Key;
      Exit;
    end;
  end;
end;

procedure TFViewMain.grade_colunasClick(Sender: TObject);
  function CreateGrade_ColunasListForm(const AElementId: string; AEditProc: TEditProc): TForm;
  begin
    Result := TFViewGrade_ColunasList.CreateForm(AElementId, AEditProc);
  end;

  function CreateGrade_ColunasEditForm(const AElementId: string; AListProc: TListProc;
    AId: JSValue): TForm;
  begin
    Result := TFViewGrade_ColunasEdit.CreateForm(AElementId, AListProc, AId);
  end;

begin
  ShowCrudContainer(TFViewGrade_ColunasList, 'Grade_Colunas', @CreateGrade_ColunasListForm, @CreateGrade_ColunasEditForm);
end;

procedure TFViewMain.grade_descricoesClick(Sender: TObject);
  function CreateGrade_DescricoesListForm(const AElementId: string; AEditProc: TEditProc): TForm;
  begin
    Result := TFViewGrade_DescricoesList.CreateForm(AElementId, AEditProc);
  end;

  function CreateGrade_DescricoesEditForm(const AElementId: string; AListProc: TListProc;
    AId: JSValue): TForm;
  begin
    Result := TFViewGrade_DescricoesEdit.CreateForm(AElementId, AListProc, AId);
  end;

begin
  ShowCrudContainer(TFViewGrade_DescricoesList, 'Grade_Descricoes', @CreateGrade_DescricoesListForm, @CreateGrade_DescricoesEditForm);
end;

procedure TFViewMain.grade_linhasClick(Sender: TObject);
  function CreateGrade_LinhasListForm(const AElementId: string; AEditProc: TEditProc): TForm;
  begin
    Result := TFViewGrade_LinhasList.CreateForm(AElementId, AEditProc);
  end;

  function CreateGrade_LinhasEditForm(const AElementId: string; AListProc: TListProc;
    AId: JSValue): TForm;
  begin
    Result := TFViewGrade_LinhasEdit.CreateForm(AElementId, AListProc, AId);
  end;

begin
  ShowCrudContainer(TFViewGrade_LinhasList, 'Grade_Linhas', @CreateGrade_LinhasListForm, @CreateGrade_LinhasEditForm);
end;

procedure TFViewMain.grade_produtosClick(Sender: TObject);
  function CreateGrade_ProdutosListForm(const AElementId: string; AEditProc: TEditProc): TForm;
  begin
    Result := TFViewGrade_ProdutosList.CreateForm(AElementId, AEditProc);
  end;

  function CreateGrade_ProdutosEditForm(const AElementId: string; AListProc: TListProc;
    AId: JSValue): TForm;
  begin
    Result := TFViewGrade_ProdutosEdit.CreateForm(AElementId, AListProc, AId);
  end;

begin
  ShowCrudContainer(TFViewGrade_ProdutosList, 'Grade_Produtos', @CreateGrade_ProdutosListForm, @CreateGrade_ProdutosEditForm);
end;

procedure TFViewMain.gruposClick(Sender: TObject);
  function CreateGruposListForm(const AElementId: string; AEditProc: TEditProc): TForm;
  begin
    Result := TFViewGruposList.CreateForm(AElementId, AEditProc);
  end;

  function CreateGruposEditForm(const AElementId: string; AListProc: TListProc;
    AId: JSValue): TForm;
  begin
    Result := TFViewGruposEdit.CreateForm(AElementId, AListProc, AId);
  end;

begin
  ShowCrudContainer(TFViewGruposList, 'Grupos', @CreateGruposListForm, @CreateGruposEditForm);
end;

procedure TFViewMain.homeClick(Sender: TObject);
begin
  ShowForm(TFViewHome);
end;

procedure TFViewMain.itens_cuponsClick(Sender: TObject);
  function CreateItens_CuponsListForm(const AElementId: string; AEditProc: TEditProc): TForm;
  begin
    Result := TFViewItens_CuponsList.CreateForm(AElementId, AEditProc);
  end;

  function CreateItens_CuponsEditForm(const AElementId: string; AListProc: TListProc;
    AId: JSValue): TForm;
  begin
    Result := TFViewItens_CuponsEdit.CreateForm(AElementId, AListProc, AId);
  end;

begin
  ShowCrudContainer(TFViewItens_CuponsList, 'Itens_Cupons', @CreateItens_CuponsListForm, @CreateItens_CuponsEditForm);
end;

procedure TFViewMain.itens_entradaClick(Sender: TObject);
  function CreateItens_EntradaListForm(const AElementId: string; AEditProc: TEditProc): TForm;
  begin
    Result := TFViewItens_EntradaList.CreateForm(AElementId, AEditProc);
  end;

  function CreateItens_EntradaEditForm(const AElementId: string; AListProc: TListProc;
    AId: JSValue): TForm;
  begin
    Result := TFViewItens_EntradaEdit.CreateForm(AElementId, AListProc, AId);
  end;

begin
  ShowCrudContainer(TFViewItens_EntradaList, 'Itens_Entrada', @CreateItens_EntradaListForm, @CreateItens_EntradaEditForm);
end;

procedure TFViewMain.SelecionarNoCombo(pId: Integer);
var
  lIndex: Integer;
begin
  if FDicionarioBancos.TryGetValue(pId, lIndex) then
    cbbDataBase.ItemIndex := lIndex
  else
    cbbDataBase.ItemIndex := 0;

  FIndice := cbbDataBase.ItemIndex;
end;

procedure TFViewMain.servicosClick(Sender: TObject);
  function CreateServicosListForm(const AElementId: string; AEditProc: TEditProc): TForm;
  begin
    Result := TFViewServicosList.CreateForm(AElementId, AEditProc);
  end;

  function CreateServicosEditForm(const AElementId: string; AListProc: TListProc;
    AId: JSValue): TForm;
  begin
    Result := TFViewServicosEdit.CreateForm(AElementId, AListProc, AId);
  end;

begin
  ShowCrudContainer(TFViewServicosList, 'Serviços', @CreateServicosListForm, @CreateServicosEditForm);
end;

procedure TFViewMain.servicos_nacionalClick(Sender: TObject);
  function CreateServicos_NacionalListForm(const AElementId: string; AEditProc: TEditProc): TForm;
  begin
    Result := TFViewServicos_NacionalList.CreateForm(AElementId, AEditProc);
  end;

  function CreateServicos_NacionalEditForm(const AElementId: string; AListProc: TListProc;
    AId: JSValue): TForm;
  begin
    Result := TFViewServicos_NacionalEdit.CreateForm(AElementId, AListProc, AId);
  end;

begin
  ShowCrudContainer(TFViewServicos_NacionalList, 'Serviços_Nacional', @CreateServicos_NacionalListForm, @CreateServicos_NacionalEditForm);
end;

procedure TFViewMain.SetPermissoes;
var
  lResponse: TXDataClientResponse;
begin
  lResponse := await(XDataWebClientPermissoes.RawInvokeAsync('IService.GetPermissoesUsuario', []));
  await(TUtils.CarregarPermissoes(lResponse.ResultAsArray, Js.toInteger(AuthService.TokenPayload.Properties['perfil'])));
end;

procedure TFViewMain.ShowCrudContainer(ACrudFormClass: TFormClass; ATitle: string;
  AShowCrudListProc: TShowCrudListProc; AShowCrudEditProc: TShowCrudEditProc);
// Todo CRUD passa por este ponto: menus, abertura direta por hash e retorno
// listagem/edição reutilizam os callbacks existentes sem duplicar lógica por tela.

  function CreateAlbumListForm(const AElementId: string; AEditProc: TEditProc): TForm;
    procedure AfterCreateListForm(Form: TObject);
    begin
      TJSObject(Form)['FEditProc'] := AEditProc;
    end;
  begin
    Application.CreateForm(ACrudFormClass, AElementId, Result, @AfterCreateListForm);
  end;

  function CreateAlbumEditForm(const AElementId: string; AListProc: TListProc;
    AId: JSValue): TForm;
    procedure AfterCreateEditForm(Form: TObject);
    begin
      //TJSObject(Form)['FEditProc'] := AEditProc;
    end;
  begin
    //Application.CreateForm(ACrudFormClass, AElementId, Result, @AfterCreateListForm);

    //Result := TFViewAlbumEdit.CreateForm(AElementId, AListProc, AId);
  end;

var
  lRoute: string;
  lInitialEditId: JSValue;
begin
  lRoute := RouteFromFormClass(ACrudFormClass);
  lInitialEditId := nil;

  // FQueryProdutos e consumido apenas pela tela de produtos. Ao trocar para
  // qualquer outro CRUD, limpamos o filtro global para ele nao vazar para
  // outras rotas ou voltar a aparecer em hashes futuras.
  if (not FRouteRestoring) and (lRoute <> 'produtos') then
    THelperServer.FQueryProdutos := '';

  if FRouteRestoring and (FPendingRoute = lRoute) then
    lInitialEditId := FPendingEditId
  else
    FCurrentRouteQueryString := BuildRouteQueryString;

  SetRouteHash(lRoute);

  if Assigned(FChildForm) then
    FChildForm.Free;

  FChildForm := TFViewCrudContainer.CreateForm(WebPanel1.ElementID,
    ATitle, @CreateAlbumListForm, AShowCrudEditProc, lRoute,
    FCurrentRouteQueryString, FRouteRestoring, lInitialEditId
  );
end;

procedure TFViewMain.ShowForm(AFormClass: TFormClass);
var
  lRoute: string;
begin
  lRoute := RouteFromFormClass(AFormClass);
  THelperServer.FQueryProdutos := '';
  SetRouteHash(lRoute);

  if Assigned(FChildForm) then
    FChildForm.Free;
  Application.CreateForm(AFormClass, WebPanel1.ElementID, FChildForm);
end;

procedure TFViewMain.sincronizacao_serviceClick(Sender: TObject);
  function CreateSincronizacao_ServiceListForm(const AElementId: string; AEditProc: TEditProc): TForm;
  begin
    Result := TFViewSincronizacao_ServiceList.CreateForm(AElementId, AEditProc);
  end;

  function CreateSincronizacao_ServiceEditForm(const AElementId: string; AListProc: TListProc;
    AId: JSValue): TForm;
  begin
    Result := TFViewSincronizacao_ServiceEdit.CreateForm(AElementId, AListProc, AId);
  end;

begin
  ShowCrudContainer(TFViewSincronizacao_ServiceList, 'Sincronização Retaguarda Servidor', @CreateSincronizacao_ServiceListForm, @CreateSincronizacao_ServiceEditForm);
end;

procedure TFViewMain.sincronizacao_servidor_retaguardaClick(Sender: TObject);
  function CreateSincronizacao_Servidor_RetaguardaListForm(const AElementId: string; AEditProc: TEditProc): TForm;
  begin
    Result := TFViewSincronizacao_Servidor_RetaguardaList.CreateForm(AElementId, AEditProc);
  end;

  function CreateSincronizacao_Servidor_RetaguardaEditForm(const AElementId: string; AListProc: TListProc;
    AId: JSValue): TForm;
  begin
    Result := TFViewSincronizacao_Servidor_RetaguardaEdit.CreateForm(AElementId, AListProc, AId);
  end;

begin
  ShowCrudContainer(TFViewSincronizacao_Servidor_RetaguardaList, 'Sincronização Servidor Retaguarda', @CreateSincronizacao_Servidor_RetaguardaListForm, @CreateSincronizacao_Servidor_RetaguardaEditForm);
end;

procedure TFViewMain.subgruposClick(Sender: TObject);
  function CreateSubgruposListForm(const AElementId: string; AEditProc: TEditProc): TForm;
  begin
    Result := TFViewSubgruposList.CreateForm(AElementId, AEditProc);
  end;

  function CreateSubgruposEditForm(const AElementId: string; AListProc: TListProc;
    AId: JSValue): TForm;
  begin
    Result := TFViewSubgruposEdit.CreateForm(AElementId, AListProc, AId);
  end;

begin
  ShowCrudContainer(TFViewSubgruposList, 'Subgrupos', @CreateSubgruposListForm, @CreateSubgruposEditForm);
end;

procedure TFViewMain.tiposClick(Sender: TObject);
  function CreateTiposListForm(const AElementId: string; AEditProc: TEditProc): TForm;
  begin
    Result := TFViewTiposList.CreateForm(AElementId, AEditProc);
  end;

  function CreateTiposEditForm(const AElementId: string; AListProc: TListProc;
    AId: JSValue): TForm;
  begin
    Result := TFViewTiposEdit.CreateForm(AElementId, AListProc, AId);
  end;

begin
  ShowCrudContainer(TFViewTiposList, 'Tipos', @CreateTiposListForm, @CreateTiposEditForm);
end;

procedure TFViewMain.tmrIniciarSistemaTimer(Sender: TObject);
begin
  tmrIniciarSistema.Enabled := False;

  if Assigned(TUtils.FDicionarioPermissoes) then
  begin
    FChildForm := nil;
    FDicionarioBancos := TDictionary<Integer, Integer>.Create;
    ConfigurarUsuarioComum;
    TUtils.MostrarElemento('frmPrincipal');
  end
  else
    tmrIniciarSistema.Enabled := True;
end;

procedure TFViewMain.ufsClick(Sender: TObject);
  function CreateUFListForm(const AElementId: string; AEditProc: TEditProc): TForm;
  begin
    Result := TFViewUFList.CreateForm(AElementId, AEditProc);
  end;

  function CreateUFEditForm(const AElementId: string; AListProc: TListProc;
    AId: JSValue): TForm;
  begin
    Result := TFViewUFEdit.CreateForm(AElementId, AListProc, AId);
  end;

begin
  ShowCrudContainer(TFViewUFList, 'UF', @CreateUFListForm, @CreateUFEditForm);
end;

procedure TFViewMain.unidadesClick(Sender: TObject);
  function CreateUnidadesListForm(const AElementId: string; AEditProc: TEditProc): TForm;
  begin
    Result := TFViewUnidadesList.CreateForm(AElementId, AEditProc);
  end;

  function CreateUnidadesEditForm(const AElementId: string; AListProc: TListProc;
    AId: JSValue): TForm;
  begin
    Result := TFViewUnidadesEdit.CreateForm(AElementId, AListProc, AId);
  end;

begin
  ShowCrudContainer(TFViewUnidadesList, 'Unidades', @CreateUnidadesListForm, @CreateUnidadesEditForm);
end;

procedure TFViewMain.usuariosClick(Sender: TObject);
  function CreateUsuariosListForm(const AElementId: string; AEditProc: TEditProc): TForm;
  begin
    Result := TFViewUsuariosList.CreateForm(AElementId, AEditProc);
  end;

  function CreateUsuariosEditForm(const AElementId: string; AListProc: TListProc;
    AId: JSValue): TForm;
  begin
    Result := TFViewUsuariosEdit.CreateForm(AElementId, AListProc, AId);
  end;

begin
  ShowCrudContainer(TFViewUsuariosList, 'Usuarios', @CreateUsuariosListForm, @CreateUsuariosEditForm);
end;

procedure TFViewMain.vendasClick(Sender: TObject);
  function CreateVendasListForm(const AElementId: string; AEditProc: TEditProc): TForm;
  begin
    Result := TFViewVendasList.CreateForm(AElementId, AEditProc);
  end;

  function CreateVendasEditForm(const AElementId: string; AListProc: TListProc;
    AId: JSValue): TForm;
  begin
    Result := TFViewVendasEdit.CreateForm(AElementId, AListProc, AId);
  end;

begin
  ShowCrudContainer(TFViewVendasList, 'Vendas', @CreateVendasListForm, @CreateVendasEditForm);
end;

procedure TFViewMain.vendas_servicosClick(Sender: TObject);
  function CreateVendas_ServicosListForm(const AElementId: string; AEditProc: TEditProc): TForm;
  begin
    Result := TFViewVendas_ServicosList.CreateForm(AElementId, AEditProc);
  end;

  function CreateVendas_ServicosEditForm(const AElementId: string; AListProc: TListProc;
    AId: JSValue): TForm;
  begin
    Result := TFViewVendas_ServicosEdit.CreateForm(AElementId, AListProc, AId);
  end;

begin
  ShowCrudContainer(TFViewVendas_ServicosList, 'Vendas Serviços', @CreateVendas_ServicosListForm, @CreateVendas_ServicosEditForm);
end;

procedure TFViewMain.versoesClick(Sender: TObject);
  function CreateVersoesListForm(const AElementId: string; AEditProc: TEditProc): TForm;
  begin
    Result := TFViewVersoesList.CreateForm(AElementId, AEditProc);
  end;

  function CreateVersoesEditForm(const AElementId: string; AListProc: TListProc;
    AId: JSValue): TForm;
  begin
    Result := TFViewVersoesEdit.CreateForm(AElementId, AListProc, AId);
  end;

begin
  ShowCrudContainer(TFViewVersoesList, 'Versões', @CreateVersoesListForm, @CreateVersoesEditForm);
end;

procedure TFViewMain.LoadDFMValues;
begin
  inherited LoadDFMValues;

  WebLinkLabel6 := TLinkLabel.Create('main.menu.logout');
  lbUsername := TLabel.Create('view.main.username');
  lblLogo := TLinkLabel.Create('logo_img');
  lblEmpresalogin := TLinkLabel.Create('empresa_logada');
  aliado_logado := TLabel.Create('aliado_logado');
  lbMeuperfil := TLabel.Create('main.menu.meu_perfil');
  WebPanel1 := TPanel.Create('main.webpanel');
  div_bancos_usuario := THTMLDiv.Create('dados_banco_usuario');
  cbbDataBase := TComboBox.Create('cbbSelecionarDataBase');
  div_empresa_login := THTMLDiv.Create('div_empresa_login');
  div_aliado_login := THTMLDiv.Create('div_aliado_login');
  aliado_conectado_topo := THTMLDiv.Create('aliado_conectado_topo');
  nome_aliado_conectado_topo := TLabel.Create('nome_aliado_conectado_topo');
  btnDesconectar := TButton.Create('desconectar');
  menu_nfse := THTMLDiv.Create('menu_nfse');
  provedores := THTMLDiv.Create('provedores');
  lbViewProvedores := TLinkLabel.Create('main.menu.provedores');
  consulta_nfse := THTMLDiv.Create('consulta_nfse');
  lbViewConsultaNfse := TLinkLabel.Create('main.menu.consulta_nfse');
  home := THTMLDiv.Create('home');
  lbViewHome := TLinkLabel.Create('main.menu.home');
  aliado := THTMLDiv.Create('aliado');
  lbViewAliado := TLinkLabel.Create('main.menu.aliado');
  logs_sistema := THTMLDiv.Create('logs_sistema');
  lbViewLogs_Sistema := TLinkLabel.Create('main.menu.logs_sistema');
  menu_scripts := THTMLDiv.Create('menu_scripts');
  scripts := THTMLDiv.Create('scripts');
  lbViewScripts := TLinkLabel.Create('main.menu.scripts');
  scripts_aliados := THTMLDiv.Create('scripts_aliados');
  lbViewScripts_Aliados := TLinkLabel.Create('main.menu.scripts_aliados');
  versoes := THTMLDiv.Create('versoes');
  lbViewVersoes := TLinkLabel.Create('main.menu.versoes');
  menu_apis_externas := THTMLDiv.Create('menu_apis_externas');
  api_veiculos := THTMLDiv.Create('api_veiculos');
  lbViewApi_Veiculos := TLinkLabel.Create('main.menu.api_veiculos');
  api_cpfs := THTMLDiv.Create('api_cpfs');
  lbViewApi_Cpfs := TLinkLabel.Create('main.menu.api_cpfs');
  menu_fs_produtos := THTMLDiv.Create('menu_fs_produtos');
  fs_prod_produtos := THTMLDiv.Create('fs_prod_produtos');
  lbViewFs_Prod_Produtos := TLinkLabel.Create('main.menu.fs_prod_produtos');
  fs_prod_marcas := THTMLDiv.Create('fs_prod_marcas');
  lbViewFs_Prod_Marcas := TLinkLabel.Create('main.menu.fs_prod_marcas');
  fs_prod_fabricantes := THTMLDiv.Create('fs_prod_fabricantes');
  lbViewFs_Prod_Fabricantes := TLinkLabel.Create('main.menu.fs_prod_fabricantes');
  fs_prod_categorias := THTMLDiv.Create('fs_prod_categorias');
  lbViewFs_Prod_Categorias := TLinkLabel.Create('main.menu.fs_prod_categorias');
  fs_prod_subcategorias := THTMLDiv.Create('fs_prod_subcategorias');
  lbViewFs_Prod_SubCategorias := TLinkLabel.Create('main.menu.fs_prod_subcategorias');
  fs_prod_departamentos := THTMLDiv.Create('fs_prod_departamentos');
  lbViewFs_Prod_Departamentos := TLinkLabel.Create('main.menu.fs_prod_departamentos');
  fs_prod_subdepartamentos := THTMLDiv.Create('fs_prod_subdepartamentos');
  lbViewFs_Prod_SubDepartamentos := TLinkLabel.Create('main.menu.fs_prod_subdepartamentos');
  fs_prod_caracteristicas := THTMLDiv.Create('fs_prod_caracteristicas');
  lbViewFs_Prod_Caracteristicas := TLinkLabel.Create('main.menu.fs_prod_caracteristicas');
  menu_facil_planos := THTMLDiv.Create('menu_facil_planos');
  facil_planos := THTMLDiv.Create('facil_planos');
  lbViewFacil_Planos := TLinkLabel.Create('main.menu.facil_planos');
  facil_planos_aliados := THTMLDiv.Create('facil_planos_aliados');
  lbViewPlanos_Aliados := TLinkLabel.Create('main.menu.aliados_planos');
  boletos := THTMLDiv.Create('boletos');
  lbViewBoletos := TLinkLabel.Create('main.menu.boletos');
  lancamentos := THTMLDiv.Create('lancamentos');
  lbViewLancamentos := TLinkLabel.Create('main.menu.lancamentos');
  menu_recebimentos := THTMLDiv.Create('menu_recebimentos');
  areceber := THTMLDiv.Create('areceber');
  lbViewAreceber := TLinkLabel.Create('main.menu.areceber');
  recebimentos := THTMLDiv.Create('recebimentos');
  lbViewRecebimentos := TLinkLabel.Create('main.menu.recebimentos');
  menu_pagamentos := THTMLDiv.Create('menu_pagamentos');
  apagar := THTMLDiv.Create('apagar');
  lbViewApagar := TLinkLabel.Create('main.menu.apagar');
  pagamentos := THTMLDiv.Create('pagamentos');
  lbViewPagamentos := TLinkLabel.Create('main.menu.pagamentos');
  menu_localidades := THTMLDiv.Create('menu_localidades');
  cidade := THTMLDiv.Create('cidade');
  lbViewCidade := TLinkLabel.Create('main.menu.cidades');
  ufs := THTMLDiv.Create('ufs');
  lbViewUF := TLinkLabel.Create('main.menu.ufs');
  menu_sincronizacao := THTMLDiv.Create('menu_sincronizacao');
  sincronizacao_service := THTMLDiv.Create('sincronizacao_service');
  lbViewSincronizacao_Service := TLinkLabel.Create('main.menu.sincronizacao_service');
  erros_catalogados := THTMLDiv.Create('erros_catalogados');
  lbViewErros_Catalogados := TLinkLabel.Create('main.menu.erros_catalogados');
  sincronizacao_servidor_retaguarda := THTMLDiv.Create('sincronizacao_servidor_retaguarda');
  lbViewSincronizacao_Servidor_Retaguarda := TLinkLabel.Create('main.menu.sincronizacao_servidor_retaguarda');
  menu_tributacoes := THTMLDiv.Create('menu_tributacoes');
  ncm := THTMLDiv.Create('ncm');
  lbViewNcm := TLinkLabel.Create('main.menu.ncm');
  cfop := THTMLDiv.Create('cfop');
  lbViewCfop := TLinkLabel.Create('main.menu.cfop');
  menu_reforma_tributaria := THTMLDiv.Create('menu_reforma_tributaria');
  rt_ibs_cbs_cst := THTMLDiv.Create('rt_ibs_cbs_cst');
  lbViewRt_Ibs_Cbs_Cst := TLinkLabel.Create('main.menu.rt_ibs_cbs_cst');
  rt_is_cst := THTMLDiv.Create('rt_is_cst');
  lbViewRt_Is_Cst := TLinkLabel.Create('main.menu.rt_is_cst');
  rt_credito_presumido := THTMLDiv.Create('rt_credito_presumido');
  lbViewRt_Credito_Presumido := TLinkLabel.Create('main.menu.rt_credito_presumido');
  cfop_configuracoes := THTMLDiv.Create('cfop_configuracoes');
  lbViewCfop_Configuracoes := TLinkLabel.Create('main.menu.cfop_configuracoes');
  cst := THTMLDiv.Create('cst');
  lbViewCst := TLinkLabel.Create('main.menu.cst');
  cst_pis := THTMLDiv.Create('cst_pis');
  lbViewCst_Pis := TLinkLabel.Create('main.menu.cst_pis');
  cst_cofins := THTMLDiv.Create('cst_cofins');
  lbViewCst_Cofins := TLinkLabel.Create('main.menu.cst_cofins');
  cst_ipi := THTMLDiv.Create('cst_ipi');
  lbViewCst_Ipi := TLinkLabel.Create('main.menu.cst_ipi');
  codigo_bc_piscofins := THTMLDiv.Create('codigo_bc_piscofins');
  lbViewCodigo_bc_Piscofins := TLinkLabel.Create('main.menu.codigo_bc_piscofins');
  origem_csosn := THTMLDiv.Create('origem_csosn');
  lbViewOrigem_Csosn := TLinkLabel.Create('main.menu.origem_csosn');
  codigo_credito_piscofins := THTMLDiv.Create('codigo_credito_piscofins');
  lbViewCodigo_Credito_Piscofins := TLinkLabel.Create('main.menu.codigo_credito_piscofins');
  desoneracao_icms := THTMLDiv.Create('desoneracao_icms');
  lbViewDesoneracao_Icms := TLinkLabel.Create('main.menu.desoneracao_icms');
  csosn := THTMLDiv.Create('csosn');
  lbViewCsosn := TLinkLabel.Create('main.menu.csosn');
  servicos_nacional := THTMLDiv.Create('servicos_nacional');
  lbViewServicos_Nacional := TLinkLabel.Create('main.menu.servicos_nacional');
  nbs := THTMLDiv.Create('nbs');
  lbViewNbs := TLinkLabel.Create('main.menu.nbs');
  menu_cadastros := THTMLDiv.Create('menu_cadastros');
  promocoes := THTMLDiv.Create('promocoes');
  lbViewPromocoes := TLinkLabel.Create('main.menu.promocoes');
  funcionarios := THTMLDiv.Create('funcionarios');
  lbViewFuncionarios := TLinkLabel.Create('main.menu.funcionarios');
  clientes := THTMLDiv.Create('clientes');
  lbViewClientes := TLinkLabel.Create('main.menu.clientes');
  modalidades := THTMLDiv.Create('modalidades');
  lbViewModalidades := TLinkLabel.Create('main.menu.modalidades');
  aliquotas := THTMLDiv.Create('aliquotas');
  lbViewAliquotas := TLinkLabel.Create('main.menu.aliquotas');
  parceiros := THTMLDiv.Create('parceiros');
  lbViewParceiros := TLinkLabel.Create('main.menu.parceiros');
  contas := THTMLDiv.Create('contas');
  lbViewContas := TLinkLabel.Create('main.menu.contas');
  bancos := THTMLDiv.Create('bancos');
  lbViewBancos := TLinkLabel.Create('main.menu.bancos');
  banco_carteiras := THTMLDiv.Create('banco_carteiras');
  lbViewBanco_Carteiras := TLinkLabel.Create('main.menu.banco_carteiras');
  operadoras_cartao := THTMLDiv.Create('operadoras_cartao');
  lbViewOperadoras_Cartao := TLinkLabel.Create('main.menu.operadoras_cartao');
  contadores := THTMLDiv.Create('contadores');
  lbViewContadores := TLinkLabel.Create('main.menu.contadores');
  fornecedores := THTMLDiv.Create('fornecedores');
  lbViewFornecedores := TLinkLabel.Create('main.menu.fornecedores');
  tipos := THTMLDiv.Create('tipos');
  lbViewTipos := TLinkLabel.Create('main.menu.tipos');
  modulos := THTMLDiv.Create('modulos');
  lbViewModulos := TLinkLabel.Create('main.menu.modulos');
  pdvs := THTMLDiv.Create('pdvs');
  lbViewPdvs := TLinkLabel.Create('main.menu.pdvs');
  segmentos := THTMLDiv.Create('segmentos');
  lbViewSegmento := TLinkLabel.Create('main.menu.segmento');
  menu_plano_contas := THTMLDiv.Create('menu_plano_contas');
  plano_contas := THTMLDiv.Create('plano_contas');
  lbViewPlano_Contas := TLinkLabel.Create('main.menu.plano_contas');
  plano_contas_contabil := THTMLDiv.Create('plano_contas_contabil');
  lbViewPlano_Contas_Contabil := TLinkLabel.Create('main.menu.plano_contas_contabil');
  plano_contas2 := THTMLDiv.Create('plano_contas2');
  lbViewPlano_Contas2 := TLinkLabel.Create('main.menu.plano_contas2');
  plano_contas1 := THTMLDiv.Create('plano_contas1');
  lbViewPlano_Contas1 := TLinkLabel.Create('main.menu.plano_contas1');
  plano_contas3 := THTMLDiv.Create('plano_contas3');
  lbViewPlano_Contas3 := TLinkLabel.Create('main.menu.plano_contas3');
  servicos := THTMLDiv.Create('servicos');
  lbViewServicos := TLinkLabel.Create('main.menu.servicos');
  menu_vendas := THTMLDiv.Create('menu_vendas');
  vendas := THTMLDiv.Create('vendas');
  lbViewVendas := TLinkLabel.Create('main.menu.vendas');
  vendas_servicos := THTMLDiv.Create('vendas_servicos');
  lbViewVendasServicos := TLinkLabel.Create('main.menu.vendas_servicos');
  cupons := THTMLDiv.Create('cupons');
  lbViewCupons := TLinkLabel.Create('main.menu.cupons');
  menu_documentos_fiscais := THTMLDiv.Create('menu_documentos_fiscais');
  nfe := THTMLDiv.Create('nfe');
  lbViewNfe := TLinkLabel.Create('main.menu.nfe');
  nfse := THTMLDiv.Create('nfse');
  lbViewNfse := TLinkLabel.Create('main.menu.nfse');
  painel_aliados := THTMLDiv.Create('painel_aliados');
  lbViewPainelAliados := TLinkLabel.Create('main.menu.painel_aliados');
  relatorios := THTMLDiv.Create('relatorios');
  lbViewRelatorios := TLinkLabel.Create('main.menu.relatorios');
  compras := THTMLDiv.Create('compras');
  lbViewCompras := TLinkLabel.Create('main.menu.compras');
  usuarios := THTMLDiv.Create('usuarios');
  lbViewUsuarios := TLinkLabel.Create('main.menu.usuarios');
  menu_produtos := THTMLDiv.Create('menu_produtos');
  produtos := THTMLDiv.Create('produtos');
  lbViewProdutos := TLinkLabel.Create('main.menu.produtos');
  grupos := THTMLDiv.Create('grupos');
  lbViewGrupos := TLinkLabel.Create('main.menu.grupos');
  unidades := THTMLDiv.Create('unidades');
  lbViewUnidades := TLinkLabel.Create('main.menu.unidades');
  subgrupos := THTMLDiv.Create('subgrupos');
  lbViewSubgrupos := TLinkLabel.Create('main.menu.subgrupos');
  menu_grades := THTMLDiv.Create('menu_grades');
  grade_produtos := THTMLDiv.Create('grade_produtos');
  lbViewGrade_Produtos := TLinkLabel.Create('main.menu.grade_produtos');
  grade_descricoes := THTMLDiv.Create('grade_descricoes');
  lbViewGrade_Descricoes := TLinkLabel.Create('main.menu.grade_descricoes');
  grade_colunas := THTMLDiv.Create('grade_colunas');
  lbViewGrade_Colunas := TLinkLabel.Create('main.menu.grade_colunas');
  grade_linhas := THTMLDiv.Create('grade_linhas');
  lbViewGrade_Linhas := TLinkLabel.Create('main.menu.grade_linhas');
  cdsDataBase := TXDataWebDataSet.Create(Self);
  cdsDataBaseid := TIntegerField.Create(Self);
  cdsDataBasenome_fantasia := TStringField.Create(Self);
  cdsDataBaseassociar_produtos := TBooleanField.Create(Self);
  dwcGetUsuario := TXDataWebClient.Create(Self);
  cdsUsuarios := TXDataWebDataSet.Create(Self);
  cdsUsuariosid := TIntegerField.Create(Self);
  cdsUsuariosdata_base_id := TIntegerField.Create(Self);
  cdsUsuariosaliado_id := TIntegerField.Create(Self);
  cdsUsuariosperfil := TIntegerField.Create(Self);
  cdsUsuariosnome := TStringField.Create(Self);
  cdsUsuariosperfil_acesso := TStringField.Create(Self);
  dwcGetDadosEmpresaLogado := TXDataWebClient.Create(Self);
  cdsLogsSistema := TXDataWebDataSet.Create(Self);
  cdsLogsSistemaaliado_id := TIntegerField.Create(Self);
  cdsLogsSistematabela := TStringField.Create(Self);
  cdsLogsSistemaoperacao := TStringField.Create(Self);
  cdsLogsSistemalog := TStringField.Create(Self);
  XDataWebClientPermissoes := TXDataWebClient.Create(Self);
  tmrIniciarSistema := TTimer.Create(Self);
  cdsPersonalizacaoTabelas := TXDataWebDataSet.Create(Self);
  cdsPersonalizacaoTabelasid := TIntegerField.Create(Self);
  cdsPersonalizacaoTabelasusuario_id := TIntegerField.Create(Self);
  cdsPersonalizacaoTabelastabela_frontend := TStringField.Create(Self);
  cdsPersonalizacaoTabelaspersonalizacao := TStringField.Create(Self);

  WebLinkLabel6.BeforeLoadDFMValues;
  lbUsername.BeforeLoadDFMValues;
  lblLogo.BeforeLoadDFMValues;
  lblEmpresalogin.BeforeLoadDFMValues;
  aliado_logado.BeforeLoadDFMValues;
  lbMeuperfil.BeforeLoadDFMValues;
  WebPanel1.BeforeLoadDFMValues;
  div_bancos_usuario.BeforeLoadDFMValues;
  cbbDataBase.BeforeLoadDFMValues;
  div_empresa_login.BeforeLoadDFMValues;
  div_aliado_login.BeforeLoadDFMValues;
  aliado_conectado_topo.BeforeLoadDFMValues;
  nome_aliado_conectado_topo.BeforeLoadDFMValues;
  btnDesconectar.BeforeLoadDFMValues;
  menu_nfse.BeforeLoadDFMValues;
  provedores.BeforeLoadDFMValues;
  lbViewProvedores.BeforeLoadDFMValues;
  consulta_nfse.BeforeLoadDFMValues;
  lbViewConsultaNfse.BeforeLoadDFMValues;
  home.BeforeLoadDFMValues;
  lbViewHome.BeforeLoadDFMValues;
  aliado.BeforeLoadDFMValues;
  lbViewAliado.BeforeLoadDFMValues;
  logs_sistema.BeforeLoadDFMValues;
  lbViewLogs_Sistema.BeforeLoadDFMValues;
  menu_scripts.BeforeLoadDFMValues;
  scripts.BeforeLoadDFMValues;
  lbViewScripts.BeforeLoadDFMValues;
  scripts_aliados.BeforeLoadDFMValues;
  lbViewScripts_Aliados.BeforeLoadDFMValues;
  versoes.BeforeLoadDFMValues;
  lbViewVersoes.BeforeLoadDFMValues;
  menu_apis_externas.BeforeLoadDFMValues;
  api_veiculos.BeforeLoadDFMValues;
  lbViewApi_Veiculos.BeforeLoadDFMValues;
  api_cpfs.BeforeLoadDFMValues;
  lbViewApi_Cpfs.BeforeLoadDFMValues;
  menu_fs_produtos.BeforeLoadDFMValues;
  fs_prod_produtos.BeforeLoadDFMValues;
  lbViewFs_Prod_Produtos.BeforeLoadDFMValues;
  fs_prod_marcas.BeforeLoadDFMValues;
  lbViewFs_Prod_Marcas.BeforeLoadDFMValues;
  fs_prod_fabricantes.BeforeLoadDFMValues;
  lbViewFs_Prod_Fabricantes.BeforeLoadDFMValues;
  fs_prod_categorias.BeforeLoadDFMValues;
  lbViewFs_Prod_Categorias.BeforeLoadDFMValues;
  fs_prod_subcategorias.BeforeLoadDFMValues;
  lbViewFs_Prod_SubCategorias.BeforeLoadDFMValues;
  fs_prod_departamentos.BeforeLoadDFMValues;
  lbViewFs_Prod_Departamentos.BeforeLoadDFMValues;
  fs_prod_subdepartamentos.BeforeLoadDFMValues;
  lbViewFs_Prod_SubDepartamentos.BeforeLoadDFMValues;
  fs_prod_caracteristicas.BeforeLoadDFMValues;
  lbViewFs_Prod_Caracteristicas.BeforeLoadDFMValues;
  menu_facil_planos.BeforeLoadDFMValues;
  facil_planos.BeforeLoadDFMValues;
  lbViewFacil_Planos.BeforeLoadDFMValues;
  facil_planos_aliados.BeforeLoadDFMValues;
  lbViewPlanos_Aliados.BeforeLoadDFMValues;
  boletos.BeforeLoadDFMValues;
  lbViewBoletos.BeforeLoadDFMValues;
  lancamentos.BeforeLoadDFMValues;
  lbViewLancamentos.BeforeLoadDFMValues;
  menu_recebimentos.BeforeLoadDFMValues;
  areceber.BeforeLoadDFMValues;
  lbViewAreceber.BeforeLoadDFMValues;
  recebimentos.BeforeLoadDFMValues;
  lbViewRecebimentos.BeforeLoadDFMValues;
  menu_pagamentos.BeforeLoadDFMValues;
  apagar.BeforeLoadDFMValues;
  lbViewApagar.BeforeLoadDFMValues;
  pagamentos.BeforeLoadDFMValues;
  lbViewPagamentos.BeforeLoadDFMValues;
  menu_localidades.BeforeLoadDFMValues;
  cidade.BeforeLoadDFMValues;
  lbViewCidade.BeforeLoadDFMValues;
  ufs.BeforeLoadDFMValues;
  lbViewUF.BeforeLoadDFMValues;
  menu_sincronizacao.BeforeLoadDFMValues;
  sincronizacao_service.BeforeLoadDFMValues;
  lbViewSincronizacao_Service.BeforeLoadDFMValues;
  erros_catalogados.BeforeLoadDFMValues;
  lbViewErros_Catalogados.BeforeLoadDFMValues;
  sincronizacao_servidor_retaguarda.BeforeLoadDFMValues;
  lbViewSincronizacao_Servidor_Retaguarda.BeforeLoadDFMValues;
  menu_tributacoes.BeforeLoadDFMValues;
  ncm.BeforeLoadDFMValues;
  lbViewNcm.BeforeLoadDFMValues;
  cfop.BeforeLoadDFMValues;
  lbViewCfop.BeforeLoadDFMValues;
  menu_reforma_tributaria.BeforeLoadDFMValues;
  rt_ibs_cbs_cst.BeforeLoadDFMValues;
  lbViewRt_Ibs_Cbs_Cst.BeforeLoadDFMValues;
  rt_is_cst.BeforeLoadDFMValues;
  lbViewRt_Is_Cst.BeforeLoadDFMValues;
  rt_credito_presumido.BeforeLoadDFMValues;
  lbViewRt_Credito_Presumido.BeforeLoadDFMValues;
  cfop_configuracoes.BeforeLoadDFMValues;
  lbViewCfop_Configuracoes.BeforeLoadDFMValues;
  cst.BeforeLoadDFMValues;
  lbViewCst.BeforeLoadDFMValues;
  cst_pis.BeforeLoadDFMValues;
  lbViewCst_Pis.BeforeLoadDFMValues;
  cst_cofins.BeforeLoadDFMValues;
  lbViewCst_Cofins.BeforeLoadDFMValues;
  cst_ipi.BeforeLoadDFMValues;
  lbViewCst_Ipi.BeforeLoadDFMValues;
  codigo_bc_piscofins.BeforeLoadDFMValues;
  lbViewCodigo_bc_Piscofins.BeforeLoadDFMValues;
  origem_csosn.BeforeLoadDFMValues;
  lbViewOrigem_Csosn.BeforeLoadDFMValues;
  codigo_credito_piscofins.BeforeLoadDFMValues;
  lbViewCodigo_Credito_Piscofins.BeforeLoadDFMValues;
  desoneracao_icms.BeforeLoadDFMValues;
  lbViewDesoneracao_Icms.BeforeLoadDFMValues;
  csosn.BeforeLoadDFMValues;
  lbViewCsosn.BeforeLoadDFMValues;
  servicos_nacional.BeforeLoadDFMValues;
  lbViewServicos_Nacional.BeforeLoadDFMValues;
  nbs.BeforeLoadDFMValues;
  lbViewNbs.BeforeLoadDFMValues;
  menu_cadastros.BeforeLoadDFMValues;
  promocoes.BeforeLoadDFMValues;
  lbViewPromocoes.BeforeLoadDFMValues;
  funcionarios.BeforeLoadDFMValues;
  lbViewFuncionarios.BeforeLoadDFMValues;
  clientes.BeforeLoadDFMValues;
  lbViewClientes.BeforeLoadDFMValues;
  modalidades.BeforeLoadDFMValues;
  lbViewModalidades.BeforeLoadDFMValues;
  aliquotas.BeforeLoadDFMValues;
  lbViewAliquotas.BeforeLoadDFMValues;
  parceiros.BeforeLoadDFMValues;
  lbViewParceiros.BeforeLoadDFMValues;
  contas.BeforeLoadDFMValues;
  lbViewContas.BeforeLoadDFMValues;
  bancos.BeforeLoadDFMValues;
  lbViewBancos.BeforeLoadDFMValues;
  banco_carteiras.BeforeLoadDFMValues;
  lbViewBanco_Carteiras.BeforeLoadDFMValues;
  operadoras_cartao.BeforeLoadDFMValues;
  lbViewOperadoras_Cartao.BeforeLoadDFMValues;
  contadores.BeforeLoadDFMValues;
  lbViewContadores.BeforeLoadDFMValues;
  fornecedores.BeforeLoadDFMValues;
  lbViewFornecedores.BeforeLoadDFMValues;
  tipos.BeforeLoadDFMValues;
  lbViewTipos.BeforeLoadDFMValues;
  modulos.BeforeLoadDFMValues;
  lbViewModulos.BeforeLoadDFMValues;
  pdvs.BeforeLoadDFMValues;
  lbViewPdvs.BeforeLoadDFMValues;
  segmentos.BeforeLoadDFMValues;
  lbViewSegmento.BeforeLoadDFMValues;
  menu_plano_contas.BeforeLoadDFMValues;
  plano_contas.BeforeLoadDFMValues;
  lbViewPlano_Contas.BeforeLoadDFMValues;
  plano_contas_contabil.BeforeLoadDFMValues;
  lbViewPlano_Contas_Contabil.BeforeLoadDFMValues;
  plano_contas2.BeforeLoadDFMValues;
  lbViewPlano_Contas2.BeforeLoadDFMValues;
  plano_contas1.BeforeLoadDFMValues;
  lbViewPlano_Contas1.BeforeLoadDFMValues;
  plano_contas3.BeforeLoadDFMValues;
  lbViewPlano_Contas3.BeforeLoadDFMValues;
  servicos.BeforeLoadDFMValues;
  lbViewServicos.BeforeLoadDFMValues;
  menu_vendas.BeforeLoadDFMValues;
  vendas.BeforeLoadDFMValues;
  lbViewVendas.BeforeLoadDFMValues;
  vendas_servicos.BeforeLoadDFMValues;
  lbViewVendasServicos.BeforeLoadDFMValues;
  cupons.BeforeLoadDFMValues;
  lbViewCupons.BeforeLoadDFMValues;
  menu_documentos_fiscais.BeforeLoadDFMValues;
  nfe.BeforeLoadDFMValues;
  lbViewNfe.BeforeLoadDFMValues;
  nfse.BeforeLoadDFMValues;
  lbViewNfse.BeforeLoadDFMValues;
  painel_aliados.BeforeLoadDFMValues;
  lbViewPainelAliados.BeforeLoadDFMValues;
  relatorios.BeforeLoadDFMValues;
  lbViewRelatorios.BeforeLoadDFMValues;
  compras.BeforeLoadDFMValues;
  lbViewCompras.BeforeLoadDFMValues;
  usuarios.BeforeLoadDFMValues;
  lbViewUsuarios.BeforeLoadDFMValues;
  menu_produtos.BeforeLoadDFMValues;
  produtos.BeforeLoadDFMValues;
  lbViewProdutos.BeforeLoadDFMValues;
  grupos.BeforeLoadDFMValues;
  lbViewGrupos.BeforeLoadDFMValues;
  unidades.BeforeLoadDFMValues;
  lbViewUnidades.BeforeLoadDFMValues;
  subgrupos.BeforeLoadDFMValues;
  lbViewSubgrupos.BeforeLoadDFMValues;
  menu_grades.BeforeLoadDFMValues;
  grade_produtos.BeforeLoadDFMValues;
  lbViewGrade_Produtos.BeforeLoadDFMValues;
  grade_descricoes.BeforeLoadDFMValues;
  lbViewGrade_Descricoes.BeforeLoadDFMValues;
  grade_colunas.BeforeLoadDFMValues;
  lbViewGrade_Colunas.BeforeLoadDFMValues;
  grade_linhas.BeforeLoadDFMValues;
  lbViewGrade_Linhas.BeforeLoadDFMValues;
  cdsDataBase.BeforeLoadDFMValues;
  cdsDataBaseid.BeforeLoadDFMValues;
  cdsDataBasenome_fantasia.BeforeLoadDFMValues;
  cdsDataBaseassociar_produtos.BeforeLoadDFMValues;
  dwcGetUsuario.BeforeLoadDFMValues;
  cdsUsuarios.BeforeLoadDFMValues;
  cdsUsuariosid.BeforeLoadDFMValues;
  cdsUsuariosdata_base_id.BeforeLoadDFMValues;
  cdsUsuariosaliado_id.BeforeLoadDFMValues;
  cdsUsuariosperfil.BeforeLoadDFMValues;
  cdsUsuariosnome.BeforeLoadDFMValues;
  cdsUsuariosperfil_acesso.BeforeLoadDFMValues;
  dwcGetDadosEmpresaLogado.BeforeLoadDFMValues;
  cdsLogsSistema.BeforeLoadDFMValues;
  cdsLogsSistemaaliado_id.BeforeLoadDFMValues;
  cdsLogsSistematabela.BeforeLoadDFMValues;
  cdsLogsSistemaoperacao.BeforeLoadDFMValues;
  cdsLogsSistemalog.BeforeLoadDFMValues;
  XDataWebClientPermissoes.BeforeLoadDFMValues;
  tmrIniciarSistema.BeforeLoadDFMValues;
  cdsPersonalizacaoTabelas.BeforeLoadDFMValues;
  cdsPersonalizacaoTabelasid.BeforeLoadDFMValues;
  cdsPersonalizacaoTabelasusuario_id.BeforeLoadDFMValues;
  cdsPersonalizacaoTabelastabela_frontend.BeforeLoadDFMValues;
  cdsPersonalizacaoTabelaspersonalizacao.BeforeLoadDFMValues;
  try
    Name := 'FViewMain';
    Width := 1073;
    Height := 750;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    ParentFont := False;
    SetEvent(Self, 'OnClose', 'WebFormClose');
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    SetEvent(Self, 'OnShow', 'WebFormShow');
    WebLinkLabel6.SetParentComponent(Self);
    WebLinkLabel6.Name := 'WebLinkLabel6';
    WebLinkLabel6.Left := 799;
    WebLinkLabel6.Top := 8;
    WebLinkLabel6.Width := 18;
    WebLinkLabel6.Height := 13;
    WebLinkLabel6.HeightPercent := 100.000000000000000000;
    WebLinkLabel6.WidthPercent := 100.000000000000000000;
    SetEvent(WebLinkLabel6, Self, 'OnClick', 'WebLinkLabel6Click');
    WebLinkLabel6.Caption := 'Sair';
    lbUsername.SetParentComponent(Self);
    lbUsername.Name := 'lbUsername';
    lbUsername.Left := 646;
    lbUsername.Top := 8;
    lbUsername.Width := 56;
    lbUsername.Height := 13;
    lbUsername.Caption := 'lbUsername';
    lbUsername.HeightPercent := 100.000000000000000000;
    lbUsername.Transparent := False;
    lbUsername.WidthPercent := 100.000000000000000000;
    lblLogo.SetParentComponent(Self);
    lblLogo.Name := 'lblLogo';
    lblLogo.Left := 557;
    lblLogo.Top := 8;
    lblLogo.Width := 66;
    lblLogo.Height := 13;
    lblLogo.Font.Charset := DEFAULT_CHARSET;
    lblLogo.Font.Color := clWindowText;
    lblLogo.Font.Height := -11;
    lblLogo.Font.Name := 'Tahoma';
    lblLogo.Font.Style := [];
    lblLogo.ParentFont := False;
    lblLogo.HeightPercent := 100.000000000000000000;
    lblLogo.WidthPercent := 100.000000000000000000;
    lblLogo.Caption := 'F'#225'cil Sistemas';
    lblEmpresalogin.SetParentComponent(Self);
    lblEmpresalogin.Name := 'lblEmpresalogin';
    lblEmpresalogin.Left := 656;
    lblEmpresalogin.Top := 492;
    lblEmpresalogin.Width := 3;
    lblEmpresalogin.Height := 13;
    lblEmpresalogin.Font.Charset := DEFAULT_CHARSET;
    lblEmpresalogin.Font.Color := clWindowText;
    lblEmpresalogin.Font.Height := -11;
    lblEmpresalogin.Font.Name := 'Tahoma';
    lblEmpresalogin.Font.Style := [];
    lblEmpresalogin.ParentFont := False;
    lblEmpresalogin.HeightPercent := 100.000000000000000000;
    lblEmpresalogin.WidthPercent := 100.000000000000000000;
    aliado_logado.SetParentComponent(Self);
    aliado_logado.Name := 'aliado_logado';
    aliado_logado.Left := 680;
    aliado_logado.Top := 239;
    aliado_logado.Width := 66;
    aliado_logado.Height := 13;
    aliado_logado.Caption := 'aliado_logado';
    aliado_logado.HeightPercent := 100.000000000000000000;
    aliado_logado.WidthPercent := 100.000000000000000000;
    lbMeuperfil.SetParentComponent(Self);
    lbMeuperfil.Name := 'lbMeuperfil';
    lbMeuperfil.Left := 722;
    lbMeuperfil.Top := 8;
    lbMeuperfil.Width := 58;
    lbMeuperfil.Height := 13;
    lbMeuperfil.Caption := 'Meus Dados';
    lbMeuperfil.HeightPercent := 100.000000000000000000;
    lbMeuperfil.Transparent := False;
    lbMeuperfil.WidthPercent := 100.000000000000000000;
    SetEvent(lbMeuperfil, Self, 'OnClick', 'lbMeuperfilClick');
    WebPanel1.SetParentComponent(Self);
    WebPanel1.Name := 'WebPanel1';
    WebPanel1.Left := 557;
    WebPanel1.Top := 27;
    WebPanel1.Width := 260;
    WebPanel1.Height := 119;
    WebPanel1.ChildOrder := 60;
    WebPanel1.TabOrder := 0;
    div_bancos_usuario.SetParentComponent(Self);
    div_bancos_usuario.Name := 'div_bancos_usuario';
    div_bancos_usuario.Left := 557;
    div_bancos_usuario.Top := 152;
    div_bancos_usuario.Width := 156;
    div_bancos_usuario.Height := 35;
    div_bancos_usuario.ChildOrder := 5;
    div_bancos_usuario.Role := '';
    cbbDataBase.SetParentComponent(div_bancos_usuario);
    cbbDataBase.Name := 'cbbDataBase';
    cbbDataBase.Left := 4;
    cbbDataBase.Top := 6;
    cbbDataBase.Width := 145;
    cbbDataBase.Height := 21;
    cbbDataBase.HeightPercent := 100.000000000000000000;
    cbbDataBase.WidthPercent := 100.000000000000000000;
    SetEvent(cbbDataBase, Self, 'OnChange', 'cbbDataBaseChange');
    cbbDataBase.ItemIndex := -1;
    div_empresa_login.SetParentComponent(Self);
    div_empresa_login.Name := 'div_empresa_login';
    div_empresa_login.Left := 719;
    div_empresa_login.Top := 193;
    div_empresa_login.Width := 98;
    div_empresa_login.Height := 28;
    div_empresa_login.ChildOrder := 5;
    div_empresa_login.Role := '';
    div_empresa_login.Visible := False;
    div_aliado_login.SetParentComponent(Self);
    div_aliado_login.Name := 'div_aliado_login';
    div_aliado_login.Left := 719;
    div_aliado_login.Top := 152;
    div_aliado_login.Width := 98;
    div_aliado_login.Height := 35;
    div_aliado_login.ChildOrder := 5;
    div_aliado_login.Role := '';
    div_aliado_login.Visible := False;
    aliado_conectado_topo.SetParentComponent(Self);
    aliado_conectado_topo.Name := 'aliado_conectado_topo';
    aliado_conectado_topo.Left := 557;
    aliado_conectado_topo.Top := 193;
    aliado_conectado_topo.Width := 156;
    aliado_conectado_topo.Height := 28;
    aliado_conectado_topo.ChildOrder := 5;
    aliado_conectado_topo.Role := '';
    aliado_conectado_topo.Visible := False;
    nome_aliado_conectado_topo.SetParentComponent(aliado_conectado_topo);
    nome_aliado_conectado_topo.Name := 'nome_aliado_conectado_topo';
    nome_aliado_conectado_topo.Left := 16;
    nome_aliado_conectado_topo.Top := 3;
    nome_aliado_conectado_topo.Width := 144;
    nome_aliado_conectado_topo.Height := 13;
    nome_aliado_conectado_topo.Caption := 'nome_aliado_conectado_topo';
    nome_aliado_conectado_topo.HeightPercent := 100.000000000000000000;
    nome_aliado_conectado_topo.WidthPercent := 100.000000000000000000;
    btnDesconectar.SetParentComponent(Self);
    btnDesconectar.Name := 'btnDesconectar';
    btnDesconectar.Left := 557;
    btnDesconectar.Top := 227;
    btnDesconectar.Width := 96;
    btnDesconectar.Height := 25;
    btnDesconectar.Caption := 'Desconectar';
    btnDesconectar.ChildOrder := 69;
    btnDesconectar.HeightPercent := 100.000000000000000000;
    btnDesconectar.WidthPercent := 100.000000000000000000;
    SetEvent(btnDesconectar, Self, 'OnClick', 'btnDesconectarClick');
    menu_nfse.SetParentComponent(Self);
    menu_nfse.Name := 'menu_nfse';
    menu_nfse.Left := 5;
    menu_nfse.Top := 75;
    menu_nfse.Width := 113;
    menu_nfse.Height := 48;
    menu_nfse.ChildOrder := 80;
    menu_nfse.Role := '';
    provedores.SetParentComponent(menu_nfse);
    provedores.Name := 'provedores';
    provedores.Left := 6;
    provedores.Top := 2;
    provedores.Width := 100;
    provedores.Height := 20;
    provedores.ChildOrder := 95;
    provedores.Role := '';
    SetEvent(provedores, Self, 'OnClick', 'provedoresClick');
    lbViewProvedores.SetParentComponent(provedores);
    lbViewProvedores.Name := 'lbViewProvedores';
    lbViewProvedores.Left := 26;
    lbViewProvedores.Top := 4;
    lbViewProvedores.Width := 55;
    lbViewProvedores.Height := 13;
    lbViewProvedores.HeightPercent := 100.000000000000000000;
    lbViewProvedores.WidthPercent := 100.000000000000000000;
    lbViewProvedores.Caption := 'Provedores';
    consulta_nfse.SetParentComponent(menu_nfse);
    consulta_nfse.Name := 'consulta_nfse';
    consulta_nfse.Left := 6;
    consulta_nfse.Top := 25;
    consulta_nfse.Width := 100;
    consulta_nfse.Height := 20;
    consulta_nfse.ChildOrder := 95;
    consulta_nfse.Role := '';
    SetEvent(consulta_nfse, Self, 'OnClick', 'consulta_nfseClick');
    lbViewConsultaNfse.SetParentComponent(consulta_nfse);
    lbViewConsultaNfse.Name := 'lbViewConsultaNfse';
    lbViewConsultaNfse.Left := 34;
    lbViewConsultaNfse.Top := 5;
    lbViewConsultaNfse.Width := 42;
    lbViewConsultaNfse.Height := 13;
    lbViewConsultaNfse.HeightPercent := 100.000000000000000000;
    lbViewConsultaNfse.WidthPercent := 100.000000000000000000;
    lbViewConsultaNfse.Caption := 'Consulta';
    home.SetParentComponent(Self);
    home.Name := 'home';
    home.Left := 5;
    home.Top := 9;
    home.Width := 113;
    home.Height := 20;
    home.ChildOrder := 95;
    home.Role := '';
    SetEvent(home, Self, 'OnClick', 'homeClick');
    lbViewHome.SetParentComponent(home);
    lbViewHome.Name := 'lbViewHome';
    lbViewHome.Left := 34;
    lbViewHome.Top := 3;
    lbViewHome.Width := 25;
    lbViewHome.Height := 13;
    lbViewHome.Font.Charset := DEFAULT_CHARSET;
    lbViewHome.Font.Color := clWindowText;
    lbViewHome.Font.Height := -11;
    lbViewHome.Font.Name := 'Tahoma';
    lbViewHome.Font.Style := [];
    lbViewHome.ParentFont := False;
    lbViewHome.HeightPercent := 100.000000000000000000;
    lbViewHome.WidthPercent := 100.000000000000000000;
    lbViewHome.Caption := 'Inic'#237'o';
    aliado.SetParentComponent(Self);
    aliado.Name := 'aliado';
    aliado.Left := 5;
    aliado.Top := 31;
    aliado.Width := 113;
    aliado.Height := 20;
    aliado.ChildOrder := 95;
    aliado.Role := '';
    SetEvent(aliado, Self, 'OnClick', 'aliadoClick');
    lbViewAliado.SetParentComponent(aliado);
    lbViewAliado.Name := 'lbViewAliado';
    lbViewAliado.Left := 31;
    lbViewAliado.Top := 4;
    lbViewAliado.Width := 41;
    lbViewAliado.Height := 13;
    lbViewAliado.HeightPercent := 100.000000000000000000;
    lbViewAliado.WidthPercent := 100.000000000000000000;
    lbViewAliado.Caption := 'Empresa';
    logs_sistema.SetParentComponent(Self);
    logs_sistema.Name := 'logs_sistema';
    logs_sistema.Left := 5;
    logs_sistema.Top := 53;
    logs_sistema.Width := 113;
    logs_sistema.Height := 20;
    logs_sistema.ChildOrder := 95;
    logs_sistema.Role := '';
    SetEvent(logs_sistema, Self, 'OnClick', 'logs_sistemaClick');
    lbViewLogs_Sistema.SetParentComponent(logs_sistema);
    lbViewLogs_Sistema.Name := 'lbViewLogs_Sistema';
    lbViewLogs_Sistema.Left := 20;
    lbViewLogs_Sistema.Top := 3;
    lbViewLogs_Sistema.Width := 62;
    lbViewLogs_Sistema.Height := 13;
    lbViewLogs_Sistema.HeightPercent := 100.000000000000000000;
    lbViewLogs_Sistema.WidthPercent := 100.000000000000000000;
    lbViewLogs_Sistema.Caption := 'Logs Sistema';
    menu_scripts.SetParentComponent(Self);
    menu_scripts.Name := 'menu_scripts';
    menu_scripts.Left := 5;
    menu_scripts.Top := 128;
    menu_scripts.Width := 113;
    menu_scripts.Height := 72;
    menu_scripts.ChildOrder := 80;
    menu_scripts.Role := '';
    scripts.SetParentComponent(menu_scripts);
    scripts.Name := 'scripts';
    scripts.Left := 6;
    scripts.Top := 2;
    scripts.Width := 100;
    scripts.Height := 20;
    scripts.ChildOrder := 95;
    scripts.Role := '';
    SetEvent(scripts, Self, 'OnClick', 'scriptsClick');
    lbViewScripts.SetParentComponent(scripts);
    lbViewScripts.Name := 'lbViewScripts';
    lbViewScripts.Left := 20;
    lbViewScripts.Top := 4;
    lbViewScripts.Width := 61;
    lbViewScripts.Height := 13;
    lbViewScripts.HeightPercent := 100.000000000000000000;
    lbViewScripts.WidthPercent := 100.000000000000000000;
    lbViewScripts.Caption := 'Cadastrados';
    scripts_aliados.SetParentComponent(menu_scripts);
    scripts_aliados.Name := 'scripts_aliados';
    scripts_aliados.Left := 6;
    scripts_aliados.Top := 25;
    scripts_aliados.Width := 100;
    scripts_aliados.Height := 20;
    scripts_aliados.ChildOrder := 95;
    scripts_aliados.Role := '';
    SetEvent(scripts_aliados, Self, 'OnClick', 'scripts_aliadosClick');
    lbViewScripts_Aliados.SetParentComponent(scripts_aliados);
    lbViewScripts_Aliados.Name := 'lbViewScripts_Aliados';
    lbViewScripts_Aliados.Left := 39;
    lbViewScripts_Aliados.Top := 4;
    lbViewScripts_Aliados.Width := 34;
    lbViewScripts_Aliados.Height := 13;
    lbViewScripts_Aliados.HeightPercent := 100.000000000000000000;
    lbViewScripts_Aliados.WidthPercent := 100.000000000000000000;
    lbViewScripts_Aliados.Caption := 'Aliados';
    versoes.SetParentComponent(menu_scripts);
    versoes.Name := 'versoes';
    versoes.Left := 6;
    versoes.Top := 48;
    versoes.Width := 100;
    versoes.Height := 20;
    versoes.ChildOrder := 95;
    versoes.Role := '';
    SetEvent(versoes, Self, 'OnClick', 'versoesClick');
    lbViewVersoes.SetParentComponent(versoes);
    lbViewVersoes.Name := 'lbViewVersoes';
    lbViewVersoes.Left := 36;
    lbViewVersoes.Top := 4;
    lbViewVersoes.Width := 38;
    lbViewVersoes.Height := 13;
    lbViewVersoes.HeightPercent := 100.000000000000000000;
    lbViewVersoes.WidthPercent := 100.000000000000000000;
    lbViewVersoes.Caption := 'Vers'#245'es';
    menu_apis_externas.SetParentComponent(Self);
    menu_apis_externas.Name := 'menu_apis_externas';
    menu_apis_externas.Left := 5;
    menu_apis_externas.Top := 203;
    menu_apis_externas.Width := 113;
    menu_apis_externas.Height := 49;
    menu_apis_externas.ChildOrder := 80;
    menu_apis_externas.Role := '';
    api_veiculos.SetParentComponent(menu_apis_externas);
    api_veiculos.Name := 'api_veiculos';
    api_veiculos.Left := 6;
    api_veiculos.Top := 3;
    api_veiculos.Width := 100;
    api_veiculos.Height := 20;
    api_veiculos.ChildOrder := 95;
    api_veiculos.Role := '';
    SetEvent(api_veiculos, Self, 'OnClick', 'api_veiculosClick');
    lbViewApi_Veiculos.SetParentComponent(api_veiculos);
    lbViewApi_Veiculos.Name := 'lbViewApi_Veiculos';
    lbViewApi_Veiculos.Left := 34;
    lbViewApi_Veiculos.Top := 4;
    lbViewApi_Veiculos.Width := 38;
    lbViewApi_Veiculos.Height := 13;
    lbViewApi_Veiculos.HeightPercent := 100.000000000000000000;
    lbViewApi_Veiculos.WidthPercent := 100.000000000000000000;
    lbViewApi_Veiculos.Caption := 'Ve'#237'culos';
    api_cpfs.SetParentComponent(menu_apis_externas);
    api_cpfs.Name := 'api_cpfs';
    api_cpfs.Left := 6;
    api_cpfs.Top := 25;
    api_cpfs.Width := 100;
    api_cpfs.Height := 20;
    api_cpfs.ChildOrder := 95;
    api_cpfs.Role := '';
    SetEvent(api_cpfs, Self, 'OnClick', 'api_cpfsClick');
    lbViewApi_Cpfs.SetParentComponent(api_cpfs);
    lbViewApi_Cpfs.Name := 'lbViewApi_Cpfs';
    lbViewApi_Cpfs.Left := 34;
    lbViewApi_Cpfs.Top := 4;
    lbViewApi_Cpfs.Width := 24;
    lbViewApi_Cpfs.Height := 13;
    lbViewApi_Cpfs.HeightPercent := 100.000000000000000000;
    lbViewApi_Cpfs.WidthPercent := 100.000000000000000000;
    lbViewApi_Cpfs.Caption := 'CPFs';
    menu_fs_produtos.SetParentComponent(Self);
    menu_fs_produtos.Name := 'menu_fs_produtos';
    menu_fs_produtos.Left := 5;
    menu_fs_produtos.Top := 360;
    menu_fs_produtos.Width := 113;
    menu_fs_produtos.Height := 185;
    menu_fs_produtos.ChildOrder := 80;
    menu_fs_produtos.Role := '';
    fs_prod_produtos.SetParentComponent(menu_fs_produtos);
    fs_prod_produtos.Name := 'fs_prod_produtos';
    fs_prod_produtos.Left := 6;
    fs_prod_produtos.Top := 2;
    fs_prod_produtos.Width := 100;
    fs_prod_produtos.Height := 20;
    fs_prod_produtos.ChildOrder := 95;
    fs_prod_produtos.Role := '';
    SetEvent(fs_prod_produtos, Self, 'OnClick', 'fs_prod_produtosClick');
    lbViewFs_Prod_Produtos.SetParentComponent(fs_prod_produtos);
    lbViewFs_Prod_Produtos.Name := 'lbViewFs_Prod_Produtos';
    lbViewFs_Prod_Produtos.Left := 33;
    lbViewFs_Prod_Produtos.Top := 5;
    lbViewFs_Prod_Produtos.Width := 43;
    lbViewFs_Prod_Produtos.Height := 13;
    lbViewFs_Prod_Produtos.HeightPercent := 100.000000000000000000;
    lbViewFs_Prod_Produtos.WidthPercent := 100.000000000000000000;
    lbViewFs_Prod_Produtos.Caption := 'Produtos';
    fs_prod_marcas.SetParentComponent(menu_fs_produtos);
    fs_prod_marcas.Name := 'fs_prod_marcas';
    fs_prod_marcas.Left := 6;
    fs_prod_marcas.Top := 25;
    fs_prod_marcas.Width := 100;
    fs_prod_marcas.Height := 20;
    fs_prod_marcas.ChildOrder := 95;
    fs_prod_marcas.Role := '';
    SetEvent(fs_prod_marcas, Self, 'OnClick', 'fs_prod_marcasClick');
    lbViewFs_Prod_Marcas.SetParentComponent(fs_prod_marcas);
    lbViewFs_Prod_Marcas.Name := 'lbViewFs_Prod_Marcas';
    lbViewFs_Prod_Marcas.Left := 39;
    lbViewFs_Prod_Marcas.Top := 4;
    lbViewFs_Prod_Marcas.Width := 34;
    lbViewFs_Prod_Marcas.Height := 13;
    lbViewFs_Prod_Marcas.HeightPercent := 100.000000000000000000;
    lbViewFs_Prod_Marcas.WidthPercent := 100.000000000000000000;
    lbViewFs_Prod_Marcas.Caption := 'Marcas';
    fs_prod_fabricantes.SetParentComponent(menu_fs_produtos);
    fs_prod_fabricantes.Name := 'fs_prod_fabricantes';
    fs_prod_fabricantes.Left := 6;
    fs_prod_fabricantes.Top := 48;
    fs_prod_fabricantes.Width := 100;
    fs_prod_fabricantes.Height := 20;
    fs_prod_fabricantes.ChildOrder := 95;
    fs_prod_fabricantes.Role := '';
    SetEvent(fs_prod_fabricantes, Self, 'OnClick', 'fs_prod_fabricantesClick');
    lbViewFs_Prod_Fabricantes.SetParentComponent(fs_prod_fabricantes);
    lbViewFs_Prod_Fabricantes.Name := 'lbViewFs_Prod_Fabricantes';
    lbViewFs_Prod_Fabricantes.Left := 24;
    lbViewFs_Prod_Fabricantes.Top := 4;
    lbViewFs_Prod_Fabricantes.Width := 56;
    lbViewFs_Prod_Fabricantes.Height := 13;
    lbViewFs_Prod_Fabricantes.HeightPercent := 100.000000000000000000;
    lbViewFs_Prod_Fabricantes.WidthPercent := 100.000000000000000000;
    lbViewFs_Prod_Fabricantes.Caption := 'Fabricantes';
    fs_prod_categorias.SetParentComponent(menu_fs_produtos);
    fs_prod_categorias.Name := 'fs_prod_categorias';
    fs_prod_categorias.Left := 6;
    fs_prod_categorias.Top := 71;
    fs_prod_categorias.Width := 100;
    fs_prod_categorias.Height := 20;
    fs_prod_categorias.ChildOrder := 95;
    fs_prod_categorias.Role := '';
    SetEvent(fs_prod_categorias, Self, 'OnClick', 'fs_prod_categoriasClick');
    lbViewFs_Prod_Categorias.SetParentComponent(fs_prod_categorias);
    lbViewFs_Prod_Categorias.Name := 'lbViewFs_Prod_Categorias';
    lbViewFs_Prod_Categorias.Left := 24;
    lbViewFs_Prod_Categorias.Top := 4;
    lbViewFs_Prod_Categorias.Width := 52;
    lbViewFs_Prod_Categorias.Height := 13;
    lbViewFs_Prod_Categorias.HeightPercent := 100.000000000000000000;
    lbViewFs_Prod_Categorias.WidthPercent := 100.000000000000000000;
    lbViewFs_Prod_Categorias.Caption := 'Categorias';
    fs_prod_subcategorias.SetParentComponent(menu_fs_produtos);
    fs_prod_subcategorias.Name := 'fs_prod_subcategorias';
    fs_prod_subcategorias.Left := 6;
    fs_prod_subcategorias.Top := 94;
    fs_prod_subcategorias.Width := 100;
    fs_prod_subcategorias.Height := 20;
    fs_prod_subcategorias.ChildOrder := 95;
    fs_prod_subcategorias.Role := '';
    SetEvent(fs_prod_subcategorias, Self, 'OnClick', 'fs_prod_subcategoriasClick');
    lbViewFs_Prod_SubCategorias.SetParentComponent(fs_prod_subcategorias);
    lbViewFs_Prod_SubCategorias.Name := 'lbViewFs_Prod_SubCategorias';
    lbViewFs_Prod_SubCategorias.Left := 14;
    lbViewFs_Prod_SubCategorias.Top := 4;
    lbViewFs_Prod_SubCategorias.Width := 70;
    lbViewFs_Prod_SubCategorias.Height := 13;
    lbViewFs_Prod_SubCategorias.HeightPercent := 100.000000000000000000;
    lbViewFs_Prod_SubCategorias.WidthPercent := 100.000000000000000000;
    lbViewFs_Prod_SubCategorias.Caption := 'SubCategorias';
    fs_prod_departamentos.SetParentComponent(menu_fs_produtos);
    fs_prod_departamentos.Name := 'fs_prod_departamentos';
    fs_prod_departamentos.Left := 6;
    fs_prod_departamentos.Top := 117;
    fs_prod_departamentos.Width := 100;
    fs_prod_departamentos.Height := 20;
    fs_prod_departamentos.ChildOrder := 95;
    fs_prod_departamentos.Role := '';
    SetEvent(fs_prod_departamentos, Self, 'OnClick', 'fs_prod_departamentosClick');
    lbViewFs_Prod_Departamentos.SetParentComponent(fs_prod_departamentos);
    lbViewFs_Prod_Departamentos.Name := 'lbViewFs_Prod_Departamentos';
    lbViewFs_Prod_Departamentos.Left := 10;
    lbViewFs_Prod_Departamentos.Top := 4;
    lbViewFs_Prod_Departamentos.Width := 74;
    lbViewFs_Prod_Departamentos.Height := 13;
    lbViewFs_Prod_Departamentos.HeightPercent := 100.000000000000000000;
    lbViewFs_Prod_Departamentos.WidthPercent := 100.000000000000000000;
    lbViewFs_Prod_Departamentos.Caption := 'Departamentos';
    fs_prod_subdepartamentos.SetParentComponent(menu_fs_produtos);
    fs_prod_subdepartamentos.Name := 'fs_prod_subdepartamentos';
    fs_prod_subdepartamentos.Left := 6;
    fs_prod_subdepartamentos.Top := 139;
    fs_prod_subdepartamentos.Width := 100;
    fs_prod_subdepartamentos.Height := 20;
    fs_prod_subdepartamentos.ChildOrder := 95;
    fs_prod_subdepartamentos.Role := '';
    SetEvent(fs_prod_subdepartamentos, Self, 'OnClick', 'fs_prod_subdepartamentosClick');
    lbViewFs_Prod_SubDepartamentos.SetParentComponent(fs_prod_subdepartamentos);
    lbViewFs_Prod_SubDepartamentos.Name := 'lbViewFs_Prod_SubDepartamentos';
    lbViewFs_Prod_SubDepartamentos.Left := 6;
    lbViewFs_Prod_SubDepartamentos.Top := 4;
    lbViewFs_Prod_SubDepartamentos.Width := 92;
    lbViewFs_Prod_SubDepartamentos.Height := 13;
    lbViewFs_Prod_SubDepartamentos.HeightPercent := 100.000000000000000000;
    lbViewFs_Prod_SubDepartamentos.WidthPercent := 100.000000000000000000;
    lbViewFs_Prod_SubDepartamentos.Caption := 'SubDepartamentos';
    fs_prod_caracteristicas.SetParentComponent(menu_fs_produtos);
    fs_prod_caracteristicas.Name := 'fs_prod_caracteristicas';
    fs_prod_caracteristicas.Left := 6;
    fs_prod_caracteristicas.Top := 162;
    fs_prod_caracteristicas.Width := 100;
    fs_prod_caracteristicas.Height := 20;
    fs_prod_caracteristicas.ChildOrder := 95;
    fs_prod_caracteristicas.Role := '';
    SetEvent(fs_prod_caracteristicas, Self, 'OnClick', 'fs_prod_caracteristicasClick');
    lbViewFs_Prod_Caracteristicas.SetParentComponent(fs_prod_caracteristicas);
    lbViewFs_Prod_Caracteristicas.Name := 'lbViewFs_Prod_Caracteristicas';
    lbViewFs_Prod_Caracteristicas.Left := 15;
    lbViewFs_Prod_Caracteristicas.Top := 4;
    lbViewFs_Prod_Caracteristicas.Width := 71;
    lbViewFs_Prod_Caracteristicas.Height := 13;
    lbViewFs_Prod_Caracteristicas.HeightPercent := 100.000000000000000000;
    lbViewFs_Prod_Caracteristicas.WidthPercent := 100.000000000000000000;
    lbViewFs_Prod_Caracteristicas.Caption := 'Caracter'#237'sticas';
    menu_facil_planos.SetParentComponent(Self);
    menu_facil_planos.Name := 'menu_facil_planos';
    menu_facil_planos.Left := 5;
    menu_facil_planos.Top := 620;
    menu_facil_planos.Width := 113;
    menu_facil_planos.Height := 48;
    menu_facil_planos.ChildOrder := 80;
    menu_facil_planos.Role := '';
    facil_planos.SetParentComponent(menu_facil_planos);
    facil_planos.Name := 'facil_planos';
    facil_planos.Left := 6;
    facil_planos.Top := 2;
    facil_planos.Width := 100;
    facil_planos.Height := 20;
    facil_planos.ChildOrder := 95;
    facil_planos.Role := '';
    SetEvent(facil_planos, Self, 'OnClick', 'facil_planosClick');
    lbViewFacil_Planos.SetParentComponent(facil_planos);
    lbViewFacil_Planos.Name := 'lbViewFacil_Planos';
    lbViewFacil_Planos.Left := 35;
    lbViewFacil_Planos.Top := 3;
    lbViewFacil_Planos.Width := 31;
    lbViewFacil_Planos.Height := 13;
    lbViewFacil_Planos.HeightPercent := 100.000000000000000000;
    lbViewFacil_Planos.WidthPercent := 100.000000000000000000;
    lbViewFacil_Planos.Caption := 'Planos';
    facil_planos_aliados.SetParentComponent(menu_facil_planos);
    facil_planos_aliados.Name := 'facil_planos_aliados';
    facil_planos_aliados.Left := 6;
    facil_planos_aliados.Top := 25;
    facil_planos_aliados.Width := 100;
    facil_planos_aliados.Height := 20;
    facil_planos_aliados.ChildOrder := 95;
    facil_planos_aliados.Role := '';
    SetEvent(facil_planos_aliados, Self, 'OnClick', 'facil_planos_aliadosClick');
    lbViewPlanos_Aliados.SetParentComponent(facil_planos_aliados);
    lbViewPlanos_Aliados.Name := 'lbViewPlanos_Aliados';
    lbViewPlanos_Aliados.Left := 19;
    lbViewPlanos_Aliados.Top := 4;
    lbViewPlanos_Aliados.Width := 68;
    lbViewPlanos_Aliados.Height := 13;
    lbViewPlanos_Aliados.HeightPercent := 100.000000000000000000;
    lbViewPlanos_Aliados.WidthPercent := 100.000000000000000000;
    lbViewPlanos_Aliados.Caption := 'Planos Aliados';
    boletos.SetParentComponent(Self);
    boletos.Name := 'boletos';
    boletos.Left := 128;
    boletos.Top := 9;
    boletos.Width := 113;
    boletos.Height := 20;
    boletos.ChildOrder := 95;
    boletos.Role := '';
    SetEvent(boletos, Self, 'OnClick', 'boletosClick');
    lbViewBoletos.SetParentComponent(boletos);
    lbViewBoletos.Name := 'lbViewBoletos';
    lbViewBoletos.Left := 38;
    lbViewBoletos.Top := 4;
    lbViewBoletos.Width := 35;
    lbViewBoletos.Height := 13;
    lbViewBoletos.HeightPercent := 100.000000000000000000;
    lbViewBoletos.WidthPercent := 100.000000000000000000;
    lbViewBoletos.Caption := 'Boletos';
    lancamentos.SetParentComponent(Self);
    lancamentos.Name := 'lancamentos';
    lancamentos.Left := 128;
    lancamentos.Top := 31;
    lancamentos.Width := 113;
    lancamentos.Height := 20;
    lancamentos.ChildOrder := 95;
    lancamentos.Role := '';
    SetEvent(lancamentos, Self, 'OnClick', 'lancamentosClick');
    lbViewLancamentos.SetParentComponent(lancamentos);
    lbViewLancamentos.Name := 'lbViewLancamentos';
    lbViewLancamentos.Left := 38;
    lbViewLancamentos.Top := 4;
    lbViewLancamentos.Width := 27;
    lbViewLancamentos.Height := 13;
    lbViewLancamentos.HeightPercent := 100.000000000000000000;
    lbViewLancamentos.WidthPercent := 100.000000000000000000;
    lbViewLancamentos.Caption := 'Caixa';
    menu_recebimentos.SetParentComponent(Self);
    menu_recebimentos.Name := 'menu_recebimentos';
    menu_recebimentos.Left := 128;
    menu_recebimentos.Top := 54;
    menu_recebimentos.Width := 113;
    menu_recebimentos.Height := 48;
    menu_recebimentos.ChildOrder := 80;
    menu_recebimentos.Role := '';
    areceber.SetParentComponent(menu_recebimentos);
    areceber.Name := 'areceber';
    areceber.Left := 6;
    areceber.Top := 2;
    areceber.Width := 100;
    areceber.Height := 20;
    areceber.ChildOrder := 95;
    areceber.Role := '';
    SetEvent(areceber, Self, 'OnClick', 'areceberClick');
    lbViewAreceber.SetParentComponent(areceber);
    lbViewAreceber.Name := 'lbViewAreceber';
    lbViewAreceber.Left := 34;
    lbViewAreceber.Top := 4;
    lbViewAreceber.Width := 34;
    lbViewAreceber.Height := 13;
    lbViewAreceber.HeightPercent := 100.000000000000000000;
    lbViewAreceber.WidthPercent := 100.000000000000000000;
    lbViewAreceber.Caption := 'Contas';
    recebimentos.SetParentComponent(menu_recebimentos);
    recebimentos.Name := 'recebimentos';
    recebimentos.Left := 6;
    recebimentos.Top := 25;
    recebimentos.Width := 100;
    recebimentos.Height := 20;
    recebimentos.ChildOrder := 95;
    recebimentos.Role := '';
    SetEvent(recebimentos, Self, 'OnClick', 'recebimentosClick');
    lbViewRecebimentos.SetParentComponent(recebimentos);
    lbViewRecebimentos.Name := 'lbViewRecebimentos';
    lbViewRecebimentos.Left := 17;
    lbViewRecebimentos.Top := 4;
    lbViewRecebimentos.Width := 67;
    lbViewRecebimentos.Height := 13;
    lbViewRecebimentos.HeightPercent := 100.000000000000000000;
    lbViewRecebimentos.WidthPercent := 100.000000000000000000;
    lbViewRecebimentos.Caption := 'Recebimentos';
    menu_pagamentos.SetParentComponent(Self);
    menu_pagamentos.Name := 'menu_pagamentos';
    menu_pagamentos.Left := 128;
    menu_pagamentos.Top := 104;
    menu_pagamentos.Width := 113;
    menu_pagamentos.Height := 48;
    menu_pagamentos.ChildOrder := 80;
    menu_pagamentos.Role := '';
    apagar.SetParentComponent(menu_pagamentos);
    apagar.Name := 'apagar';
    apagar.Left := 6;
    apagar.Top := 2;
    apagar.Width := 100;
    apagar.Height := 20;
    apagar.ChildOrder := 95;
    apagar.Role := '';
    SetEvent(apagar, Self, 'OnClick', 'apagarClick');
    lbViewApagar.SetParentComponent(apagar);
    lbViewApagar.Name := 'lbViewApagar';
    lbViewApagar.Left := 34;
    lbViewApagar.Top := 4;
    lbViewApagar.Width := 34;
    lbViewApagar.Height := 13;
    lbViewApagar.HeightPercent := 100.000000000000000000;
    lbViewApagar.WidthPercent := 100.000000000000000000;
    lbViewApagar.Caption := 'Contas';
    pagamentos.SetParentComponent(menu_pagamentos);
    pagamentos.Name := 'pagamentos';
    pagamentos.Left := 6;
    pagamentos.Top := 25;
    pagamentos.Width := 100;
    pagamentos.Height := 20;
    pagamentos.ChildOrder := 95;
    pagamentos.Role := '';
    SetEvent(pagamentos, Self, 'OnClick', 'pagamentosClick');
    lbViewPagamentos.SetParentComponent(pagamentos);
    lbViewPagamentos.Name := 'lbViewPagamentos';
    lbViewPagamentos.Left := 23;
    lbViewPagamentos.Top := 4;
    lbViewPagamentos.Width := 59;
    lbViewPagamentos.Height := 13;
    lbViewPagamentos.HeightPercent := 100.000000000000000000;
    lbViewPagamentos.WidthPercent := 100.000000000000000000;
    lbViewPagamentos.Caption := 'Pagamentos';
    menu_localidades.SetParentComponent(Self);
    menu_localidades.Name := 'menu_localidades';
    menu_localidades.Left := 128;
    menu_localidades.Top := 153;
    menu_localidades.Width := 113;
    menu_localidades.Height := 48;
    menu_localidades.ChildOrder := 80;
    menu_localidades.Role := '';
    cidade.SetParentComponent(menu_localidades);
    cidade.Name := 'cidade';
    cidade.Left := 6;
    cidade.Top := 2;
    cidade.Width := 100;
    cidade.Height := 20;
    cidade.ChildOrder := 95;
    cidade.Role := '';
    SetEvent(cidade, Self, 'OnClick', 'cidadeClick');
    lbViewCidade.SetParentComponent(cidade);
    lbViewCidade.Name := 'lbViewCidade';
    lbViewCidade.Left := 30;
    lbViewCidade.Top := 4;
    lbViewCidade.Width := 38;
    lbViewCidade.Height := 13;
    lbViewCidade.HeightPercent := 100.000000000000000000;
    lbViewCidade.WidthPercent := 100.000000000000000000;
    lbViewCidade.Caption := 'Cidades';
    ufs.SetParentComponent(menu_localidades);
    ufs.Name := 'ufs';
    ufs.Left := 6;
    ufs.Top := 25;
    ufs.Width := 100;
    ufs.Height := 20;
    ufs.ChildOrder := 95;
    ufs.Role := '';
    SetEvent(ufs, Self, 'OnClick', 'ufsClick');
    lbViewUF.SetParentComponent(ufs);
    lbViewUF.Name := 'lbViewUF';
    lbViewUF.Left := 42;
    lbViewUF.Top := 4;
    lbViewUF.Width := 18;
    lbViewUF.Height := 13;
    lbViewUF.HeightPercent := 100.000000000000000000;
    lbViewUF.WidthPercent := 100.000000000000000000;
    lbViewUF.Caption := 'UFs';
    menu_sincronizacao.SetParentComponent(Self);
    menu_sincronizacao.Name := 'menu_sincronizacao';
    menu_sincronizacao.Left := 5;
    menu_sincronizacao.Top := 550;
    menu_sincronizacao.Width := 113;
    menu_sincronizacao.Height := 69;
    menu_sincronizacao.ChildOrder := 80;
    menu_sincronizacao.Role := '';
    sincronizacao_service.SetParentComponent(menu_sincronizacao);
    sincronizacao_service.Name := 'sincronizacao_service';
    sincronizacao_service.Left := 6;
    sincronizacao_service.Top := 2;
    sincronizacao_service.Width := 100;
    sincronizacao_service.Height := 20;
    sincronizacao_service.ChildOrder := 95;
    sincronizacao_service.Role := '';
    SetEvent(sincronizacao_service, Self, 'OnClick', 'sincronizacao_serviceClick');
    lbViewSincronizacao_Service.SetParentComponent(sincronizacao_service);
    lbViewSincronizacao_Service.Name := 'lbViewSincronizacao_Service';
    lbViewSincronizacao_Service.Left := 1;
    lbViewSincronizacao_Service.Top := 4;
    lbViewSincronizacao_Service.Width := 100;
    lbViewSincronizacao_Service.Height := 13;
    lbViewSincronizacao_Service.HeightPercent := 100.000000000000000000;
    lbViewSincronizacao_Service.WidthPercent := 100.000000000000000000;
    lbViewSincronizacao_Service.Caption := 'Retaguarda Servidor';
    erros_catalogados.SetParentComponent(menu_sincronizacao);
    erros_catalogados.Name := 'erros_catalogados';
    erros_catalogados.Left := 6;
    erros_catalogados.Top := 47;
    erros_catalogados.Width := 100;
    erros_catalogados.Height := 20;
    erros_catalogados.ChildOrder := 95;
    erros_catalogados.Role := '';
    SetEvent(erros_catalogados, Self, 'OnClick', 'erros_catalogadosClick');
    lbViewErros_Catalogados.SetParentComponent(erros_catalogados);
    lbViewErros_Catalogados.Name := 'lbViewErros_Catalogados';
    lbViewErros_Catalogados.Left := 7;
    lbViewErros_Catalogados.Top := 4;
    lbViewErros_Catalogados.Width := 88;
    lbViewErros_Catalogados.Height := 13;
    lbViewErros_Catalogados.HeightPercent := 100.000000000000000000;
    lbViewErros_Catalogados.WidthPercent := 100.000000000000000000;
    lbViewErros_Catalogados.Caption := 'Erros Catalogados';
    sincronizacao_servidor_retaguarda.SetParentComponent(menu_sincronizacao);
    sincronizacao_servidor_retaguarda.Name := 'sincronizacao_servidor_retaguarda';
    sincronizacao_servidor_retaguarda.Left := 5;
    sincronizacao_servidor_retaguarda.Top := 25;
    sincronizacao_servidor_retaguarda.Width := 100;
    sincronizacao_servidor_retaguarda.Height := 20;
    sincronizacao_servidor_retaguarda.ChildOrder := 95;
    sincronizacao_servidor_retaguarda.Role := '';
    SetEvent(sincronizacao_servidor_retaguarda, Self, 'OnClick', 'sincronizacao_servidor_retaguardaClick');
    lbViewSincronizacao_Servidor_Retaguarda.SetParentComponent(sincronizacao_servidor_retaguarda);
    lbViewSincronizacao_Servidor_Retaguarda.Name := 'lbViewSincronizacao_Servidor_Retaguarda';
    lbViewSincronizacao_Servidor_Retaguarda.Left := 3;
    lbViewSincronizacao_Servidor_Retaguarda.Top := 3;
    lbViewSincronizacao_Servidor_Retaguarda.Width := 100;
    lbViewSincronizacao_Servidor_Retaguarda.Height := 13;
    lbViewSincronizacao_Servidor_Retaguarda.HeightPercent := 100.000000000000000000;
    lbViewSincronizacao_Servidor_Retaguarda.WidthPercent := 100.000000000000000000;
    lbViewSincronizacao_Servidor_Retaguarda.Caption := 'Servidor Retaguarda';
    menu_tributacoes.SetParentComponent(Self);
    menu_tributacoes.Name := 'menu_tributacoes';
    menu_tributacoes.Left := 128;
    menu_tributacoes.Top := 208;
    menu_tributacoes.Width := 121;
    menu_tributacoes.Height := 413;
    menu_tributacoes.ChildOrder := 80;
    menu_tributacoes.Role := '';
    ncm.SetParentComponent(menu_tributacoes);
    ncm.Name := 'ncm';
    ncm.Left := 10;
    ncm.Top := 2;
    ncm.Width := 100;
    ncm.Height := 20;
    ncm.ChildOrder := 95;
    ncm.Role := '';
    SetEvent(ncm, Self, 'OnClick', 'ncmClick');
    lbViewNcm.SetParentComponent(ncm);
    lbViewNcm.Name := 'lbViewNcm';
    lbViewNcm.Left := 40;
    lbViewNcm.Top := 4;
    lbViewNcm.Width := 20;
    lbViewNcm.Height := 13;
    lbViewNcm.HeightPercent := 100.000000000000000000;
    lbViewNcm.WidthPercent := 100.000000000000000000;
    lbViewNcm.Caption := 'Ncm';
    cfop.SetParentComponent(menu_tributacoes);
    cfop.Name := 'cfop';
    cfop.Left := 10;
    cfop.Top := 25;
    cfop.Width := 100;
    cfop.Height := 20;
    cfop.ChildOrder := 95;
    cfop.Role := '';
    SetEvent(cfop, Self, 'OnClick', 'cfopClick');
    lbViewCfop.SetParentComponent(cfop);
    lbViewCfop.Name := 'lbViewCfop';
    lbViewCfop.Left := 37;
    lbViewCfop.Top := 4;
    lbViewCfop.Width := 23;
    lbViewCfop.Height := 13;
    lbViewCfop.HeightPercent := 100.000000000000000000;
    lbViewCfop.WidthPercent := 100.000000000000000000;
    lbViewCfop.Caption := 'Cfop';
    menu_reforma_tributaria.SetParentComponent(menu_tributacoes);
    menu_reforma_tributaria.Name := 'menu_reforma_tributaria';
    menu_reforma_tributaria.Left := 4;
    menu_reforma_tributaria.Top := 279;
    menu_reforma_tributaria.Width := 113;
    menu_reforma_tributaria.Height := 82;
    menu_reforma_tributaria.ChildOrder := 80;
    menu_reforma_tributaria.Role := '';
    rt_ibs_cbs_cst.SetParentComponent(menu_reforma_tributaria);
    rt_ibs_cbs_cst.Name := 'rt_ibs_cbs_cst';
    rt_ibs_cbs_cst.Left := 6;
    rt_ibs_cbs_cst.Top := 2;
    rt_ibs_cbs_cst.Width := 100;
    rt_ibs_cbs_cst.Height := 20;
    rt_ibs_cbs_cst.ChildOrder := 95;
    rt_ibs_cbs_cst.Role := '';
    SetEvent(rt_ibs_cbs_cst, Self, 'OnClick', 'rt_ibs_cbs_cstClick');
    lbViewRt_Ibs_Cbs_Cst.SetParentComponent(rt_ibs_cbs_cst);
    lbViewRt_Ibs_Cbs_Cst.Name := 'lbViewRt_Ibs_Cbs_Cst';
    lbViewRt_Ibs_Cbs_Cst.Left := 18;
    lbViewRt_Ibs_Cbs_Cst.Top := 4;
    lbViewRt_Ibs_Cbs_Cst.Width := 60;
    lbViewRt_Ibs_Cbs_Cst.Height := 13;
    lbViewRt_Ibs_Cbs_Cst.HeightPercent := 100.000000000000000000;
    lbViewRt_Ibs_Cbs_Cst.WidthPercent := 100.000000000000000000;
    lbViewRt_Ibs_Cbs_Cst.Caption := 'IBS CBS CST';
    rt_is_cst.SetParentComponent(menu_reforma_tributaria);
    rt_is_cst.Name := 'rt_is_cst';
    rt_is_cst.Left := 6;
    rt_is_cst.Top := 25;
    rt_is_cst.Width := 100;
    rt_is_cst.Height := 20;
    rt_is_cst.ChildOrder := 95;
    rt_is_cst.Role := '';
    SetEvent(rt_is_cst, Self, 'OnClick', 'rt_is_cstClick');
    lbViewRt_Is_Cst.SetParentComponent(rt_is_cst);
    lbViewRt_Is_Cst.Name := 'lbViewRt_Is_Cst';
    lbViewRt_Is_Cst.Left := 36;
    lbViewRt_Is_Cst.Top := 4;
    lbViewRt_Is_Cst.Width := 32;
    lbViewRt_Is_Cst.Height := 13;
    lbViewRt_Is_Cst.HeightPercent := 100.000000000000000000;
    lbViewRt_Is_Cst.WidthPercent := 100.000000000000000000;
    lbViewRt_Is_Cst.Caption := 'IS CST';
    rt_credito_presumido.SetParentComponent(menu_reforma_tributaria);
    rt_credito_presumido.Name := 'rt_credito_presumido';
    rt_credito_presumido.Left := 6;
    rt_credito_presumido.Top := 48;
    rt_credito_presumido.Width := 100;
    rt_credito_presumido.Height := 20;
    rt_credito_presumido.ChildOrder := 95;
    rt_credito_presumido.Role := '';
    SetEvent(rt_credito_presumido, Self, 'OnClick', 'rt_credito_presumidoClick');
    lbViewRt_Credito_Presumido.SetParentComponent(rt_credito_presumido);
    lbViewRt_Credito_Presumido.Name := 'lbViewRt_Credito_Presumido';
    lbViewRt_Credito_Presumido.Left := 6;
    lbViewRt_Credito_Presumido.Top := 4;
    lbViewRt_Credito_Presumido.Width := 87;
    lbViewRt_Credito_Presumido.Height := 13;
    lbViewRt_Credito_Presumido.HeightPercent := 100.000000000000000000;
    lbViewRt_Credito_Presumido.WidthPercent := 100.000000000000000000;
    lbViewRt_Credito_Presumido.Caption := 'Cr'#233'dito Presumido';
    cfop_configuracoes.SetParentComponent(menu_tributacoes);
    cfop_configuracoes.Name := 'cfop_configuracoes';
    cfop_configuracoes.Left := 10;
    cfop_configuracoes.Top := 48;
    cfop_configuracoes.Width := 100;
    cfop_configuracoes.Height := 20;
    cfop_configuracoes.ChildOrder := 95;
    cfop_configuracoes.Role := '';
    SetEvent(cfop_configuracoes, Self, 'OnClick', 'cfop_configuracoesClick');
    lbViewCfop_Configuracoes.SetParentComponent(cfop_configuracoes);
    lbViewCfop_Configuracoes.Name := 'lbViewCfop_Configuracoes';
    lbViewCfop_Configuracoes.Left := 5;
    lbViewCfop_Configuracoes.Top := 4;
    lbViewCfop_Configuracoes.Width := 95;
    lbViewCfop_Configuracoes.Height := 13;
    lbViewCfop_Configuracoes.HeightPercent := 100.000000000000000000;
    lbViewCfop_Configuracoes.WidthPercent := 100.000000000000000000;
    lbViewCfop_Configuracoes.Caption := 'Cfop Configura'#231#245'es';
    cst.SetParentComponent(menu_tributacoes);
    cst.Name := 'cst';
    cst.Left := 10;
    cst.Top := 71;
    cst.Width := 100;
    cst.Height := 20;
    cst.ChildOrder := 95;
    cst.Role := '';
    SetEvent(cst, Self, 'OnClick', 'cstClick');
    lbViewCst.SetParentComponent(cst);
    lbViewCst.Name := 'lbViewCst';
    lbViewCst.Left := 40;
    lbViewCst.Top := 7;
    lbViewCst.Width := 16;
    lbViewCst.Height := 13;
    lbViewCst.HeightPercent := 100.000000000000000000;
    lbViewCst.WidthPercent := 100.000000000000000000;
    lbViewCst.Caption := 'Cst';
    cst_pis.SetParentComponent(menu_tributacoes);
    cst_pis.Name := 'cst_pis';
    cst_pis.Left := 10;
    cst_pis.Top := 94;
    cst_pis.Width := 100;
    cst_pis.Height := 20;
    cst_pis.ChildOrder := 95;
    cst_pis.Role := '';
    SetEvent(cst_pis, Self, 'OnClick', 'cst_pisClick');
    lbViewCst_Pis.SetParentComponent(cst_pis);
    lbViewCst_Pis.Name := 'lbViewCst_Pis';
    lbViewCst_Pis.Left := 36;
    lbViewCst_Pis.Top := 4;
    lbViewCst_Pis.Width := 32;
    lbViewCst_Pis.Height := 13;
    lbViewCst_Pis.HeightPercent := 100.000000000000000000;
    lbViewCst_Pis.WidthPercent := 100.000000000000000000;
    lbViewCst_Pis.Caption := 'Cst Pis';
    cst_cofins.SetParentComponent(menu_tributacoes);
    cst_cofins.Name := 'cst_cofins';
    cst_cofins.Left := 10;
    cst_cofins.Top := 117;
    cst_cofins.Width := 100;
    cst_cofins.Height := 20;
    cst_cofins.ChildOrder := 95;
    cst_cofins.Role := '';
    SetEvent(cst_cofins, Self, 'OnClick', 'cst_cofinsClick');
    lbViewCst_Cofins.SetParentComponent(cst_cofins);
    lbViewCst_Cofins.Name := 'lbViewCst_Cofins';
    lbViewCst_Cofins.Left := 27;
    lbViewCst_Cofins.Top := 4;
    lbViewCst_Cofins.Width := 49;
    lbViewCst_Cofins.Height := 13;
    lbViewCst_Cofins.HeightPercent := 100.000000000000000000;
    lbViewCst_Cofins.WidthPercent := 100.000000000000000000;
    lbViewCst_Cofins.Caption := 'Cst Cofins';
    cst_ipi.SetParentComponent(menu_tributacoes);
    cst_ipi.Name := 'cst_ipi';
    cst_ipi.Left := 10;
    cst_ipi.Top := 140;
    cst_ipi.Width := 100;
    cst_ipi.Height := 20;
    cst_ipi.ChildOrder := 95;
    cst_ipi.Role := '';
    SetEvent(cst_ipi, Self, 'OnClick', 'cst_ipiClick');
    lbViewCst_Ipi.SetParentComponent(cst_ipi);
    lbViewCst_Ipi.Name := 'lbViewCst_Ipi';
    lbViewCst_Ipi.Left := 37;
    lbViewCst_Ipi.Top := 4;
    lbViewCst_Ipi.Width := 31;
    lbViewCst_Ipi.Height := 13;
    lbViewCst_Ipi.HeightPercent := 100.000000000000000000;
    lbViewCst_Ipi.WidthPercent := 100.000000000000000000;
    lbViewCst_Ipi.Caption := 'Cst Ipi';
    codigo_bc_piscofins.SetParentComponent(menu_tributacoes);
    codigo_bc_piscofins.Name := 'codigo_bc_piscofins';
    codigo_bc_piscofins.Left := 10;
    codigo_bc_piscofins.Top := 163;
    codigo_bc_piscofins.Width := 100;
    codigo_bc_piscofins.Height := 20;
    codigo_bc_piscofins.ChildOrder := 95;
    codigo_bc_piscofins.Role := '';
    SetEvent(codigo_bc_piscofins, Self, 'OnClick', 'codigo_bc_piscofinsClick');
    lbViewCodigo_bc_Piscofins.SetParentComponent(codigo_bc_piscofins);
    lbViewCodigo_bc_Piscofins.Name := 'lbViewCodigo_bc_Piscofins';
    lbViewCodigo_bc_Piscofins.Left := 27;
    lbViewCodigo_bc_Piscofins.Top := 4;
    lbViewCodigo_bc_Piscofins.Width := 49;
    lbViewCodigo_bc_Piscofins.Height := 13;
    lbViewCodigo_bc_Piscofins.HeightPercent := 100.000000000000000000;
    lbViewCodigo_bc_Piscofins.WidthPercent := 100.000000000000000000;
    lbViewCodigo_bc_Piscofins.Caption := 'C'#243'digo BC';
    origem_csosn.SetParentComponent(menu_tributacoes);
    origem_csosn.Name := 'origem_csosn';
    origem_csosn.Left := 10;
    origem_csosn.Top := 186;
    origem_csosn.Width := 100;
    origem_csosn.Height := 20;
    origem_csosn.ChildOrder := 95;
    origem_csosn.Role := '';
    SetEvent(origem_csosn, Self, 'OnClick', 'origem_csosnClick');
    lbViewOrigem_Csosn.SetParentComponent(origem_csosn);
    lbViewOrigem_Csosn.Name := 'lbViewOrigem_Csosn';
    lbViewOrigem_Csosn.Left := 18;
    lbViewOrigem_Csosn.Top := 4;
    lbViewOrigem_Csosn.Width := 66;
    lbViewOrigem_Csosn.Height := 13;
    lbViewOrigem_Csosn.HeightPercent := 100.000000000000000000;
    lbViewOrigem_Csosn.WidthPercent := 100.000000000000000000;
    lbViewOrigem_Csosn.Caption := 'Origem Csosn';
    codigo_credito_piscofins.SetParentComponent(menu_tributacoes);
    codigo_credito_piscofins.Name := 'codigo_credito_piscofins';
    codigo_credito_piscofins.Left := 10;
    codigo_credito_piscofins.Top := 209;
    codigo_credito_piscofins.Width := 100;
    codigo_credito_piscofins.Height := 20;
    codigo_credito_piscofins.ChildOrder := 95;
    codigo_credito_piscofins.Role := '';
    SetEvent(codigo_credito_piscofins, Self, 'OnClick', 'codigo_credito_piscofinsClick');
    lbViewCodigo_Credito_Piscofins.SetParentComponent(codigo_credito_piscofins);
    lbViewCodigo_Credito_Piscofins.Name := 'lbViewCodigo_Credito_Piscofins';
    lbViewCodigo_Credito_Piscofins.Left := 17;
    lbViewCodigo_Credito_Piscofins.Top := 4;
    lbViewCodigo_Credito_Piscofins.Width := 71;
    lbViewCodigo_Credito_Piscofins.Height := 13;
    lbViewCodigo_Credito_Piscofins.HeightPercent := 100.000000000000000000;
    lbViewCodigo_Credito_Piscofins.WidthPercent := 100.000000000000000000;
    lbViewCodigo_Credito_Piscofins.Caption := 'C'#243'digo Cr'#233'dito';
    desoneracao_icms.SetParentComponent(menu_tributacoes);
    desoneracao_icms.Name := 'desoneracao_icms';
    desoneracao_icms.Left := 10;
    desoneracao_icms.Top := 232;
    desoneracao_icms.Width := 100;
    desoneracao_icms.Height := 20;
    desoneracao_icms.ChildOrder := 95;
    desoneracao_icms.Role := '';
    SetEvent(desoneracao_icms, Self, 'OnClick', 'desoneracao_icmsClick');
    lbViewDesoneracao_Icms.SetParentComponent(desoneracao_icms);
    lbViewDesoneracao_Icms.Name := 'lbViewDesoneracao_Icms';
    lbViewDesoneracao_Icms.Left := 4;
    lbViewDesoneracao_Icms.Top := 4;
    lbViewDesoneracao_Icms.Width := 88;
    lbViewDesoneracao_Icms.Height := 13;
    lbViewDesoneracao_Icms.HeightPercent := 100.000000000000000000;
    lbViewDesoneracao_Icms.WidthPercent := 100.000000000000000000;
    lbViewDesoneracao_Icms.Caption := 'Desonera'#231#227'o Icms';
    csosn.SetParentComponent(menu_tributacoes);
    csosn.Name := 'csosn';
    csosn.Left := 10;
    csosn.Top := 255;
    csosn.Width := 100;
    csosn.Height := 20;
    csosn.ChildOrder := 95;
    csosn.Role := '';
    SetEvent(csosn, Self, 'OnClick', 'csosnClick');
    lbViewCsosn.SetParentComponent(csosn);
    lbViewCsosn.Name := 'lbViewCsosn';
    lbViewCsosn.Left := 39;
    lbViewCsosn.Top := 4;
    lbViewCsosn.Width := 29;
    lbViewCsosn.Height := 13;
    lbViewCsosn.HeightPercent := 100.000000000000000000;
    lbViewCsosn.WidthPercent := 100.000000000000000000;
    lbViewCsosn.Caption := 'Csosn';
    servicos_nacional.SetParentComponent(menu_tributacoes);
    servicos_nacional.Name := 'servicos_nacional';
    servicos_nacional.Left := 10;
    servicos_nacional.Top := 364;
    servicos_nacional.Width := 100;
    servicos_nacional.Height := 20;
    servicos_nacional.ChildOrder := 95;
    servicos_nacional.Role := '';
    SetEvent(servicos_nacional, Self, 'OnClick', 'servicos_nacionalClick');
    lbViewServicos_Nacional.SetParentComponent(servicos_nacional);
    lbViewServicos_Nacional.Name := 'lbViewServicos_Nacional';
    lbViewServicos_Nacional.Left := 10;
    lbViewServicos_Nacional.Top := 3;
    lbViewServicos_Nacional.Width := 83;
    lbViewServicos_Nacional.Height := 13;
    lbViewServicos_Nacional.HeightPercent := 100.000000000000000000;
    lbViewServicos_Nacional.WidthPercent := 100.000000000000000000;
    lbViewServicos_Nacional.Caption := 'Servi'#231'os Nacional';
    nbs.SetParentComponent(menu_tributacoes);
    nbs.Name := 'nbs';
    nbs.Left := 10;
    nbs.Top := 387;
    nbs.Width := 100;
    nbs.Height := 20;
    nbs.ChildOrder := 95;
    nbs.Role := '';
    SetEvent(nbs, Self, 'OnClick', 'nbsClick');
    lbViewNbs.SetParentComponent(nbs);
    lbViewNbs.Name := 'lbViewNbs';
    lbViewNbs.Left := 37;
    lbViewNbs.Top := 4;
    lbViewNbs.Width := 18;
    lbViewNbs.Height := 13;
    lbViewNbs.HeightPercent := 100.000000000000000000;
    lbViewNbs.WidthPercent := 100.000000000000000000;
    lbViewNbs.Caption := 'Nbs';
    menu_cadastros.SetParentComponent(Self);
    menu_cadastros.Name := 'menu_cadastros';
    menu_cadastros.Left := 256;
    menu_cadastros.Top := 9;
    menu_cadastros.Width := 249;
    menu_cadastros.Height := 510;
    menu_cadastros.ChildOrder := 80;
    menu_cadastros.Role := '';
    promocoes.SetParentComponent(menu_cadastros);
    promocoes.Name := 'promocoes';
    promocoes.Left := 15;
    promocoes.Top := 25;
    promocoes.Width := 100;
    promocoes.Height := 20;
    promocoes.ChildOrder := 95;
    promocoes.Role := '';
    SetEvent(promocoes, Self, 'OnClick', 'promocoesClick');
    lbViewPromocoes.SetParentComponent(promocoes);
    lbViewPromocoes.Name := 'lbViewPromocoes';
    lbViewPromocoes.Left := 32;
    lbViewPromocoes.Top := 4;
    lbViewPromocoes.Width := 52;
    lbViewPromocoes.Height := 13;
    lbViewPromocoes.HeightPercent := 100.000000000000000000;
    lbViewPromocoes.WidthPercent := 100.000000000000000000;
    lbViewPromocoes.Caption := 'Promo'#231#245'es';
    funcionarios.SetParentComponent(menu_cadastros);
    funcionarios.Name := 'funcionarios';
    funcionarios.Left := 15;
    funcionarios.Top := 71;
    funcionarios.Width := 100;
    funcionarios.Height := 20;
    funcionarios.ChildOrder := 95;
    funcionarios.Role := '';
    SetEvent(funcionarios, Self, 'OnClick', 'funcionariosClick');
    lbViewFuncionarios.SetParentComponent(funcionarios);
    lbViewFuncionarios.Name := 'lbViewFuncionarios';
    lbViewFuncionarios.Left := 24;
    lbViewFuncionarios.Top := 4;
    lbViewFuncionarios.Width := 60;
    lbViewFuncionarios.Height := 13;
    lbViewFuncionarios.HeightPercent := 100.000000000000000000;
    lbViewFuncionarios.WidthPercent := 100.000000000000000000;
    lbViewFuncionarios.Caption := 'Funcion'#225'rios';
    clientes.SetParentComponent(menu_cadastros);
    clientes.Name := 'clientes';
    clientes.Left := 15;
    clientes.Top := 48;
    clientes.Width := 100;
    clientes.Height := 20;
    clientes.ChildOrder := 95;
    clientes.Role := '';
    SetEvent(clientes, Self, 'OnClick', 'clientesClick');
    lbViewClientes.SetParentComponent(clientes);
    lbViewClientes.Name := 'lbViewClientes';
    lbViewClientes.Left := 36;
    lbViewClientes.Top := 4;
    lbViewClientes.Width := 38;
    lbViewClientes.Height := 13;
    lbViewClientes.HeightPercent := 100.000000000000000000;
    lbViewClientes.WidthPercent := 100.000000000000000000;
    lbViewClientes.Caption := 'Clientes';
    modalidades.SetParentComponent(menu_cadastros);
    modalidades.Name := 'modalidades';
    modalidades.Left := 15;
    modalidades.Top := 93;
    modalidades.Width := 100;
    modalidades.Height := 20;
    modalidades.ChildOrder := 95;
    modalidades.Role := '';
    SetEvent(modalidades, Self, 'OnClick', 'modalidadesClick');
    lbViewModalidades.SetParentComponent(modalidades);
    lbViewModalidades.Name := 'lbViewModalidades';
    lbViewModalidades.Left := 25;
    lbViewModalidades.Top := 4;
    lbViewModalidades.Width := 59;
    lbViewModalidades.Height := 13;
    lbViewModalidades.HeightPercent := 100.000000000000000000;
    lbViewModalidades.WidthPercent := 100.000000000000000000;
    lbViewModalidades.Caption := 'Modalidades';
    aliquotas.SetParentComponent(menu_cadastros);
    aliquotas.Name := 'aliquotas';
    aliquotas.Left := 15;
    aliquotas.Top := 115;
    aliquotas.Width := 100;
    aliquotas.Height := 20;
    aliquotas.ChildOrder := 95;
    aliquotas.Role := '';
    SetEvent(aliquotas, Self, 'OnClick', 'aliquotasClick');
    lbViewAliquotas.SetParentComponent(aliquotas);
    lbViewAliquotas.Name := 'lbViewAliquotas';
    lbViewAliquotas.Left := 32;
    lbViewAliquotas.Top := 4;
    lbViewAliquotas.Width := 44;
    lbViewAliquotas.Height := 13;
    lbViewAliquotas.HeightPercent := 100.000000000000000000;
    lbViewAliquotas.WidthPercent := 100.000000000000000000;
    lbViewAliquotas.Caption := 'Aliquotas';
    parceiros.SetParentComponent(menu_cadastros);
    parceiros.Name := 'parceiros';
    parceiros.Left := 15;
    parceiros.Top := 138;
    parceiros.Width := 100;
    parceiros.Height := 20;
    parceiros.ChildOrder := 95;
    parceiros.Role := '';
    SetEvent(parceiros, Self, 'OnClick', 'parceirosClick');
    lbViewParceiros.SetParentComponent(parceiros);
    lbViewParceiros.Name := 'lbViewParceiros';
    lbViewParceiros.Left := 32;
    lbViewParceiros.Top := 4;
    lbViewParceiros.Width := 44;
    lbViewParceiros.Height := 13;
    lbViewParceiros.HeightPercent := 100.000000000000000000;
    lbViewParceiros.WidthPercent := 100.000000000000000000;
    lbViewParceiros.Caption := 'Parceiros';
    contas.SetParentComponent(menu_cadastros);
    contas.Name := 'contas';
    contas.Left := 15;
    contas.Top := 161;
    contas.Width := 100;
    contas.Height := 20;
    contas.ChildOrder := 95;
    contas.Role := '';
    SetEvent(contas, Self, 'OnClick', 'contasClick');
    lbViewContas.SetParentComponent(contas);
    lbViewContas.Name := 'lbViewContas';
    lbViewContas.Left := 34;
    lbViewContas.Top := 4;
    lbViewContas.Width := 34;
    lbViewContas.Height := 13;
    lbViewContas.HeightPercent := 100.000000000000000000;
    lbViewContas.WidthPercent := 100.000000000000000000;
    lbViewContas.Caption := 'Contas';
    bancos.SetParentComponent(menu_cadastros);
    bancos.Name := 'bancos';
    bancos.Left := 15;
    bancos.Top := 184;
    bancos.Width := 100;
    bancos.Height := 20;
    bancos.ChildOrder := 95;
    bancos.Role := '';
    SetEvent(bancos, Self, 'OnClick', 'bancosClick');
    lbViewBancos.SetParentComponent(bancos);
    lbViewBancos.Name := 'lbViewBancos';
    lbViewBancos.Left := 34;
    lbViewBancos.Top := 4;
    lbViewBancos.Width := 34;
    lbViewBancos.Height := 13;
    lbViewBancos.HeightPercent := 100.000000000000000000;
    lbViewBancos.WidthPercent := 100.000000000000000000;
    lbViewBancos.Caption := 'Bancos';
    banco_carteiras.SetParentComponent(menu_cadastros);
    banco_carteiras.Name := 'banco_carteiras';
    banco_carteiras.Left := 15;
    banco_carteiras.Top := 206;
    banco_carteiras.Width := 100;
    banco_carteiras.Height := 20;
    banco_carteiras.ChildOrder := 95;
    banco_carteiras.Role := '';
    SetEvent(banco_carteiras, Self, 'OnClick', 'banco_carteirasClick');
    lbViewBanco_Carteiras.SetParentComponent(banco_carteiras);
    lbViewBanco_Carteiras.Name := 'lbViewBanco_Carteiras';
    lbViewBanco_Carteiras.Left := 14;
    lbViewBanco_Carteiras.Top := 4;
    lbViewBanco_Carteiras.Width := 76;
    lbViewBanco_Carteiras.Height := 13;
    lbViewBanco_Carteiras.HeightPercent := 100.000000000000000000;
    lbViewBanco_Carteiras.WidthPercent := 100.000000000000000000;
    lbViewBanco_Carteiras.Caption := 'Banco Carteiras';
    operadoras_cartao.SetParentComponent(menu_cadastros);
    operadoras_cartao.Name := 'operadoras_cartao';
    operadoras_cartao.Left := 15;
    operadoras_cartao.Top := 228;
    operadoras_cartao.Width := 100;
    operadoras_cartao.Height := 20;
    operadoras_cartao.ChildOrder := 95;
    operadoras_cartao.Role := '';
    SetEvent(operadoras_cartao, Self, 'OnClick', 'operadoras_cartaoClick');
    lbViewOperadoras_Cartao.SetParentComponent(operadoras_cartao);
    lbViewOperadoras_Cartao.Name := 'lbViewOperadoras_Cartao';
    lbViewOperadoras_Cartao.Left := 1;
    lbViewOperadoras_Cartao.Top := 4;
    lbViewOperadoras_Cartao.Width := 93;
    lbViewOperadoras_Cartao.Height := 13;
    lbViewOperadoras_Cartao.HeightPercent := 100.000000000000000000;
    lbViewOperadoras_Cartao.WidthPercent := 100.000000000000000000;
    lbViewOperadoras_Cartao.Caption := 'Operadoras Cart'#227'o';
    contadores.SetParentComponent(menu_cadastros);
    contadores.Name := 'contadores';
    contadores.Left := 15;
    contadores.Top := 251;
    contadores.Width := 100;
    contadores.Height := 20;
    contadores.ChildOrder := 95;
    contadores.Role := '';
    SetEvent(contadores, Self, 'OnClick', 'contadoresClick');
    lbViewContadores.SetParentComponent(contadores);
    lbViewContadores.Name := 'lbViewContadores';
    lbViewContadores.Left := 28;
    lbViewContadores.Top := 4;
    lbViewContadores.Width := 56;
    lbViewContadores.Height := 13;
    lbViewContadores.HeightPercent := 100.000000000000000000;
    lbViewContadores.WidthPercent := 100.000000000000000000;
    lbViewContadores.Caption := 'Contadores';
    fornecedores.SetParentComponent(menu_cadastros);
    fornecedores.Name := 'fornecedores';
    fornecedores.Left := 15;
    fornecedores.Top := 274;
    fornecedores.Width := 100;
    fornecedores.Height := 20;
    fornecedores.ChildOrder := 95;
    fornecedores.Role := '';
    SetEvent(fornecedores, Self, 'OnClick', 'fornecedoresClick');
    lbViewFornecedores.SetParentComponent(fornecedores);
    lbViewFornecedores.Name := 'lbViewFornecedores';
    lbViewFornecedores.Left := 18;
    lbViewFornecedores.Top := 4;
    lbViewFornecedores.Width := 66;
    lbViewFornecedores.Height := 13;
    lbViewFornecedores.HeightPercent := 100.000000000000000000;
    lbViewFornecedores.WidthPercent := 100.000000000000000000;
    lbViewFornecedores.Caption := 'Fornecedores';
    tipos.SetParentComponent(menu_cadastros);
    tipos.Name := 'tipos';
    tipos.Left := 15;
    tipos.Top := 297;
    tipos.Width := 100;
    tipos.Height := 20;
    tipos.ChildOrder := 95;
    tipos.Role := '';
    SetEvent(tipos, Self, 'OnClick', 'tiposClick');
    lbViewTipos.SetParentComponent(tipos);
    lbViewTipos.Name := 'lbViewTipos';
    lbViewTipos.Left := 43;
    lbViewTipos.Top := 4;
    lbViewTipos.Width := 25;
    lbViewTipos.Height := 13;
    lbViewTipos.HeightPercent := 100.000000000000000000;
    lbViewTipos.WidthPercent := 100.000000000000000000;
    lbViewTipos.Caption := 'Tipos';
    modulos.SetParentComponent(menu_cadastros);
    modulos.Name := 'modulos';
    modulos.Left := 15;
    modulos.Top := 319;
    modulos.Width := 100;
    modulos.Height := 20;
    modulos.ChildOrder := 95;
    modulos.Role := '';
    SetEvent(modulos, Self, 'OnClick', 'modulosClick');
    lbViewModulos.SetParentComponent(modulos);
    lbViewModulos.Name := 'lbViewModulos';
    lbViewModulos.Left := 8;
    lbViewModulos.Top := 5;
    lbViewModulos.Width := 84;
    lbViewModulos.Height := 13;
    lbViewModulos.HeightPercent := 100.000000000000000000;
    lbViewModulos.WidthPercent := 100.000000000000000000;
    lbViewModulos.Caption := 'M'#243'd. Retaguarda';
    pdvs.SetParentComponent(menu_cadastros);
    pdvs.Name := 'pdvs';
    pdvs.Left := 15;
    pdvs.Top := 364;
    pdvs.Width := 100;
    pdvs.Height := 20;
    pdvs.ChildOrder := 95;
    pdvs.Role := '';
    SetEvent(pdvs, Self, 'OnClick', 'pdvsClick');
    lbViewPdvs.SetParentComponent(pdvs);
    lbViewPdvs.Name := 'lbViewPdvs';
    lbViewPdvs.Left := 44;
    lbViewPdvs.Top := 5;
    lbViewPdvs.Width := 24;
    lbViewPdvs.Height := 13;
    lbViewPdvs.HeightPercent := 100.000000000000000000;
    lbViewPdvs.WidthPercent := 100.000000000000000000;
    lbViewPdvs.Caption := 'PDVs';
    segmentos.SetParentComponent(menu_cadastros);
    segmentos.Name := 'segmentos';
    segmentos.Left := 15;
    segmentos.Top := 341;
    segmentos.Width := 100;
    segmentos.Height := 20;
    segmentos.ChildOrder := 95;
    segmentos.Role := '';
    SetEvent(segmentos, Self, 'OnClick', 'segmentosClick');
    lbViewSegmento.SetParentComponent(segmentos);
    lbViewSegmento.Name := 'lbViewSegmento';
    lbViewSegmento.Left := 31;
    lbViewSegmento.Top := 4;
    lbViewSegmento.Width := 53;
    lbViewSegmento.Height := 13;
    lbViewSegmento.HeightPercent := 100.000000000000000000;
    lbViewSegmento.WidthPercent := 100.000000000000000000;
    lbViewSegmento.Caption := 'Segmentos';
    menu_plano_contas.SetParentComponent(menu_cadastros);
    menu_plano_contas.Name := 'menu_plano_contas';
    menu_plano_contas.Left := 9;
    menu_plano_contas.Top := 389;
    menu_plano_contas.Width := 113;
    menu_plano_contas.Height := 117;
    menu_plano_contas.ChildOrder := 80;
    menu_plano_contas.Role := '';
    plano_contas.SetParentComponent(menu_plano_contas);
    plano_contas.Name := 'plano_contas';
    plano_contas.Left := 6;
    plano_contas.Top := 2;
    plano_contas.Width := 100;
    plano_contas.Height := 20;
    plano_contas.ChildOrder := 95;
    plano_contas.Role := '';
    SetEvent(plano_contas, Self, 'OnClick', 'plano_contasClick');
    lbViewPlano_Contas.SetParentComponent(plano_contas);
    lbViewPlano_Contas.Name := 'lbViewPlano_Contas';
    lbViewPlano_Contas.Left := 37;
    lbViewPlano_Contas.Top := 3;
    lbViewPlano_Contas.Width := 31;
    lbViewPlano_Contas.Height := 13;
    lbViewPlano_Contas.HeightPercent := 100.000000000000000000;
    lbViewPlano_Contas.WidthPercent := 100.000000000000000000;
    lbViewPlano_Contas.Caption := 'Planos';
    plano_contas_contabil.SetParentComponent(menu_plano_contas);
    plano_contas_contabil.Name := 'plano_contas_contabil';
    plano_contas_contabil.Left := 6;
    plano_contas_contabil.Top := 25;
    plano_contas_contabil.Width := 100;
    plano_contas_contabil.Height := 20;
    plano_contas_contabil.ChildOrder := 95;
    plano_contas_contabil.Role := '';
    SetEvent(plano_contas_contabil, Self, 'OnClick', 'plano_contas_contabilClick');
    lbViewPlano_Contas_Contabil.SetParentComponent(plano_contas_contabil);
    lbViewPlano_Contas_Contabil.Name := 'lbViewPlano_Contas_Contabil';
    lbViewPlano_Contas_Contabil.Left := 20;
    lbViewPlano_Contas_Contabil.Top := 4;
    lbViewPlano_Contas_Contabil.Width := 68;
    lbViewPlano_Contas_Contabil.Height := 13;
    lbViewPlano_Contas_Contabil.HeightPercent := 100.000000000000000000;
    lbViewPlano_Contas_Contabil.WidthPercent := 100.000000000000000000;
    lbViewPlano_Contas_Contabil.Caption := 'Plano Cont'#225'bil';
    plano_contas2.SetParentComponent(menu_plano_contas);
    plano_contas2.Name := 'plano_contas2';
    plano_contas2.Left := 6;
    plano_contas2.Top := 71;
    plano_contas2.Width := 100;
    plano_contas2.Height := 20;
    plano_contas2.ChildOrder := 95;
    plano_contas2.Role := '';
    SetEvent(plano_contas2, Self, 'OnClick', 'plano_contas2Click');
    lbViewPlano_Contas2.SetParentComponent(plano_contas2);
    lbViewPlano_Contas2.Name := 'lbViewPlano_Contas2';
    lbViewPlano_Contas2.Left := 41;
    lbViewPlano_Contas2.Top := 4;
    lbViewPlano_Contas2.Width := 35;
    lbViewPlano_Contas2.Height := 13;
    lbViewPlano_Contas2.HeightPercent := 100.000000000000000000;
    lbViewPlano_Contas2.WidthPercent := 100.000000000000000000;
    lbViewPlano_Contas2.Caption := 'Plano 2';
    plano_contas1.SetParentComponent(menu_plano_contas);
    plano_contas1.Name := 'plano_contas1';
    plano_contas1.Left := 6;
    plano_contas1.Top := 48;
    plano_contas1.Width := 100;
    plano_contas1.Height := 20;
    plano_contas1.ChildOrder := 95;
    plano_contas1.Role := '';
    SetEvent(plano_contas1, Self, 'OnClick', 'plano_contas1Click');
    lbViewPlano_Contas1.SetParentComponent(plano_contas1);
    lbViewPlano_Contas1.Name := 'lbViewPlano_Contas1';
    lbViewPlano_Contas1.Left := 41;
    lbViewPlano_Contas1.Top := 4;
    lbViewPlano_Contas1.Width := 35;
    lbViewPlano_Contas1.Height := 13;
    lbViewPlano_Contas1.HeightPercent := 100.000000000000000000;
    lbViewPlano_Contas1.WidthPercent := 100.000000000000000000;
    lbViewPlano_Contas1.Caption := 'Plano 1';
    plano_contas3.SetParentComponent(menu_plano_contas);
    plano_contas3.Name := 'plano_contas3';
    plano_contas3.Left := 6;
    plano_contas3.Top := 93;
    plano_contas3.Width := 100;
    plano_contas3.Height := 20;
    plano_contas3.ChildOrder := 95;
    plano_contas3.Role := '';
    SetEvent(plano_contas3, Self, 'OnClick', 'plano_contas3Click');
    lbViewPlano_Contas3.SetParentComponent(plano_contas3);
    lbViewPlano_Contas3.Name := 'lbViewPlano_Contas3';
    lbViewPlano_Contas3.Left := 42;
    lbViewPlano_Contas3.Top := 4;
    lbViewPlano_Contas3.Width := 35;
    lbViewPlano_Contas3.Height := 13;
    lbViewPlano_Contas3.HeightPercent := 100.000000000000000000;
    lbViewPlano_Contas3.WidthPercent := 100.000000000000000000;
    lbViewPlano_Contas3.Caption := 'Plano 3';
    servicos.SetParentComponent(menu_cadastros);
    servicos.Name := 'servicos';
    servicos.Left := 135;
    servicos.Top := 3;
    servicos.Width := 100;
    servicos.Height := 20;
    servicos.ChildOrder := 95;
    servicos.Role := '';
    SetEvent(servicos, Self, 'OnClick', 'servicosClick');
    lbViewServicos.SetParentComponent(servicos);
    lbViewServicos.Name := 'lbViewServicos';
    lbViewServicos.Left := 34;
    lbViewServicos.Top := 2;
    lbViewServicos.Width := 40;
    lbViewServicos.Height := 13;
    lbViewServicos.HeightPercent := 100.000000000000000000;
    lbViewServicos.WidthPercent := 100.000000000000000000;
    lbViewServicos.Caption := 'Servi'#231'os';
    menu_vendas.SetParentComponent(Self);
    menu_vendas.Name := 'menu_vendas';
    menu_vendas.Left := 5;
    menu_vendas.Top := 279;
    menu_vendas.Width := 113;
    menu_vendas.Height := 75;
    menu_vendas.ChildOrder := 32;
    menu_vendas.Role := '';
    vendas.SetParentComponent(menu_vendas);
    vendas.Name := 'vendas';
    vendas.Left := 9;
    vendas.Top := 3;
    vendas.Width := 97;
    vendas.Height := 20;
    vendas.ChildOrder := 95;
    vendas.Role := '';
    SetEvent(vendas, Self, 'OnClick', 'vendasClick');
    lbViewVendas.SetParentComponent(vendas);
    lbViewVendas.Name := 'lbViewVendas';
    lbViewVendas.Left := 32;
    lbViewVendas.Top := 4;
    lbViewVendas.Width := 35;
    lbViewVendas.Height := 13;
    lbViewVendas.HeightPercent := 100.000000000000000000;
    lbViewVendas.WidthPercent := 100.000000000000000000;
    lbViewVendas.Caption := 'Vendas';
    vendas_servicos.SetParentComponent(menu_vendas);
    vendas_servicos.Name := 'vendas_servicos';
    vendas_servicos.Left := 9;
    vendas_servicos.Top := 25;
    vendas_servicos.Width := 97;
    vendas_servicos.Height := 20;
    vendas_servicos.ChildOrder := 95;
    vendas_servicos.Role := '';
    SetEvent(vendas_servicos, Self, 'OnClick', 'vendas_servicosClick');
    lbViewVendasServicos.SetParentComponent(vendas_servicos);
    lbViewVendasServicos.Name := 'lbViewVendasServicos';
    lbViewVendasServicos.Left := 8;
    lbViewVendasServicos.Top := 4;
    lbViewVendasServicos.Width := 78;
    lbViewVendasServicos.Height := 13;
    lbViewVendasServicos.HeightPercent := 100.000000000000000000;
    lbViewVendasServicos.WidthPercent := 100.000000000000000000;
    lbViewVendasServicos.Caption := 'Vendas Servi'#231'os';
    cupons.SetParentComponent(menu_vendas);
    cupons.Name := 'cupons';
    cupons.Left := 6;
    cupons.Top := 48;
    cupons.Width := 100;
    cupons.Height := 20;
    cupons.ChildOrder := 95;
    cupons.Role := '';
    SetEvent(cupons, Self, 'OnClick', 'cuponsClick');
    lbViewCupons.SetParentComponent(cupons);
    lbViewCupons.Name := 'lbViewCupons';
    lbViewCupons.Left := 32;
    lbViewCupons.Top := 4;
    lbViewCupons.Width := 36;
    lbViewCupons.Height := 13;
    lbViewCupons.HeightPercent := 100.000000000000000000;
    lbViewCupons.WidthPercent := 100.000000000000000000;
    lbViewCupons.Caption := 'Cupons';
    menu_documentos_fiscais.SetParentComponent(Self);
    menu_documentos_fiscais.Name := 'menu_documentos_fiscais';
    menu_documentos_fiscais.Left := 128;
    menu_documentos_fiscais.Top := 627;
    menu_documentos_fiscais.Width := 122;
    menu_documentos_fiscais.Height := 56;
    menu_documentos_fiscais.ChildOrder := 32;
    menu_documentos_fiscais.Role := '';
    nfe.SetParentComponent(menu_documentos_fiscais);
    nfe.Name := 'nfe';
    nfe.Left := 6;
    nfe.Top := 7;
    nfe.Width := 107;
    nfe.Height := 20;
    nfe.ChildOrder := 95;
    nfe.Role := '';
    SetEvent(nfe, Self, 'OnClick', 'nfeClick');
    lbViewNfe.SetParentComponent(nfe);
    lbViewNfe.Name := 'lbViewNfe';
    lbViewNfe.Left := 48;
    lbViewNfe.Top := 4;
    lbViewNfe.Width := 19;
    lbViewNfe.Height := 13;
    lbViewNfe.HeightPercent := 100.000000000000000000;
    lbViewNfe.WidthPercent := 100.000000000000000000;
    lbViewNfe.Caption := 'NFe';
    nfse.SetParentComponent(menu_documentos_fiscais);
    nfse.Name := 'nfse';
    nfse.Left := 6;
    nfse.Top := 29;
    nfse.Width := 107;
    nfse.Height := 20;
    nfse.ChildOrder := 95;
    nfse.Role := '';
    SetEvent(nfse, Self, 'OnClick', 'nfseClick');
    lbViewNfse.SetParentComponent(nfse);
    lbViewNfse.Name := 'lbViewNfse';
    lbViewNfse.Left := 48;
    lbViewNfse.Top := 4;
    lbViewNfse.Width := 25;
    lbViewNfse.Height := 13;
    lbViewNfse.HeightPercent := 100.000000000000000000;
    lbViewNfse.WidthPercent := 100.000000000000000000;
    lbViewNfse.Caption := 'NFSe';
    painel_aliados.SetParentComponent(Self);
    painel_aliados.Name := 'painel_aliados';
    painel_aliados.Left := 5;
    painel_aliados.Top := 721;
    painel_aliados.Width := 113;
    painel_aliados.Height := 20;
    painel_aliados.ChildOrder := 95;
    painel_aliados.Role := '';
    SetEvent(painel_aliados, Self, 'OnClick', 'painel_aliadosClick');
    lbViewPainelAliados.SetParentComponent(painel_aliados);
    lbViewPainelAliados.Name := 'lbViewPainelAliados';
    lbViewPainelAliados.Left := 9;
    lbViewPainelAliados.Top := 3;
    lbViewPainelAliados.Width := 80;
    lbViewPainelAliados.Height := 13;
    lbViewPainelAliados.Font.Charset := DEFAULT_CHARSET;
    lbViewPainelAliados.Font.Color := clWindowText;
    lbViewPainelAliados.Font.Height := -11;
    lbViewPainelAliados.Font.Name := 'Tahoma';
    lbViewPainelAliados.Font.Style := [];
    lbViewPainelAliados.ParentFont := False;
    lbViewPainelAliados.HeightPercent := 100.000000000000000000;
    lbViewPainelAliados.WidthPercent := 100.000000000000000000;
    lbViewPainelAliados.Caption := 'Painel de Aliados';
    relatorios.SetParentComponent(Self);
    relatorios.Name := 'relatorios';
    relatorios.Left := 132;
    relatorios.Top := 689;
    relatorios.Width := 92;
    relatorios.Height := 20;
    relatorios.ChildOrder := 95;
    relatorios.Role := '';
    SetEvent(relatorios, Self, 'OnClick', 'relatoriosClick');
    lbViewRelatorios.SetParentComponent(relatorios);
    lbViewRelatorios.Name := 'lbViewRelatorios';
    lbViewRelatorios.Left := 25;
    lbViewRelatorios.Top := 3;
    lbViewRelatorios.Width := 48;
    lbViewRelatorios.Height := 13;
    lbViewRelatorios.Font.Charset := DEFAULT_CHARSET;
    lbViewRelatorios.Font.Color := clWindowText;
    lbViewRelatorios.Font.Height := -11;
    lbViewRelatorios.Font.Name := 'Tahoma';
    lbViewRelatorios.Font.Style := [];
    lbViewRelatorios.ParentFont := False;
    lbViewRelatorios.HeightPercent := 100.000000000000000000;
    lbViewRelatorios.WidthPercent := 100.000000000000000000;
    lbViewRelatorios.Caption := 'Relat'#243'rios';
    compras.SetParentComponent(Self);
    compras.Name := 'compras';
    compras.Left := 134;
    compras.Top := 715;
    compras.Width := 100;
    compras.Height := 20;
    compras.ChildOrder := 95;
    compras.Role := '';
    SetEvent(compras, Self, 'OnClick', 'comprasClick');
    lbViewCompras.SetParentComponent(compras);
    lbViewCompras.Name := 'lbViewCompras';
    lbViewCompras.Left := 32;
    lbViewCompras.Top := 4;
    lbViewCompras.Width := 42;
    lbViewCompras.Height := 13;
    lbViewCompras.HeightPercent := 100.000000000000000000;
    lbViewCompras.WidthPercent := 100.000000000000000000;
    lbViewCompras.Caption := 'Compras';
    usuarios.SetParentComponent(Self);
    usuarios.Name := 'usuarios';
    usuarios.Left := 8;
    usuarios.Top := 672;
    usuarios.Width := 104;
    usuarios.Height := 20;
    usuarios.ChildOrder := 95;
    usuarios.Role := '';
    SetEvent(usuarios, Self, 'OnClick', 'usuariosClick');
    lbViewUsuarios.SetParentComponent(usuarios);
    lbViewUsuarios.Name := 'lbViewUsuarios';
    lbViewUsuarios.Left := 34;
    lbViewUsuarios.Top := 7;
    lbViewUsuarios.Width := 41;
    lbViewUsuarios.Height := 13;
    lbViewUsuarios.HeightPercent := 100.000000000000000000;
    lbViewUsuarios.WidthPercent := 100.000000000000000000;
    lbViewUsuarios.Caption := 'Usu'#225'rios';
    menu_produtos.SetParentComponent(Self);
    menu_produtos.Name := 'menu_produtos';
    menu_produtos.Left := 256;
    menu_produtos.Top := 526;
    menu_produtos.Width := 121;
    menu_produtos.Height := 216;
    menu_produtos.ChildOrder := 80;
    menu_produtos.Role := '';
    produtos.SetParentComponent(menu_produtos);
    produtos.Name := 'produtos';
    produtos.Left := 10;
    produtos.Top := 25;
    produtos.Width := 100;
    produtos.Height := 20;
    produtos.ChildOrder := 95;
    produtos.Role := '';
    SetEvent(produtos, Self, 'OnClick', 'produtosClick');
    lbViewProdutos.SetParentComponent(produtos);
    lbViewProdutos.Name := 'lbViewProdutos';
    lbViewProdutos.Left := 29;
    lbViewProdutos.Top := 4;
    lbViewProdutos.Width := 43;
    lbViewProdutos.Height := 13;
    lbViewProdutos.HeightPercent := 100.000000000000000000;
    lbViewProdutos.WidthPercent := 100.000000000000000000;
    lbViewProdutos.Caption := 'Produtos';
    grupos.SetParentComponent(menu_produtos);
    grupos.Name := 'grupos';
    grupos.Left := 10;
    grupos.Top := 71;
    grupos.Width := 100;
    grupos.Height := 20;
    grupos.ChildOrder := 95;
    grupos.Role := '';
    SetEvent(grupos, Self, 'OnClick', 'gruposClick');
    lbViewGrupos.SetParentComponent(grupos);
    lbViewGrupos.Name := 'lbViewGrupos';
    lbViewGrupos.Left := 34;
    lbViewGrupos.Top := 4;
    lbViewGrupos.Width := 34;
    lbViewGrupos.Height := 13;
    lbViewGrupos.HeightPercent := 100.000000000000000000;
    lbViewGrupos.WidthPercent := 100.000000000000000000;
    lbViewGrupos.Caption := 'Grupos';
    unidades.SetParentComponent(menu_produtos);
    unidades.Name := 'unidades';
    unidades.Left := 10;
    unidades.Top := 48;
    unidades.Width := 100;
    unidades.Height := 20;
    unidades.ChildOrder := 95;
    unidades.Role := '';
    SetEvent(unidades, Self, 'OnClick', 'unidadesClick');
    lbViewUnidades.SetParentComponent(unidades);
    lbViewUnidades.Name := 'lbViewUnidades';
    lbViewUnidades.Left := 32;
    lbViewUnidades.Top := 4;
    lbViewUnidades.Width := 44;
    lbViewUnidades.Height := 13;
    lbViewUnidades.HeightPercent := 100.000000000000000000;
    lbViewUnidades.WidthPercent := 100.000000000000000000;
    lbViewUnidades.Caption := 'Unidades';
    subgrupos.SetParentComponent(menu_produtos);
    subgrupos.Name := 'subgrupos';
    subgrupos.Left := 10;
    subgrupos.Top := 93;
    subgrupos.Width := 100;
    subgrupos.Height := 20;
    subgrupos.ChildOrder := 95;
    subgrupos.Role := '';
    SetEvent(subgrupos, Self, 'OnClick', 'subgruposClick');
    lbViewSubgrupos.SetParentComponent(subgrupos);
    lbViewSubgrupos.Name := 'lbViewSubgrupos';
    lbViewSubgrupos.Left := 24;
    lbViewSubgrupos.Top := 4;
    lbViewSubgrupos.Width := 52;
    lbViewSubgrupos.Height := 13;
    lbViewSubgrupos.HeightPercent := 100.000000000000000000;
    lbViewSubgrupos.WidthPercent := 100.000000000000000000;
    lbViewSubgrupos.Caption := 'SubGrupos';
    menu_grades.SetParentComponent(menu_produtos);
    menu_grades.Name := 'menu_grades';
    menu_grades.Left := 4;
    menu_grades.Top := 115;
    menu_grades.Width := 113;
    menu_grades.Height := 95;
    menu_grades.ChildOrder := 80;
    menu_grades.Role := '';
    grade_produtos.SetParentComponent(menu_grades);
    grade_produtos.Name := 'grade_produtos';
    grade_produtos.Left := 6;
    grade_produtos.Top := 2;
    grade_produtos.Width := 100;
    grade_produtos.Height := 20;
    grade_produtos.ChildOrder := 95;
    grade_produtos.Role := '';
    SetEvent(grade_produtos, Self, 'OnClick', 'grade_produtosClick');
    lbViewGrade_Produtos.SetParentComponent(grade_produtos);
    lbViewGrade_Produtos.Name := 'lbViewGrade_Produtos';
    lbViewGrade_Produtos.Left := 39;
    lbViewGrade_Produtos.Top := 4;
    lbViewGrade_Produtos.Width := 29;
    lbViewGrade_Produtos.Height := 13;
    lbViewGrade_Produtos.HeightPercent := 100.000000000000000000;
    lbViewGrade_Produtos.WidthPercent := 100.000000000000000000;
    lbViewGrade_Produtos.Caption := 'Grade';
    grade_descricoes.SetParentComponent(menu_grades);
    grade_descricoes.Name := 'grade_descricoes';
    grade_descricoes.Left := 6;
    grade_descricoes.Top := 25;
    grade_descricoes.Width := 100;
    grade_descricoes.Height := 20;
    grade_descricoes.ChildOrder := 95;
    grade_descricoes.Role := '';
    SetEvent(grade_descricoes, Self, 'OnClick', 'grade_descricoesClick');
    lbViewGrade_Descricoes.SetParentComponent(grade_descricoes);
    lbViewGrade_Descricoes.Name := 'lbViewGrade_Descricoes';
    lbViewGrade_Descricoes.Left := 33;
    lbViewGrade_Descricoes.Top := 4;
    lbViewGrade_Descricoes.Width := 51;
    lbViewGrade_Descricoes.Height := 13;
    lbViewGrade_Descricoes.HeightPercent := 100.000000000000000000;
    lbViewGrade_Descricoes.WidthPercent := 100.000000000000000000;
    lbViewGrade_Descricoes.Caption := 'Descri'#231#245'es';
    grade_colunas.SetParentComponent(menu_grades);
    grade_colunas.Name := 'grade_colunas';
    grade_colunas.Left := 6;
    grade_colunas.Top := 71;
    grade_colunas.Width := 100;
    grade_colunas.Height := 20;
    grade_colunas.ChildOrder := 95;
    grade_colunas.Role := '';
    SetEvent(grade_colunas, Self, 'OnClick', 'grade_colunasClick');
    lbViewGrade_Colunas.SetParentComponent(grade_colunas);
    lbViewGrade_Colunas.Name := 'lbViewGrade_Colunas';
    lbViewGrade_Colunas.Left := 38;
    lbViewGrade_Colunas.Top := 4;
    lbViewGrade_Colunas.Width := 38;
    lbViewGrade_Colunas.Height := 13;
    lbViewGrade_Colunas.HeightPercent := 100.000000000000000000;
    lbViewGrade_Colunas.WidthPercent := 100.000000000000000000;
    lbViewGrade_Colunas.Caption := 'Colunas';
    grade_linhas.SetParentComponent(menu_grades);
    grade_linhas.Name := 'grade_linhas';
    grade_linhas.Left := 6;
    grade_linhas.Top := 48;
    grade_linhas.Width := 100;
    grade_linhas.Height := 20;
    grade_linhas.ChildOrder := 95;
    grade_linhas.Role := '';
    SetEvent(grade_linhas, Self, 'OnClick', 'grade_linhasClick');
    lbViewGrade_Linhas.SetParentComponent(grade_linhas);
    lbViewGrade_Linhas.Name := 'lbViewGrade_Linhas';
    lbViewGrade_Linhas.Left := 38;
    lbViewGrade_Linhas.Top := 4;
    lbViewGrade_Linhas.Width := 30;
    lbViewGrade_Linhas.Height := 13;
    lbViewGrade_Linhas.HeightPercent := 100.000000000000000000;
    lbViewGrade_Linhas.WidthPercent := 100.000000000000000000;
    lbViewGrade_Linhas.Caption := 'Linhas';
    cdsDataBase.SetParentComponent(Self);
    cdsDataBase.Name := 'cdsDataBase';
    cdsDataBase.AfterOpen := cdsDataBaseAfterOpen;
    cdsDataBase.EntitySetName := 'data_base';
    cdsDataBase.Connection := DMConnection.ApiConnection;
    cdsDataBase.QueryTop := 124;
    cdsDataBase.Left := 648;
    cdsDataBase.Top := 273;
    cdsDataBaseid.SetParentComponent(cdsDataBase);
    cdsDataBaseid.Name := 'cdsDataBaseid';
    cdsDataBaseid.FieldName := 'id';
    cdsDataBaseid.Required := True;
    cdsDataBasenome_fantasia.SetParentComponent(cdsDataBase);
    cdsDataBasenome_fantasia.Name := 'cdsDataBasenome_fantasia';
    cdsDataBasenome_fantasia.FieldName := 'nome_fantasia';
    cdsDataBasenome_fantasia.Size := 255;
    cdsDataBaseassociar_produtos.SetParentComponent(cdsDataBase);
    cdsDataBaseassociar_produtos.Name := 'cdsDataBaseassociar_produtos';
    cdsDataBaseassociar_produtos.FieldName := 'associar_produtos';
    dwcGetUsuario.SetParentComponent(Self);
    dwcGetUsuario.Name := 'dwcGetUsuario';
    dwcGetUsuario.Connection := DMConnection.ApiConnection;
    SetEvent(dwcGetUsuario, Self, 'OnLoad', 'dwcGetUsuarioLoad');
    dwcGetUsuario.Left := 776;
    dwcGetUsuario.Top := 273;
    cdsUsuarios.SetParentComponent(Self);
    cdsUsuarios.Name := 'cdsUsuarios';
    cdsUsuarios.AfterApplyUpdates := cdsUsuariosAfterApplyUpdates;
    cdsUsuarios.AfterOpen := cdsUsuariosAfterOpen;
    cdsUsuarios.EntitySetName := 'Usuarios_Gerenciamento';
    cdsUsuarios.Connection := DMConnection.ApiConnection;
    cdsUsuarios.Left := 712;
    cdsUsuarios.Top := 273;
    cdsUsuariosid.SetParentComponent(cdsUsuarios);
    cdsUsuariosid.Name := 'cdsUsuariosid';
    cdsUsuariosid.FieldName := 'id';
    cdsUsuariosid.Required := True;
    cdsUsuariosdata_base_id.SetParentComponent(cdsUsuarios);
    cdsUsuariosdata_base_id.Name := 'cdsUsuariosdata_base_id';
    cdsUsuariosdata_base_id.FieldName := 'data_base_id';
    cdsUsuariosaliado_id.SetParentComponent(cdsUsuarios);
    cdsUsuariosaliado_id.Name := 'cdsUsuariosaliado_id';
    cdsUsuariosaliado_id.FieldName := 'aliado_id';
    cdsUsuariosperfil.SetParentComponent(cdsUsuarios);
    cdsUsuariosperfil.Name := 'cdsUsuariosperfil';
    cdsUsuariosperfil.FieldName := 'perfil';
    cdsUsuariosperfil.Required := True;
    cdsUsuariosnome.SetParentComponent(cdsUsuarios);
    cdsUsuariosnome.Name := 'cdsUsuariosnome';
    cdsUsuariosnome.FieldName := 'nome';
    cdsUsuariosnome.Required := True;
    cdsUsuariosnome.Size := 255;
    cdsUsuariosperfil_acesso.SetParentComponent(cdsUsuarios);
    cdsUsuariosperfil_acesso.Name := 'cdsUsuariosperfil_acesso';
    cdsUsuariosperfil_acesso.FieldName := 'perfil_acesso';
    cdsUsuariosperfil_acesso.Size := 255;
    dwcGetDadosEmpresaLogado.SetParentComponent(Self);
    dwcGetDadosEmpresaLogado.Name := 'dwcGetDadosEmpresaLogado';
    dwcGetDadosEmpresaLogado.Connection := DMConnection.ApiConnection;
    SetEvent(dwcGetDadosEmpresaLogado, Self, 'OnLoad', 'dwcGetDadosEmpresaLogadoLoad');
    dwcGetDadosEmpresaLogado.Left := 584;
    dwcGetDadosEmpresaLogado.Top := 329;
    cdsLogsSistema.SetParentComponent(Self);
    cdsLogsSistema.Name := 'cdsLogsSistema';
    cdsLogsSistema.EntitySetName := 'Logs_Sistema';
    cdsLogsSistema.Connection := DMConnection.ApiConnection;
    cdsLogsSistema.Left := 576;
    cdsLogsSistema.Top := 273;
    cdsLogsSistemaaliado_id.SetParentComponent(cdsLogsSistema);
    cdsLogsSistemaaliado_id.Name := 'cdsLogsSistemaaliado_id';
    cdsLogsSistemaaliado_id.FieldName := 'aliado_id';
    cdsLogsSistematabela.SetParentComponent(cdsLogsSistema);
    cdsLogsSistematabela.Name := 'cdsLogsSistematabela';
    cdsLogsSistematabela.FieldName := 'tabela';
    cdsLogsSistematabela.Required := True;
    cdsLogsSistematabela.Size := 255;
    cdsLogsSistemaoperacao.SetParentComponent(cdsLogsSistema);
    cdsLogsSistemaoperacao.Name := 'cdsLogsSistemaoperacao';
    cdsLogsSistemaoperacao.FieldName := 'operacao';
    cdsLogsSistemaoperacao.Required := True;
    cdsLogsSistemaoperacao.Size := 255;
    cdsLogsSistemalog.SetParentComponent(cdsLogsSistema);
    cdsLogsSistemalog.Name := 'cdsLogsSistemalog';
    cdsLogsSistemalog.FieldName := 'log';
    cdsLogsSistemalog.Required := True;
    cdsLogsSistemalog.Size := 255;
    XDataWebClientPermissoes.SetParentComponent(Self);
    XDataWebClientPermissoes.Name := 'XDataWebClientPermissoes';
    XDataWebClientPermissoes.Connection := DMConnection.ApiConnection;
    XDataWebClientPermissoes.Left := 552;
    XDataWebClientPermissoes.Top := 409;
    tmrIniciarSistema.SetParentComponent(Self);
    tmrIniciarSistema.Name := 'tmrIniciarSistema';
    SetEvent(tmrIniciarSistema, Self, 'OnTimer', 'tmrIniciarSistemaTimer');
    tmrIniciarSistema.Left := 840;
    tmrIniciarSistema.Top := 480;
    cdsPersonalizacaoTabelas.SetParentComponent(Self);
    cdsPersonalizacaoTabelas.Name := 'cdsPersonalizacaoTabelas';
    cdsPersonalizacaoTabelas.AfterApplyUpdates := cdsPersonalizacaoTabelasAfterApplyUpdates;
    cdsPersonalizacaoTabelas.EntitySetName := 'Tabelas_Personalizacao';
    cdsPersonalizacaoTabelas.Connection := DMConnection.ApiConnection;
    cdsPersonalizacaoTabelas.Left := 720;
    cdsPersonalizacaoTabelas.Top := 353;
    cdsPersonalizacaoTabelasid.SetParentComponent(cdsPersonalizacaoTabelas);
    cdsPersonalizacaoTabelasid.Name := 'cdsPersonalizacaoTabelasid';
    cdsPersonalizacaoTabelasid.FieldName := 'id';
    cdsPersonalizacaoTabelasusuario_id.SetParentComponent(cdsPersonalizacaoTabelas);
    cdsPersonalizacaoTabelasusuario_id.Name := 'cdsPersonalizacaoTabelasusuario_id';
    cdsPersonalizacaoTabelasusuario_id.FieldName := 'usuario_id';
    cdsPersonalizacaoTabelasusuario_id.Required := True;
    cdsPersonalizacaoTabelastabela_frontend.SetParentComponent(cdsPersonalizacaoTabelas);
    cdsPersonalizacaoTabelastabela_frontend.Name := 'cdsPersonalizacaoTabelastabela_frontend';
    cdsPersonalizacaoTabelastabela_frontend.FieldName := 'tabela_frontend';
    cdsPersonalizacaoTabelastabela_frontend.Required := True;
    cdsPersonalizacaoTabelastabela_frontend.Size := 255;
    cdsPersonalizacaoTabelaspersonalizacao.SetParentComponent(cdsPersonalizacaoTabelas);
    cdsPersonalizacaoTabelaspersonalizacao.Name := 'cdsPersonalizacaoTabelaspersonalizacao';
    cdsPersonalizacaoTabelaspersonalizacao.FieldName := 'personalizacao';
    cdsPersonalizacaoTabelaspersonalizacao.Required := True;
    cdsPersonalizacaoTabelaspersonalizacao.Size := 255;
  finally
    WebLinkLabel6.AfterLoadDFMValues;
    lbUsername.AfterLoadDFMValues;
    lblLogo.AfterLoadDFMValues;
    lblEmpresalogin.AfterLoadDFMValues;
    aliado_logado.AfterLoadDFMValues;
    lbMeuperfil.AfterLoadDFMValues;
    WebPanel1.AfterLoadDFMValues;
    div_bancos_usuario.AfterLoadDFMValues;
    cbbDataBase.AfterLoadDFMValues;
    div_empresa_login.AfterLoadDFMValues;
    div_aliado_login.AfterLoadDFMValues;
    aliado_conectado_topo.AfterLoadDFMValues;
    nome_aliado_conectado_topo.AfterLoadDFMValues;
    btnDesconectar.AfterLoadDFMValues;
    menu_nfse.AfterLoadDFMValues;
    provedores.AfterLoadDFMValues;
    lbViewProvedores.AfterLoadDFMValues;
    consulta_nfse.AfterLoadDFMValues;
    lbViewConsultaNfse.AfterLoadDFMValues;
    home.AfterLoadDFMValues;
    lbViewHome.AfterLoadDFMValues;
    aliado.AfterLoadDFMValues;
    lbViewAliado.AfterLoadDFMValues;
    logs_sistema.AfterLoadDFMValues;
    lbViewLogs_Sistema.AfterLoadDFMValues;
    menu_scripts.AfterLoadDFMValues;
    scripts.AfterLoadDFMValues;
    lbViewScripts.AfterLoadDFMValues;
    scripts_aliados.AfterLoadDFMValues;
    lbViewScripts_Aliados.AfterLoadDFMValues;
    versoes.AfterLoadDFMValues;
    lbViewVersoes.AfterLoadDFMValues;
    menu_apis_externas.AfterLoadDFMValues;
    api_veiculos.AfterLoadDFMValues;
    lbViewApi_Veiculos.AfterLoadDFMValues;
    api_cpfs.AfterLoadDFMValues;
    lbViewApi_Cpfs.AfterLoadDFMValues;
    menu_fs_produtos.AfterLoadDFMValues;
    fs_prod_produtos.AfterLoadDFMValues;
    lbViewFs_Prod_Produtos.AfterLoadDFMValues;
    fs_prod_marcas.AfterLoadDFMValues;
    lbViewFs_Prod_Marcas.AfterLoadDFMValues;
    fs_prod_fabricantes.AfterLoadDFMValues;
    lbViewFs_Prod_Fabricantes.AfterLoadDFMValues;
    fs_prod_categorias.AfterLoadDFMValues;
    lbViewFs_Prod_Categorias.AfterLoadDFMValues;
    fs_prod_subcategorias.AfterLoadDFMValues;
    lbViewFs_Prod_SubCategorias.AfterLoadDFMValues;
    fs_prod_departamentos.AfterLoadDFMValues;
    lbViewFs_Prod_Departamentos.AfterLoadDFMValues;
    fs_prod_subdepartamentos.AfterLoadDFMValues;
    lbViewFs_Prod_SubDepartamentos.AfterLoadDFMValues;
    fs_prod_caracteristicas.AfterLoadDFMValues;
    lbViewFs_Prod_Caracteristicas.AfterLoadDFMValues;
    menu_facil_planos.AfterLoadDFMValues;
    facil_planos.AfterLoadDFMValues;
    lbViewFacil_Planos.AfterLoadDFMValues;
    facil_planos_aliados.AfterLoadDFMValues;
    lbViewPlanos_Aliados.AfterLoadDFMValues;
    boletos.AfterLoadDFMValues;
    lbViewBoletos.AfterLoadDFMValues;
    lancamentos.AfterLoadDFMValues;
    lbViewLancamentos.AfterLoadDFMValues;
    menu_recebimentos.AfterLoadDFMValues;
    areceber.AfterLoadDFMValues;
    lbViewAreceber.AfterLoadDFMValues;
    recebimentos.AfterLoadDFMValues;
    lbViewRecebimentos.AfterLoadDFMValues;
    menu_pagamentos.AfterLoadDFMValues;
    apagar.AfterLoadDFMValues;
    lbViewApagar.AfterLoadDFMValues;
    pagamentos.AfterLoadDFMValues;
    lbViewPagamentos.AfterLoadDFMValues;
    menu_localidades.AfterLoadDFMValues;
    cidade.AfterLoadDFMValues;
    lbViewCidade.AfterLoadDFMValues;
    ufs.AfterLoadDFMValues;
    lbViewUF.AfterLoadDFMValues;
    menu_sincronizacao.AfterLoadDFMValues;
    sincronizacao_service.AfterLoadDFMValues;
    lbViewSincronizacao_Service.AfterLoadDFMValues;
    erros_catalogados.AfterLoadDFMValues;
    lbViewErros_Catalogados.AfterLoadDFMValues;
    sincronizacao_servidor_retaguarda.AfterLoadDFMValues;
    lbViewSincronizacao_Servidor_Retaguarda.AfterLoadDFMValues;
    menu_tributacoes.AfterLoadDFMValues;
    ncm.AfterLoadDFMValues;
    lbViewNcm.AfterLoadDFMValues;
    cfop.AfterLoadDFMValues;
    lbViewCfop.AfterLoadDFMValues;
    menu_reforma_tributaria.AfterLoadDFMValues;
    rt_ibs_cbs_cst.AfterLoadDFMValues;
    lbViewRt_Ibs_Cbs_Cst.AfterLoadDFMValues;
    rt_is_cst.AfterLoadDFMValues;
    lbViewRt_Is_Cst.AfterLoadDFMValues;
    rt_credito_presumido.AfterLoadDFMValues;
    lbViewRt_Credito_Presumido.AfterLoadDFMValues;
    cfop_configuracoes.AfterLoadDFMValues;
    lbViewCfop_Configuracoes.AfterLoadDFMValues;
    cst.AfterLoadDFMValues;
    lbViewCst.AfterLoadDFMValues;
    cst_pis.AfterLoadDFMValues;
    lbViewCst_Pis.AfterLoadDFMValues;
    cst_cofins.AfterLoadDFMValues;
    lbViewCst_Cofins.AfterLoadDFMValues;
    cst_ipi.AfterLoadDFMValues;
    lbViewCst_Ipi.AfterLoadDFMValues;
    codigo_bc_piscofins.AfterLoadDFMValues;
    lbViewCodigo_bc_Piscofins.AfterLoadDFMValues;
    origem_csosn.AfterLoadDFMValues;
    lbViewOrigem_Csosn.AfterLoadDFMValues;
    codigo_credito_piscofins.AfterLoadDFMValues;
    lbViewCodigo_Credito_Piscofins.AfterLoadDFMValues;
    desoneracao_icms.AfterLoadDFMValues;
    lbViewDesoneracao_Icms.AfterLoadDFMValues;
    csosn.AfterLoadDFMValues;
    lbViewCsosn.AfterLoadDFMValues;
    servicos_nacional.AfterLoadDFMValues;
    lbViewServicos_Nacional.AfterLoadDFMValues;
    nbs.AfterLoadDFMValues;
    lbViewNbs.AfterLoadDFMValues;
    menu_cadastros.AfterLoadDFMValues;
    promocoes.AfterLoadDFMValues;
    lbViewPromocoes.AfterLoadDFMValues;
    funcionarios.AfterLoadDFMValues;
    lbViewFuncionarios.AfterLoadDFMValues;
    clientes.AfterLoadDFMValues;
    lbViewClientes.AfterLoadDFMValues;
    modalidades.AfterLoadDFMValues;
    lbViewModalidades.AfterLoadDFMValues;
    aliquotas.AfterLoadDFMValues;
    lbViewAliquotas.AfterLoadDFMValues;
    parceiros.AfterLoadDFMValues;
    lbViewParceiros.AfterLoadDFMValues;
    contas.AfterLoadDFMValues;
    lbViewContas.AfterLoadDFMValues;
    bancos.AfterLoadDFMValues;
    lbViewBancos.AfterLoadDFMValues;
    banco_carteiras.AfterLoadDFMValues;
    lbViewBanco_Carteiras.AfterLoadDFMValues;
    operadoras_cartao.AfterLoadDFMValues;
    lbViewOperadoras_Cartao.AfterLoadDFMValues;
    contadores.AfterLoadDFMValues;
    lbViewContadores.AfterLoadDFMValues;
    fornecedores.AfterLoadDFMValues;
    lbViewFornecedores.AfterLoadDFMValues;
    tipos.AfterLoadDFMValues;
    lbViewTipos.AfterLoadDFMValues;
    modulos.AfterLoadDFMValues;
    lbViewModulos.AfterLoadDFMValues;
    pdvs.AfterLoadDFMValues;
    lbViewPdvs.AfterLoadDFMValues;
    segmentos.AfterLoadDFMValues;
    lbViewSegmento.AfterLoadDFMValues;
    menu_plano_contas.AfterLoadDFMValues;
    plano_contas.AfterLoadDFMValues;
    lbViewPlano_Contas.AfterLoadDFMValues;
    plano_contas_contabil.AfterLoadDFMValues;
    lbViewPlano_Contas_Contabil.AfterLoadDFMValues;
    plano_contas2.AfterLoadDFMValues;
    lbViewPlano_Contas2.AfterLoadDFMValues;
    plano_contas1.AfterLoadDFMValues;
    lbViewPlano_Contas1.AfterLoadDFMValues;
    plano_contas3.AfterLoadDFMValues;
    lbViewPlano_Contas3.AfterLoadDFMValues;
    servicos.AfterLoadDFMValues;
    lbViewServicos.AfterLoadDFMValues;
    menu_vendas.AfterLoadDFMValues;
    vendas.AfterLoadDFMValues;
    lbViewVendas.AfterLoadDFMValues;
    vendas_servicos.AfterLoadDFMValues;
    lbViewVendasServicos.AfterLoadDFMValues;
    cupons.AfterLoadDFMValues;
    lbViewCupons.AfterLoadDFMValues;
    menu_documentos_fiscais.AfterLoadDFMValues;
    nfe.AfterLoadDFMValues;
    lbViewNfe.AfterLoadDFMValues;
    nfse.AfterLoadDFMValues;
    lbViewNfse.AfterLoadDFMValues;
    painel_aliados.AfterLoadDFMValues;
    lbViewPainelAliados.AfterLoadDFMValues;
    relatorios.AfterLoadDFMValues;
    lbViewRelatorios.AfterLoadDFMValues;
    compras.AfterLoadDFMValues;
    lbViewCompras.AfterLoadDFMValues;
    usuarios.AfterLoadDFMValues;
    lbViewUsuarios.AfterLoadDFMValues;
    menu_produtos.AfterLoadDFMValues;
    produtos.AfterLoadDFMValues;
    lbViewProdutos.AfterLoadDFMValues;
    grupos.AfterLoadDFMValues;
    lbViewGrupos.AfterLoadDFMValues;
    unidades.AfterLoadDFMValues;
    lbViewUnidades.AfterLoadDFMValues;
    subgrupos.AfterLoadDFMValues;
    lbViewSubgrupos.AfterLoadDFMValues;
    menu_grades.AfterLoadDFMValues;
    grade_produtos.AfterLoadDFMValues;
    lbViewGrade_Produtos.AfterLoadDFMValues;
    grade_descricoes.AfterLoadDFMValues;
    lbViewGrade_Descricoes.AfterLoadDFMValues;
    grade_colunas.AfterLoadDFMValues;
    lbViewGrade_Colunas.AfterLoadDFMValues;
    grade_linhas.AfterLoadDFMValues;
    lbViewGrade_Linhas.AfterLoadDFMValues;
    cdsDataBase.AfterLoadDFMValues;
    cdsDataBaseid.AfterLoadDFMValues;
    cdsDataBasenome_fantasia.AfterLoadDFMValues;
    cdsDataBaseassociar_produtos.AfterLoadDFMValues;
    dwcGetUsuario.AfterLoadDFMValues;
    cdsUsuarios.AfterLoadDFMValues;
    cdsUsuariosid.AfterLoadDFMValues;
    cdsUsuariosdata_base_id.AfterLoadDFMValues;
    cdsUsuariosaliado_id.AfterLoadDFMValues;
    cdsUsuariosperfil.AfterLoadDFMValues;
    cdsUsuariosnome.AfterLoadDFMValues;
    cdsUsuariosperfil_acesso.AfterLoadDFMValues;
    dwcGetDadosEmpresaLogado.AfterLoadDFMValues;
    cdsLogsSistema.AfterLoadDFMValues;
    cdsLogsSistemaaliado_id.AfterLoadDFMValues;
    cdsLogsSistematabela.AfterLoadDFMValues;
    cdsLogsSistemaoperacao.AfterLoadDFMValues;
    cdsLogsSistemalog.AfterLoadDFMValues;
    XDataWebClientPermissoes.AfterLoadDFMValues;
    tmrIniciarSistema.AfterLoadDFMValues;
    cdsPersonalizacaoTabelas.AfterLoadDFMValues;
    cdsPersonalizacaoTabelasid.AfterLoadDFMValues;
    cdsPersonalizacaoTabelasusuario_id.AfterLoadDFMValues;
    cdsPersonalizacaoTabelastabela_frontend.AfterLoadDFMValues;
    cdsPersonalizacaoTabelaspersonalizacao.AfterLoadDFMValues;
  end;
end;

end.
